/* ===========================================================================
   MAISON — Custom Studio configurator           assets/custom-configurator.js
   ===========================================================================

   BLOCK 4 of the section, lifted out of sections/custom-configurator.liquid on
   25/09/2026 because the template crossed Shopify's 256 KB limit. Nothing was
   edited on the way out and nothing was deleted.

   It lifted out cleanly because it was built to: there is not one Liquid tag
   in this file, and there can never be one. Every value comes from the JSON
   island the section writes in BLOCK 1 and is read here with JSON.parse, which
   is exactly why the split cost nothing. Anything this script needs from
   Liquid goes into that island and comes out of CFG; `| t` will not run here.

   Loaded with defer, so it runs after the section's markup is parsed. The
   whole file is one IIFE that initialises per section, so two configurators on
   a page never share state, and it listens for shopify:section:load so the
   Theme Editor keeps working.

   ES5 on purpose — no build step, no transpiler, nothing to go stale.
   =========================================================================== */

(function(){
  'use strict';

  /* ══════════════════════════════════════════════════════════════════════
     STRINGS — there are none in this file.

     Every customer-facing word is a locale key under
     maison.custom_configurator.*, read with `| t` in BLOCK 1 and handed over
     in CFG.i18n. There is deliberately NO fallback: a key that is not in the
     locale file renders as Shopify's own "Translation missing: it.maison…",
     which is loud, greppable and obviously wrong. A fallback would hide
     exactly the thing you need to see while filling the files in.

     Nothing below builds a sentence by concatenation except through t(), so
     no string is stranded in the logic.
     ══════════════════════════════════════════════════════════════════════ */
  /* IT MUST NEVER THROW, and that is not a style preference — it is the
     difference between one missing word and a dead page. 28/09/2026: a key
     added to this file but not yet to the section arrived here as undefined,
     `undefined.replace` threw inside go(), and the WHOLE configurator stopped
     on the first filter change. The three files deploy separately, so that
     skew is a normal state to be in for a few seconds, not an exotic one.

     A missing key still shows itself — every key that IS in the island and
     not in the locale file prints Shopify's own "Translation missing: …", as
     designed. This only covers the key that is not in the island at all,
     which is a deploy question rather than a translation one. */
  function t(s, vars){
    if(s == null) return '';
    s = String(s);
    if(!vars) return s;
    return s.replace(/\{(\w+)\}/g, function(_, k){ return vars[k] != null ? vars[k] : ''; });
  }

  /* ONE OR MANY. `{n} characters left` reads "1 characters left" at the end
     of a word, and English is the easy case — Italian, French, German and
     Spanish all inflect the noun, and several languages have more than two
     forms. So every string whose {n} sits beside a NOUN gets a singular twin,
     and this picks between them.

     SHOPIFY'S OWN one/other PLURALISATION CANNOT DO THIS, which is why it is
     not used. `| t: count: n` resolves in LIQUID, at render time, and the
     island is rendered once per page while these counts are computed in the
     browser and change as you type. The count simply is not known when the
     string is made.

     A missing singular falls back to the plural rather than printing nothing:
     that is the DEPLOY-SKEW case — this file live, the section not yet — and
     the wrong plural beats an empty label. A singular that is in the island
     but missing from a locale file still prints Shopify's own "Translation
     missing", because BLOCK 1 writes the key either way.

     Only for a {n} beside a noun. A figure with a unit after it — "7 cm",
     "2 cm" — needs none, and neither does a count in brackets. */
  function tN(many, one, n, vars){
    vars = vars || {};
    vars.n = n;
    return t((n === 1 && one) ? one : many, vars);
  }

  /* ─── THE SAME SUBSTITUTION, BUT AS NODES ───
     t() returns a STRING, and every string in this file is written with
     textContent — which is exactly why none of them can carry markup, and
     why that is a feature rather than a limitation. The locale values come
     through Shopify's `t` filter, which HTML-escapes; unescapeEntities()
     undoes that on the way in, and textContent puts the characters on screen
     without ever parsing them. Nothing in this file has an innerHTML path
     for a translated string and nothing should gain one.

     So when a placeholder has to be WRAPPED — a size in its own span so it
     can be set apart from the sentence around it — the answer is not to put
     a tag in the locale file. It is to substitute an ELEMENT instead of a
     string, which is what this does: it walks the same {name} pattern t()
     walks and builds a fragment of text nodes and spans.

     A var may be either:
       'L'                          a plain value, as before
       { text:'L', cls:'mcfg__x' }  a value in a <span class="mcfg__x">

     Both forms are accepted everywhere, so a placeholder can be given a
     class later without touching anything but the call site. A var that is
     null or missing prints nothing, exactly as t() does — so a translation
     that drops a placeholder still reads, and one that adds an unknown one
     leaves no residue.

     THE LOCALE FILE STAYS PLAIN TEXT. A translator writes "{v}" and never
     sees a class name, which is the whole point: markup is a decision about
     this page, not about the sentence. */
  function tNodes(s, vars){
    var frag = document.createDocumentFragment();
    if(s == null) return frag;
    s = String(s);
    var re = /\{(\w+)\}/g, last = 0, m;
    while((m = re.exec(s)) !== null){
      if(m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));
      var v = vars ? vars[m[1]] : null;
      if(v != null){
        if(typeof v === 'object' && v.cls != null){
          frag.appendChild(el('span', v.cls, v.text == null ? '' : String(v.text)));
        } else {
          frag.appendChild(document.createTextNode(String(v)));
        }
      }
      last = re.lastIndex;
    }
    if(last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
    return frag;
  }

  /* ─────────── the entity net ───────────
     Shopify's `t` filter HTML-ESCAPES what it returns. On a normal page that
     is invisible, because the value lands in HTML and the browser decodes it
     on the way in. Here it does not: BLOCK 1 sends it through | json into the
     JSON island, JSON.parse hands back the literal characters, and every
     string is written with textContent — which escapes nothing and decodes
     nothing. So an apostrophe typed in a locale file reached the screen as
     &#39;, and an ampersand as &amp;.

     Fixed here rather than in BLOCK 1, because a Liquid replace chain would
     have to be repeated on all 57 keys and would be forgotten on the 58th.

     An explicit table, not a detached element's innerHTML: these five are
     exactly what Shopify emits, the mapping is deterministic, and no HTML is
     ever parsed. &amp; is decoded LAST, so "&amp;lt;" survives as "&lt;"
     rather than collapsing into "<". */
  var ENTITIES = [
    [/&#0*39;/g,   "'"], [/&apos;/g, "'"],
    [/&quot;/g,    '"'],
    [/&lt;/g,      '<'],
    [/&gt;/g,      '>'],
    [/&amp;/g,     '&']            /* last, always */
  ];
  function unescapeEntities(v){
    if(typeof v === 'string'){
      for(var i = 0; i < ENTITIES.length; i++) v = v.replace(ENTITIES[i][0], ENTITIES[i][1]);
      return v;
    }
    if(v && typeof v === 'object'){
      for(var k in v) if(Object.prototype.hasOwnProperty.call(v, k)) v[k] = unescapeEntities(v[k]);
    }
    return v;
  }

  /* Order of the tiers in the panel. Independent of the order Shopify happens
     to return the variants in. */
  var TIER_ORDER = ['COL','ADJ','STG','DIM'];
  /* Order of the steps. This array IS the flow — reorder it and the flow
     reorders, which is what the prototype's arrows were demonstrating.

     MEASUREMENTS COME FIRST, before the customer is asked what they want to
     change, and that order is the whole point. Asked first, people answer with
     the size they believe they wear: somebody who is a 4XL asks to change the
     colour of an XL, and every step after that is built on a wrong number.
     Asked second, the question is no longer "what do you want" but "here is
     your size — now, what do you want", and the options offered are only the
     ones that exist for it. A size that is not in the catalogue never reaches
     the question at all; it goes straight to New size. */
  var STEP_ORDER = ['prod','meas','tier','size','fit','dim','color','pers','req'];
  /* The measurements, in two rounds.

     Round one — asked of everybody, before anything else — is whichever body
     measurement this garment is graded on (chest for a sweater, hips for a
     pair of joggers), plus height and weight. Those three resolve the size.

     Round two is asked once the path is known, and only then. Two keys, and
     both are FINISHED GARMENT MEASUREMENTS in centimetres — the length to
     make the piece, not a difference from ours and not a measurement of the
     customer's body. Nothing here is calculated from a person.

     THEY WERE DIFFERENCES until 25/09/2026, and the change is worth knowing
     about because the argument for a delta sounded good and was wrong twice.

     It was wrong for the customer, who was being asked to do arithmetic in a
     form box: read our figure, measure their own garment, subtract, and type
     the remainder with the right sign. Nothing on the form said the number
     was a difference, so somebody who measured a sleeve at 62cm and typed 62
     asked for a sleeve 62cm LONGER than ours, and nothing downstream could
     tell that from a deliberate request.

     It was wrong mechanically too. A negative number could not be typed AT
     ALL: go(true) rebuilds the step body on every keystroke, and assigning
     "-" to an <input type=number> is invalid, so the browser blanked it. The
     minus was erased the instant it was typed. The whole "shorter" half of
     the question was unreachable, which no amount of labelling would have
     fixed.

     And the reason for a delta did not survive either. It was supposed to be
     robust to HOW the tape was held — three centimetres longer is three
     centimetres longer wherever it started — but that only holds if the
     customer measured their own garment the way we measure ours. Measured
     from the shoulder seam instead of the nape, their figure is 13cm out, and
     so is the difference they computed from it. The convention has to be
     stated either way; stating it and asking for the number outright is the
     same risk with none of the arithmetic.

       sleeveLen    The CENTRE BACK NECK TO CUFF length — nape, over the
                    shoulder, down to the cuff — which on our side is
                    shoulders/2 + sleeves out of the product's own chart.

                    That route and no other, because it is the only one that
                    means the same thing on every cut. Across 124 products the
                    sum is stable to about a centimetre between Slim, Regular,
                    Tailored and Loose while the sleeve alone moves 3.6cm: the
                    fit profile only decides how the arm is SPLIT between
                    shoulder and sleeve, and a dropped shoulder shortens the
                    sleeve by exactly what it adds to the yoke.

                    Measured from the seam instead, the same Donna L reads 60cm
                    on a set-in style and 47cm on MCW029 — 13cm apart on one
                    body, with nothing downstream able to tell that the
                    difference was not asked for.

                    So the composite is both what we SHOW as the standard and
                    what the customer's own number is measured the same way
                    as. Production reads the figure against the same route.

       bodyLen      The chart's `length`, measured from the HIGH POINT
                    SHOULDER to the hem on a top and the OUTSEAM on a bottom —
                    one key, two names, chosen by the axis the garment grades
                    on.

                    NEVER predicted from the body, and this is why the step
                    exists at all: where the hem sits is a STYLE. Same size,
                    same gender, different fit — Slim 62.4, Boxy 62.8,
                    Oversized 66.6, Regular 68.1, Tailored 70.2, Loose 75.1. A
                    13cm spread on one body, so no measurement of a person
                    could ever tell us which of those they wanted. Only they
                    can, and only by naming the length.

     BOTH ARE OPTIONAL and both default to our standard. An empty box is not
     an unanswered question: it is "make it the way you make it", which is the
     commonest answer and the one that needs no typing. That is why the
     standard is shown as the PLACEHOLDER rather than filled in — a filled box
     would travel to the next product in the URL and read there as a request
     nobody made, and fitEntries() would have to unpick it.

     Shoulders are NOT asked. The garment's shoulder comes from the chart,
     which is where it was all along. */
  var BODY_KEYS  = ['chest','hips'];
  var EXTRA_KEYS = ['weight','height'];
  var FIT_KEYS   = ['sleeveLen','bodyLen'];
  var MEAS_KEYS  = BODY_KEYS.concat(EXTRA_KEYS);
  var ALL_MEAS   = MEAS_KEYS.concat(FIT_KEYS);
  /* An accessory has no size and no chart. It has two numbers, and they are
     the finished piece's, not the customer's. */
  var DIM_KEYS   = ['length','width'];
  /* AND THEIR BOUNDS, absolute and generous — the same kind of range the fit
     pair carry, and for the same reason.

     They used to be [standard - limit, standard + limit], which made the box
     refuse anything past the house rule and CLAMPED whatever a URL put there.
     That reads as arithmetic: type 5 into a box whose floor is 173 and 173 is
     what you get, which looks like the figure was added to something.

     THE HOUSE LIMIT IS NOT THIS, and the two were confused for a day. These
     are the absolute sanity bounds — a width of 5cm, a length of 4 metres —
     and nothing reads them today. What the boxes are actually bounded by is
     the standard plus or minus the house limit, per product, and a figure
     outside THAT is clamped to it when the field is left. See numField's
     `clamp` and the dim branch of body(). */
  /* UNUSED SINCE 30/09/2026 and kept deliberately. The boxes are bounded by
     the standard plus or minus the house limit again — see the dim branch of
     body() — which is a narrower window than any of this and is the rule the
     customer is actually held to.

     It is left here as the absolute sanity range, the one a figure would
     have to fall inside whatever the standard happened to be, for the day
     somebody wants a bound that does not move with the product. Nothing
     reads it today; numField's own fallback is MEAS_RANGE. */
  var DIM_RANGE  = { length:[10,400], width:[5,200] };
  /* Personalisation, in the order the customer answers them. */
  var PERS_KEYS  = ['pos','font','color','text'];
  /* The example in the lettering box, substituted into the same "e.g." the
     measurement boxes use. Two letters, because the shortest option takes
     three characters. Change it here and nowhere else. */
  var PERS_EG    = 'MC';
  /* Bounds are CANONICAL — centimetres and kilograms — and so is everything
     else the configurator stores. See UNITS below. Round two is bounded the
     same way round one is: nothing here stops a wrong answer, but it stops an
     impossible one reaching production. */
  /* The fit pair are FINISHED GARMENT lengths now, not differences, so their
     bounds are absolute and generous: one key covers a cropped top and a pair
     of trousers, and nothing here is trying to be a size chart. They only
     have to stop an impossible number reaching production. */
  var MEAS_RANGE = { chest:[40,200], hips:[40,200], weight:[30,250], height:[120,220],
                     sleeveLen:[40,110], bodyLen:[30,130] };
  /* PRODUCTION TOLERANCE, and it is why no garment measurement is ever
     printed as a single number. Nothing comes off a knitting machine to the
     millimetre: the piece lands within about a centimetre of what was asked
     for. "73.3 cm" is therefore a precision we do not have and could not
     honour if we claimed it — and it is a figure nobody typed, since it falls
     out of shoulders/2 + sleeves.

     TWO NUMBERS, and they were one until 25/09/2026, which was wrong because
     they answer different questions.

     FIT_TOL is the PRODUCTION TOLERANCE — how far the finished piece may land
     from the figure asked for. It is what the terms line states, and it is
     also the threshold for "did they actually change anything": a request
     within the tolerance of our own standard is a request for a piece we
     cannot knit differently, so it is not an alteration and is not charged
     as one.

     FIT_BAND is how wide the printed STANDARD is, and it stays at one whole
     unit whatever the tolerance is. The band exists for a different reason —
     our standard is 73.25 and nobody should be shown that precision, so it is
     quoted as the whole-unit window it sits in, floor to floor+1. Widening it
     with the tolerance would print "77-81" for a figure we know to a quarter
     of a centimetre, which reads as vagueness about the garment rather than
     honesty about the machine.

     So: the band says what we make, the tolerance says how close we come.
     Change either without touching the other. */
  var FIT_TOL  = 2;
  var FIT_BAND = 1;

  /* ─────────── units ───────────
     The size ladder is in centimetres: max_body on every rung of
     custom.size_ranges is cm, resolveSize() compares against it in cm, and the
     number posted to the cart is what production cuts from. So CENTIMETRES ARE
     THE ONLY THING STORED. Inches are a display layer and nothing more — the
     conversion happens at the input, once, and never again. If a raw inch
     figure ever reached the cart somebody would be sent a garment cut to a
     41cm chest.

     Weight and height do not touch the resolver at all; they travel to
     production as context. That is exactly why height may be split into feet and
     inches when the switch is on inches: nobody says they are 69 inches tall,
     and two boxes cost the resolver nothing because it never reads this
     number. Both boxes write the same single centimetre value.

     The symbols are not translated. cm, in, kg and lb are written the same in
     every language this shop sells in, and putting them in the locale files
     would invite someone to "translate" them into something the arithmetic
     does not expect. */
  var UNIT_KIND = { chest:'len', hips:'len', height:'len', weight:'mass',
                    sleeveLen:'len', bodyLen:'len', length:'len', width:'len' };
  var LB_PER_KG = 2.2046226, CM_PER_IN = 2.54;
  function round1(n){ return Math.round(n * 10) / 10; }
  /* ─── READ A TYPED FIGURE ───
     02/10/2026, and it exists because the boxes are <input type=text> now —
     see numField(), which says why. A text box hands back exactly what was
     typed, and what gets typed is not always what parseFloat expects.

     A COMMA IS A DECIMAL POINT on an Italian, French, German or Spanish
     keyboard, and it is what those keyboards put on the numeric keypad. It
     was unreachable before in the worst possible way: <input type=number>
     treats "24,5" as invalid and blanks it, so on every storefront but the
     English one a decimal could not be entered AT ALL. parseFloat is no
     better on its own — parseFloat("24,5") is 24, which is not a refusal but
     a WRONG ANSWER, silently 0.5 short.

     So the separator is normalised here, in the one place every typed figure
     passes through, rather than at each of the four call sites.

     ONLY THE FIRST SEPARATOR, and anything after a second one is dropped by
     parseFloat as it always was. A thousands separator has no business in a
     box that holds a chest measurement.

     Everything else stays parseFloat's job, including returning NaN for a
     box with nothing useful in it — every caller already tests isFinite. */
  function num(v){
    if(typeof v === 'number') return v;
    return parseFloat(String(v == null ? '' : v).replace(',', '.'));
  }
  /* cm -> {ft,in} for display. The carry matters: 5'11.96" must show as 6'0",
     never as 5'12". */
  function ftFromCanonical(v){
    var n = parseFloat(v);
    if(!isFinite(n)) return { ft:'', inch:'' };
    var total = n / CM_PER_IN;
    var ft = Math.floor(total / 12), inch = round1(total - ft * 12);
    if(inch >= 12){ ft += 1; inch = 0; }
    return { ft:String(ft), inch:String(inch) };
  }
  /* {ft,in} -> cm. Either box alone is a real answer (6 ft, or 9 in while the
     feet are still being typed), so a blank one counts as zero; both blank is
     no answer at all. */
  function canonicalFromFt(ft, inch){
    var f = num(ft), i = num(inch);
    if(!isFinite(f) && !isFinite(i)) return '';
    return String(((isFinite(f) ? f : 0) * 12 + (isFinite(i) ? i : 0)) * CM_PER_IN);
  }

  /* The colour engine renders at this size and is blitted up to the display
     canvas. Matches the resolution the masks were baked at; raising it costs
     render time for no visible gain. */
  var W = 500, H = 625, N = W * H;

  function el(tag, cls, text){
    var e = document.createElement(tag);
    if(cls) e.className = cls;
    if(text != null) e.textContent = text;
    return e;
  }
  function uniq(a){ return a.filter(function(v,i){ return a.indexOf(v) === i; }); }

  /* ─── A BOX THAT SAYS WHEN THERE IS MORE ───
     02/10/2026. el()'s twin for the handful of boxes that scroll: it builds
     the theme's own <scroll-hint> instead of a <div>.

     WHAT IT BUYS. scroll.js upgrades the element and paints a mask on it —
     the end with content past it fades out, both ends when you are in the
     middle, neither when there is nothing to scroll. That is the whole
     feature: a list that stops at a hard edge reads as a list that has
     ended, and inside a panel held to one screenful it usually has not.

     THE ELEMENT IS THE SCROLLER. It reads its own scrollTop and
     clientHeight, so the tag belongs on the overflow box itself and not on
     a wrapper round it.

     IT COSTS NOTHING WHERE NOTHING SCROLLS. The mask is computed from
     scrollHeight - clientHeight; when that is zero the percentage is NaN and
     the element clears its own mask. So the same call is safe for a list
     that happens to be short, and there is no branch here deciding which
     instance will overflow.

     AND NOTHING DEPENDS ON IT. Where scroll.js has not been loaded the
     element is never upgraded: an unknown element is an inline box, which
     BLOCK 3 gives display:block, and the result is the <div> it replaced. */
  function scrollBox(cls){
    var e = document.createElement('scroll-hint');
    if(cls) e.className = cls;
    return e;
  }

  /* ─── THE STYLE'S OWN NAME ───
     Every made-to-order product is titled "<something> - <the style>", and
     the left-hand half is a label rather than a name: it says which programme
     the product belongs to, which the customer already knows, because they
     are standing in it. Repeated down a list of seventy-odd rows it is the
     only thing on screen and the actual garment is what moves.

     IT USED TO BE A LITERAL. `.replace('Custom Studio - ','')` worked exactly
     as long as that string was the prefix — and it is not any more: the
     programme was renamed, and the name is TRANSLATED, so the Italian, the
     French and the German storefronts each carry a different one. On every
     locale but the one the literal was written for it matched nothing and
     the prefix simply stayed on.

     So the SEPARATOR is the rule, not the words: everything up to and
     including the first " - " goes. That is locale-proof, survives the next
     rename, and needs nothing maintained.

     THE FIRST ONE ONLY, and a title with none is left exactly as it is —
     which is what keeps a style whose own name contains a dash intact.
     Checked against the live catalogue 30/09/2026: all 75 carry exactly one
     " - " and not one carries two, so nothing is at risk today. The day a
     style is named "Something - Else", this takes the wrong half; the fix
     then is to split on the first separator only if what precedes it is the
     programme, which needs a list of programme names and is not worth
     carrying until it is. */
  function styleName(title){
    var s = String(title == null ? '' : title);
    var i = s.indexOf(' - ');
    return (i < 0 ? s : s.slice(i + 3)).trim();
  }

  /* ══════════════════════════════════════════════════════════════════════
     ONE CONFIGURATOR
     ══════════════════════════════════════════════════════════════════════ */
  function init(root){
    if(root.getAttribute('data-mcfg-ready')) return;
    root.setAttribute('data-mcfg-ready','1');

    var island = root.querySelector('[data-mcfg-json]');
    if(!island) return;
    var CFG;
    try { CFG = JSON.parse(island.textContent); } catch(e){ return; }

    var UPLIFT = CFG.uplift;
    if(!UPLIFT || Array.isArray(UPLIFT)) UPLIFT = {};   /* PHP sends [] for "none" */
    var COLORS = CFG.colors || [];
    /* Straight from the island. The SHAPE is guaranteed by BLOCK 1, which
       writes every key whether the locale file has it or not, so nothing here
       has to defend against a missing branch — only against a missing
       translation, which is visible on screen by design. */
    var STR = unescapeEntities(CFG.i18n || {});

    /* DEFINED HERE, NOT BESIDE whoOf(), AND IT HAS TO BE. `function whoKey`
       hoists, but `var WHO_KEYS` hoists only its NAME — the array is still
       undefined until the line runs. The route-2 derivation calls whoKey a
       couple of hundred lines above where this used to sit, so WHO_KEYS.length
       threw on boot and took the whole configurator with it.

       So it lives immediately after STR, which is the only thing it reads and
       the earliest point at which it can. See whoOf() for what it is for. */
    var WHO_KEYS = ['Women','Men','Lifestyle','Unisex'];
    function whoKey(raw){
      var w = String(raw == null ? '' : raw).trim();
      if(!w) return '';
      var lc = w.toLowerCase();
      for(var i = 0; i < WHO_KEYS.length; i++){
        var k = WHO_KEYS[i];
        if(lc === k.toLowerCase()) return k;
        var t = STR.who && STR.who[k];
        if(t && lc === String(t).trim().toLowerCase()) return k;
      }
      return w;
    }

    var $ = function(sel){ return root.querySelector(sel); };
    /* THE BREAKPOINT — there is one, and this string is it. It has to agree
       with the NARROW block in the CSS to the pixel, because the two decide
       the same thing about the same screen: the stylesheet lays the section
       out and this file decides what to BUILD, and they cannot be allowed to
       disagree about which layout is on.

       It was 760 here and 1080 there, which is how the band between them came
       to be neither layout. Now it is one value, written once and read by
       both questions below. Asked fresh each time rather than cached, so a
       rotation gets the right answer. */
    var MQ_NARROW = '(max-width:1080px)';
    function narrow(){
      return !!(window.matchMedia && window.matchMedia(MQ_NARROW).matches);
    }
    /* The same answer today, and a different QUESTION: narrow() asks whether
       this is the phone treatment — the model list folds away, the tabs wrap —
       and oneCol() asks only whether the grid is stacked, which is what
       decides where the cart form is moved to. They were two breakpoints and
       are now one; both names stay, because the questions are still two and a
       future layout could part them again. */
    function oneCol(){ return narrow(); }

    /* ─────────── state ───────────
       Everything here survives a jump to another product, because it is what
       gets written into the link — and is checked against the new product on
       arrival, at the top of go(): a tier, a size or a category the garment
       you landed on does not offer is dropped rather than rendered broken. */
    var S = {
      route: 1, who: null, garment: null, tier: null, size: null, color: null,
      /* WAS THE SIZE CHOSEN, OR MERELY SUGGESTED — 01/10/2026, and keeping
         the two apart is the whole of a bug that charged for a size nobody
         picked.

         S.size is filled in twice over: the measurement resolves one and puts
         it in the picker, and the customer may click a different one. Those
         are not the same kind of answer, and until today nothing could tell
         them apart — so the preselect ran only `if(!S.size)`, which meant the
         FIRST value to land stuck for the rest of the visit.

         Type a 166 chest, get 3XL. Go back, type 90. The measurement now
         resolves to M, the step says "Recommended size: M", and the selected
         tile and the price are both still 3XL — a size the customer never
         chose, carrying its own uplift.

         So a SUGGESTION follows the measurement, every render, and a CHOICE
         does not. Clicking a tile is the only thing that sets this. */
      sizePicked: false,
      /* WHETHER THE VISITOR HAS TOUCHED THE FILTER DROPDOWNS ON THIS PAGE,
         which is not the same question as "is a filter set" and cannot be
         derived from who/garment — see the Modello step, which changes shape
         on it.

         S.who arrives set on most cold landings: route 2 derives it from the
         product so the model list opens on the right gender. That derivation
         is the page being helpful, not the visitor searching, and reading it
         as a search put every arrival into the flat result list instead of
         the pinned-plus-fold shape. Route 1's criteria come from the funnel
         and are the same kind of thing — chosen, but not here.

         So it is set in ONE place, the two change handlers below, and nowhere
         else. It does not travel in the URL: picking a model is a real page
         load onto a different garment, and pinning THAT garment is right. */
      searched: false,
      /* meas is ALWAYS cm/kg. typed is what is in the box, in whatever unit is
         showing — kept separately so that typing in inches does not lose a
         digit to a round trip through centimetres on every keystroke. */
      meas:  { chest:'', hips:'', weight:'', height:'',
               sleeveLen:'', bodyLen:'' },
      typed: { chest:'', hips:'', weight:'', height:'', heightFt:'', heightIn:'',
               sleeveLen:'', bodyLen:'' },
      /* An accessory's finished dimensions, in centimetres, with the same typed
         buffer for the same reason. These are ABSOLUTE — the length to cut to,
         not a delta — because that is the number the customer can picture and
         the number production works from. The limit is enforced against the
         standard, which is read off the product's own sentence. */
      dim:      { length:'', width:'' },
      typedDim: { length:'', width:'' },
      /* Ricamo or intarsio. Text is what they typed, verbatim; the other three
         are the keys the option offers. Nothing here is posted until there is
         TEXT — a font with nothing written on it is not personalisation. */
      /* `on` is the ANSWER TO THE QUESTION, and it is a real answer rather
         than a side effect of the text box being empty. It starts false — no
         personalisation is the normal case and nobody should have to decline
         something they never asked for — and saying yes is one click. */
      /* `on` is TRI-STATE, and the third state is the point: null means the
         question has not been answered yet, false means no, true means yes.

         It started at false, which read as "no" — so the step counted as
         answered before anybody had looked at it, and Add to bag was live on
         a piece nobody had finished configuring. Declining is a real answer
         and has to be given, not assumed. */
      pers: { on:null, text:'', font:'', color:'', pos:'' },
      /* Request form for a size we can't sell. Never written to the URL. */
      req: { name:'', email:'', note:'' },
      unit: 'cm',
      active: null, list: null, listErr: false,
      view: 'main'
    };

    var params = new URLSearchParams(window.location.search);
    var DEBUG  = params.get('debug') === '1';

    /* Canonicalised here too, so a link written before this change — or one
       built on a translated storefront by an older copy of this file — still
       resolves. whoKey() cannot run yet (STR is not read until below), so it
       is applied a few lines down instead. */
    S.who     = params.get('who')     || null;
    S.garment = params.get('garment') || null;
    S.tier    = params.get('tier')    || null;
    S.size    = params.get('size')    || null;
    /* THE PARAMETER'S PRESENCE IS THE FLAG, so there is no second one to
       carry, read or forget. linkTo() writes `size=` only for a size that was
       CHOSEN — a suggested one is left out, because it can be derived again
       from the measurements that are already in the link.

       Which is what makes a refresh behave: a chosen size comes back chosen,
       and a suggested one is re-suggested from the chest rather than frozen
       as somebody's first answer. */
    S.sizePicked = !!S.size;
    S.color   = params.get('col')     || null;
    ALL_MEAS.forEach(function(k){
      var v = params.get(k);
      if(v) S.meas[k] = v;
    });
    /* CLAMPED ONCE, HERE, and here only — a link can say anything and this
       is the one moment it arrives. It cannot be done in go(): that runs on
       every keystroke, and clamping per keystroke is exactly the bug the
       commit-time clamp in numField exists to avoid.

       dimStd() and houseLimit() are function declarations, so both are
       hoisted and callable at this point; CFG is already parsed. */
    DIM_KEYS.forEach(function(k){
      var v = params.get('dim_' + k);
      if(!v) return;
      var n = parseFloat(v), std = dimStd();
      if(std && isFinite(n)){
        var lo = std[k] - houseLimit(), hi = std[k] + houseLimit();
        if(n < lo) n = lo; else if(n > hi) n = hi;
        v = String(n);
      }
      S.dim[k] = v;
    });
    PERS_KEYS.forEach(function(k){
      var v = params.get('p_' + k);
      if(v) S.pers[k] = v;
    });
    /* Its own parameter, because it is an answer and the others are values.
       ABSENT IS NOT 'NO': it is "not asked yet", so the parameter has to be
       able to say 0 as well as 1 — otherwise a refresh on a line where the
       customer had declined would come back unanswered and disable the
       button they were about to press. */
    var pOn = params.get('p_on');
    S.pers.on = (pOn === '1') ? true : (pOn === '0' ? false : null);

    /* Inches for the United States, centimetres everywhere else, and whatever
       the visitor last chose beats both — u= travels in the URL like every
       other choice, so a refresh or a shared link keeps it. */
    function defaultUnit(){ return CFG.country === 'US' ? 'in' : 'cm'; }
    var uParam = params.get('u');
    S.unit = (uParam === 'in' || uParam === 'cm') ? uParam : defaultUnit();

    /* THE TOLERANCE IN WORDS, for the terms line: one figure and its unit,
       from FIT_TOL, so the sentence and the threshold that decides whether a
       request counts as an alteration are the same number and cannot drift.
       NOT the band: that is FIT_BAND and a different question — see the
       constants.

       Rounded UP to the nearest half inch rather than printed as 0.4: half an
       inch is a figure somebody can picture, and over-stating a tolerance is
       the safe direction — it is a promise we can always keep. */
    function tolText(){
      if(S.unit !== 'in') return FIT_TOL + ' cm';
      return (Math.ceil((FIT_TOL / CM_PER_IN) * 2) / 2) + ' in';
    }
    function unitLabel(k){
      if(S.unit === 'in' && k === 'height') return 'ft / in';
      if(S.unit === 'in') return UNIT_KIND[k] === 'mass' ? 'lb' : 'in';
      return UNIT_KIND[k] === 'mass' ? 'kg' : 'cm';
    }
    /* what was typed  ->  cm / kg */
    function toCanonical(k, v){
      var n = num(v);
      if(!isFinite(n)) return '';
      if(S.unit === 'cm') return String(n);
      return String(UNIT_KIND[k] === 'mass' ? n / LB_PER_KG : n * CM_PER_IN);
    }
    /* cm / kg  ->  what to show in the box */
    function fromCanonical(k, v){
      var n = parseFloat(v);
      if(!isFinite(n)) return '';
      if(S.unit === 'in') n = (UNIT_KIND[k] === 'mass') ? n * LB_PER_KG : n / CM_PER_IN;
      return String(round1(n));
    }
    /* Re-fill every box from what is stored. Called on boot and whenever the
       unit changes; never while typing, which is the whole point of keeping
       the two apart. */
    function retype(){
      ALL_MEAS.forEach(function(k){ S.typed[k] = fromCanonical(k, S.meas[k]); });
      var h = ftFromCanonical(S.meas.height);
      S.typed.heightFt = h.ft; S.typed.heightIn = h.inch;
      DIM_KEYS.forEach(function(k){ S.typedDim[k] = fromCanonical(k, S.dim[k]); });
    }
    retype();

    /* The cm/in switch. It belongs to whichever step is asking for a number,
       and three of them do, so it is built once and each of them appends it
       LAST — under its own fields. Changing it converts what is already there
       instead of clearing it, so a number typed in inches survives the switch
       to centimetres and back. */
    function unitSwitch(){
      var ur = el('div','mcfg__unitrow');
      ['cm','in'].forEach(function(u){
        var ub = el('button','mcfg__unit', u); ub.type = 'button';
        ub.setAttribute('aria-pressed', S.unit === u ? 'true' : 'false');
        ub.addEventListener('click', function(){
          if(S.unit === u) return;
          S.unit = u;
          retype();
          go();
        });
        ur.appendChild(ub);
      });
      return ur;
    }

    /* Route 1 means the funnel already asked these questions, so they are shown
       as criteria instead of being asked again. Route 2 is a cold landing from
       search: derive `who` from this product so the model list is relevant,
       and derive nothing for Unisex, which belongs to both lists. */
    /* The route travels in the URL as r=. Deriving it from which params are
       present looked tidier, but broke on refresh: route 2 derives `who` from
       the product, syncUrl writes it back, and the reload then reads that
       derived value as a funnel criterion. Stating it is cheaper than
       inferring it. */
    var rParam = params.get('r');
    S.route = rParam ? (parseInt(rParam, 10) === 1 ? 1 : 2)
                     : ((S.who || S.garment || S.tier) ? 1 : 2);
    /* Through whoKey() as well: CFG.who is this product's own type segment,
       so it is translated exactly like the list's. */
    if(S.who) S.who = whoKey(S.who);
    var cfgWho = whoKey(CFG.who);
    if(S.route === 2 && !S.who && cfgWho && cfgWho !== 'Unisex') S.who = cfgWho;

    /* HOW THE PAGE ARRIVED, kept so a search can be CLOSED and put back
       exactly as it was. Captured here, after the route-2 derivation above
       and before anything on screen can touch either value.

       Not recomputed on the way out, because the right answer differs by
       route and only this line knows both: on a cold landing it is the
       gender derived from the product, and on a funnel arrival it is the
       criteria the funnel chose. Restoring a guess would quietly discard
       somebody's funnel. */
    var ARRIVED = { who: S.who, garment: S.garment };

    /* ─────────── rounding ───────────
       Every market this shop sells in prices in whole units: the live IT
       figures are 175 / 184 / 192, GB 186 / 195 / 204, US 249 / 261 / 273 —
       never a decimal. Multiplying one of those by a size percentage produced
       192,50 and 204,60, which are not prices this store would ever show.

       The step is read off the variants rather than hardcoded, so a market that
       genuinely prices in decimals keeps its cents and nothing here changes. */
    function priceStep(){
      var vs = CFG.variants || [];
      if(!vs.length) return 1;
      for(var i = 0; i < vs.length; i++) if(vs[i].cents % 100 !== 0) return 1;
      return 100;
    }
    var STEP = priceStep();
    function roundPrice(cents){ return Math.round(cents / STEP) * STEP; }

    /* ─────────── money ───────────
       Intl, not a reimplementation of the money filter: the shop is multi-market
       and the currency travels with the price.

       No decimals when the market prices in whole units — "€167,00" carries two
       zeroes that can never be anything else. It follows STEP rather than being
       switched off, so a decimal market still shows its cents. */
    var DIGITS = (STEP === 100) ? 0 : 2;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(CFG.locale || undefined,
              { style:'currency', currency: CFG.currency || 'EUR',
                minimumFractionDigits: DIGITS, maximumFractionDigits: DIGITS });
    } catch(e){ fmt = null; }
    /* A SPACE BETWEEN THE SYMBOL AND THE FIGURE, in every market. Intl already
       puts one in for it-IT ("167 €") and none at all for en-US ("$167"), so
       the same shop read as two different house styles depending on where you
       stood.

       formatToParts, not a regex on the output: the symbol may be '$', 'CHF'
       or '¥', it may lead or trail, and the group and decimal separators are
       the locale's own — a regex would have to know all of that and would get
       JPY or CHF wrong. Here the currency part is simply identified and a
       space put beside it.

       Only where there is not one already, so the markets Intl gets right are
       left exactly as they were: \s matches the non-breaking space Intl
       actually emits, not just a plain one. Guarded because formatToParts is
       later than the rest of this file's ES5 — without it, the old behaviour. */
    function money(cents){
      if(cents == null) return '—';
      if(!fmt) return (cents / 100).toFixed(DIGITS) + ' ' + (CFG.currency || '');
      if(!fmt.formatToParts) return fmt.format(cents / 100);
      /* Against the DIGITS, not against anything that happens to sit next to
         the symbol: a minus sign is one of those, and "- $ 167" is not what
         anybody meant by a space before the figure. */
      var NUMERIC = { integer:1, fraction:1, decimal:1, group:1 };
      var parts = fmt.formatToParts(cents / 100), out = '';
      for(var i = 0; i < parts.length; i++){
        var p = parts[i], prev = parts[i - 1];
        var touches = (p.type === 'currency' && prev && NUMERIC[prev.type]) ||
                      (prev && prev.type === 'currency' && NUMERIC[p.type]);
        if(touches && !/\s$/.test(out) && !/^\s/.test(p.value)) out += ' ';
        out += p.value;
      }
      return out;
    }

    /* ─────────── this product's sizes ───────────
       All of it derived from custom.size_ranges. A rung without `extrapolated`
       is a size the origin product really sells; one with it exists on paper
       only. See the header: that is the whole stocked/developed distinction. */
    function rungs(){
      if(!CFG.ranges || !CFG.ranges.ranges) return [];
      var keys = Object.keys(CFG.ranges.ranges);
      /* One key for a gendered product. A unisex product carries both ladders;
         the first is used, which is right today because the two unisex products
         have no profile yet. @TODO pick by `who` once MCU001/MCU002 are tagged. */
      return keys.length ? (CFG.ranges.ranges[keys[0]] || []) : [];
    }
    function stockedSizes(){
      return rungs().filter(function(r){ return !r.extrapolated; })
                    .map(function(r){ return r.size; });
    }
    /* Which body measurement grades THIS garment. Octopus decided it per
       product and put it in size_ranges.axis; reading anything else here would
       resolve a hip ladder against a chest. */
    function axisKey(){
      var a = (CFG.ranges && CFG.ranges.axis) || CFG.axis || 'chest';
      return BODY_KEYS.indexOf(a) >= 0 ? a : 'chest';
    }
    function bodyValue(){ return S.meas[axisKey()]; }

    /* ─── EXAMPLE FIGURES FOR THE EMPTY BOXES ───
       An empty numeric field says what it wants in its label and nothing
       about the SHAPE of the answer. "Torace (cm)" is answered with 88 by
       somebody who knows their chest and with 34 by somebody reading an
       inch-sized number off a shirt label, and the second one resolves to a
       size we do not make.

       So each box opens with a plausible figure greyed out in it. It is an
       EXAMPLE and reads as one — the wording carries "e.g." from the locale
       file — and because it is a placeholder it is never a value: it is not
       stored, not written into the URL, and not carried to the next garment.
       That distinction is the same one the fit boxes already make.

       THE GRADED AXIS COMES FROM THE PRODUCT'S OWN LADDER rather than from
       the table below. The middle rung's max_body is a real chest (or hip)
       for a real wearer of this exact garment, so it is right for a women's
       cardigan and right for a men's coat without anybody maintaining two
       numbers, and it follows the catalogue as the catalogue moves.

       THE TABLE IS ONLY FOR WEIGHT AND HEIGHT, which no ladder knows. Rough
       adult averages, by the gender the product is filed under; a Unisex or
       Lifestyle product takes the midpoint, because it is worn by both and an
       example that leans either way would read as an assumption about who is
       buying. They are examples and nothing computes from them, so a number
       somebody disagrees with costs an edit here and nothing else. */
    var AVG = {
      Women: { chest:88,  hips:96,  weight:65, height:165 },
      Men:   { chest:100, hips:100, weight:80, height:178 }
    };
    function egValue(k){
      if(k === axisKey()){
        var rs = rungs();
        if(rs.length){
          var mid = rs[Math.floor((rs.length - 1) / 2)];
          var m = parseFloat(mid && mid.max_body);
          if(isFinite(m) && m > 0) return m;
        }
      }
      var tbl = AVG[CFG.who];
      if(tbl && isFinite(tbl[k])) return tbl[k];
      var a = AVG.Women[k], b = AVG.Men[k];
      return (isFinite(a) && isFinite(b)) ? Math.round((a + b) / 2) : NaN;
    }
    /* "e.g. 88", in the visitor's own unit and in their own language.

       THE WORDING IS A LOCALE KEY and the figure is substituted into it,
       which is the only way it can work: `e.g.` is `es.` in Italian, `p. ex.`
       in French and `z. B.` in German, and several of those put the full stop
       somewhere English does not. {v} is the number alone — the unit is
       already in the field's label, and printing it twice made the
       placeholder longer than the box.

       WITHOUT THE KEY there is no placeholder at all rather than a bare
       number: that is the deploy-skew case, this file live and the section
       not, and a naked "88" in a box reads as a value somebody entered. */
    function eg(text){
      return STR.eg ? t(STR.eg, { v: text }) : '';
    }
    function egFor(k){
      var v = egValue(k);
      if(!isFinite(v)) return '';
      var shown = parseFloat(fromCanonical(k, v));
      if(!isFinite(shown)) return '';
      /* Whole numbers. An example carrying a decimal invites somebody to
         match its precision, and none of these is measured that finely. */
      return eg(String(Math.round(shown)));
    }

    /* EVERY BOX ON THE FIRST STEP, not just the graded one. The axis is what
       resolves the size, but the weight and the height are what production
       reads when a body does not sit neatly on the ladder — and a piece cut
       from one number out of three is the failure this whole flow exists to
       avoid. All three are rendered, so all three are required.

       Used by BOTH the Continue button and the add-to-cart guard, so the two
       cannot disagree about what "measured" means. To go back to the axis
       alone, return `!!bodyValue()` and nothing else changes.

       TRUE WHERE THE STEP IS NOT DRAWN AT ALL — an accessory is never asked
       for a body, and a question nobody was asked cannot be unanswered. */
    /* ─── AN ALTERATION HAS TO ALTER SOMETHING ───
       29/09/2026, and it closes a hole that cost money rather than clarity.

       The two fit boxes are optional and always have been: an empty one means
       "make it the way you make it", which is the commonest answer and the
       one that needs no typing. That is true on NEW SIZE, where the customer
       is paying for a size that does not exist and the lengths are a courtesy.

       It is NOT true on ADJ. There the whole charge IS the alteration — the
       tier costs more than colour-only for exactly one reason — so walking
       past this step with both boxes empty buys the standard garment at the
       altered price. The dimensions step has always refused the equivalent
       (dimEntries().length, and for the same reason); this is the garment's
       half of the same rule.

       fitEntries() is the right test rather than "is a box filled", because
       it already discounts a figure within the tolerance of our own standard
       — typing 73 back into a box whose standard is 73 has changed nothing
       and must not unlock a paid change.

       STG IS LEFT ALONE. A new size is being developed whatever the sleeve
       says, so there is nothing to withhold. */
    function fitAnswered(){
      if(!visible('fit')) return true;
      if(S.tier !== 'ADJ') return true;
      return fitEntries().length > 0;
    }

    function measFields(){ return [axisKey()].concat(EXTRA_KEYS); }
    function measComplete(){
      if(!visible('meas')) return true;
      return measFields().every(function(k){
        var n = parseFloat(S.meas[k]);
        return isFinite(n) && n > 0;
      });
    }

    /* The first rung that covers the body — the same rule, in the same order,
       as easeResolveSize() in Octopus. */
    function resolveSize(chest){
      var list = rungs(), c = parseFloat(chest);
      if(!c || !list.length) return null;
      for(var i = 0; i < list.length; i++) if(c <= list[i].max_body) return list[i];
      return null;                                  /* past the last rung */
    }
    /* Offered = in the catalogue, or a developed rung somebody priced.
       No row at all is not an omission, it is a decision: we do not make it. */
    function isOffered(label){
      return stockedSizes().indexOf(label) >= 0 ||
             Object.prototype.hasOwnProperty.call(UPLIFT, label);
    }
    function isStocked(label){ return stockedSizes().indexOf(label) >= 0; }

    /* ─────────── this product's chart ───────────
       custom.product_measurements_table, as Octopus writes it:
         { sizes:[ { label:"L", characteristics:{ shoulders, chest, sleeves,
           length } } ] }
       Flat production measurements in centimetres. A /C product carries its
       ORIGINAL's chart — resolved on the Octopus side — so there is no hop to
       make here.

       It is read for ONE thing: which of the second-round measurements are
       worth asking for. A chart with no sleeve row means a garment with no
       sleeves, and nobody should be asked for their arm length in order to buy
       a gilet. The numbers in it are never shown and never compared against
       what the customer types — those are measurements of a person, these are
       measurements of a finished garment, and putting them side by side would
       invite exactly the subtraction that must not happen on a form.

       Asked across ALL the rows, not the row for one size: a new size has no
       row of its own, and the question "does this garment have sleeves" has
       the same answer either way. */
    function chartHas(k){
      var sz = (CFG.chart && CFG.chart.sizes) || [];
      for(var i = 0; i < sz.length; i++){
        var v = parseFloat((sz[i].characteristics || {})[k]);
        if(isFinite(v) && v > 0) return true;
      }
      return false;
    }
    /* IS THIS A GARMENT AT ALL — something worn on a body, whether or not we
       can size it. 13 products carry a measurements table but no ease
       profile: they have no ladder, so nothing resolves, but they must still
       be ASKED for a measurement, because the contact block is reached from
       that step and it is their only way out. An accessory has no chart — it
       has a sentence — and is never asked.

       Any characteristic with a real number will do. Asking specifically for
       a chest would answer `false` for a pair of joggers, whose chart is
       graded on the hip; the question here is whether there is a chart, not
       which axis it grades. */
    function hasBodyChart(){
      return ['chest','hips','shoulders','sleeves','length'].some(function(k){
        return chartHas(k);
      });
    }
    /* The chart row for a size, or null. Used ONLY to print the standard body
       length beside the delta box. A size nobody has made yet has no row, and
       that is not a problem: the question is still answerable — longer or
       shorter than our standard — and Octopus applies the delta to the figure
       it grades. */
    function chartRow(label){
      var sz = (CFG.chart && CFG.chart.sizes) || [];
      if(!label) return null;
      for(var i = 0; i < sz.length; i++) if(sz[i].label === label) return sz[i].characteristics || null;
      return null;
    }
    /* At most two questions, chosen by what the garment is. A gilet has no
       sleeve row and is never asked for an arm; a sweater is never asked for an
       outseam. */
    function fitAxes(){
      var out = [];
      if(chartHas('sleeves')) out.push('sleeveLen');
      if(chartHas('length'))  out.push('bodyLen');
      return out;
    }
    /* One key, two names: the chart's `length` is measured from the high point
       shoulder to the hem on a top and is the outseam on a bottom. Nothing
       else distinguishes them and nothing else needs to — a product graded on
       hips is a bottom. */
    function measLabel(k){
      if(k !== 'bodyLen') return STR.meas[k];
      return axisKey() === 'hips' ? STR.meas.lenLeg : STR.meas.lenBody;
    }
    /* WHAT WE MAKE AS STANDARD for this size. For the sleeve it is the
       composite — shoulders/2 + sleeves — because that is the route the
       customer is asked to measure along; for the length it is the chart
       figure as it stands.

       It does three jobs now that the box takes an absolute: it is printed
       under the field as the band, it is the placeholder inside it, and it is
       what fitEntries() compares against to decide whether anything was
       actually changed.

       NULL IS A REAL ANSWER and every one of those three handles it: a size
       nobody has made yet has no chart row, and 7 products (MCW029, MCW036
       and the other drop-shoulder styles) have a sleeve figure but no
       shoulder, so their composite cannot be computed until somebody measures
       it. No band is printed, the box shows no placeholder, and whatever is
       typed counts as a request — which is right, because with nothing to
       compare against there is no way to call it unchanged. */
    function fitStd(k, size){
      var row = chartRow(size);
      if(!row) return null;
      if(k === 'bodyLen'){
        var L = parseFloat(row.length);
        return (isFinite(L) && L > 0) ? L : null;
      }
      var sh = parseFloat(row.shoulders), sl = parseFloat(row.sleeves);
      if(!isFinite(sl) || sl <= 0) return null;
      if(!isFinite(sh) || sh <= 0) return null;
      return sh / 2 + sl;
    }
    /* No standard for this size (new size, or a request): the largest size we
       make gives the "e.g." figure. An example only, never shown as a standard. */
    function fitExample(k){
      var sz = (CFG.chart && CFG.chart.sizes) || [];
      for(var i = sz.length - 1; i >= 0; i--){
        var v = fitStd(k, sz[i].label);
        if(v != null) return v;
      }
      return null;
    }
    /* Whatever round two actually collected, as [{key, cm}] — used by the recap
       and by the cart, so the two cannot disagree about what was asked for.
       Blank is a real answer and leaves no entry. */
    function fitEntries(){
      if(!visible('fit')) return [];
      var size = outcome().size;
      return fitAxes().filter(function(k){
        var n = parseFloat(S.meas[k]);
        if(!isFinite(n) || n <= 0) return false;
        /* ASKING FOR OUR OWN STANDARD BACK IS NOT AN ALTERATION. The
           placeholder shows that figure, so somebody who reads it and types
           it has changed nothing and must not be charged as though they had.

           Judged against the tolerance rather than by equality, because the
           standard is a band: 73.25 is printed as 73—74, and a request
           anywhere inside that band is a request for the piece we already
           make. Without a standard there is nothing to compare against, so
           anything typed counts. */
        var std = fitStd(k, size);
        return std == null || Math.abs(n - std) >= FIT_TOL;
      }).map(function(k){ return { key:k, cm:parseFloat(S.meas[k]) }; });
    }
    /* WHAT THE PIECE WILL ACTUALLY MEASURE — every axis the step asked
       about, whether it was changed or left alone. FOR READING BACK ONLY.

       fitEntries() answers a different question: what did they CHANGE. That
       is the right question for the cart, where posting the standard back
       would put production to work on a piece already in the catalogue and
       would be charged as an alteration. It is the wrong question for the
       recap, which was simply silent about a sleeve nobody touched — so a
       customer who left both boxes alone read a summary that never mentioned
       the sleeves at all, and had no way to see what they were getting.

       So the recap reads from here and the cart still reads from
       fitEntries(). Two questions, two functions, and the one that spends
       money is the narrow one.

       An axis with NO STANDARD to state is skipped rather than guessed at:
       a size nobody has made has no chart row, and the drop-shoulder styles
       have a sleeve figure but no shoulder, so the composite cannot be
       computed. Printing a name with no figure beside it says nothing. */
    function fitReadback(){
      if(!visible('fit')) return [];
      var size = outcome().size, changed = {};
      fitEntries().forEach(function(a){ changed[a.key] = a.cm; });

      /* THE STANDARDS WAIT UNTIL THE STEP HAS BEEN WALKED PAST. Choosing
         "colour and fit" put both bands in the recap before the customer had
         been shown the fit step at all, which reads as a decision already
         taken on their behalf — and on a screen whose whole job is to say
         what THEY chose.

         Past it, the same two lines are the opposite: they confirm that the
         boxes left empty mean our standard rather than nothing.

         iNow is -1 on the very first render, because the recap is built
         before go() normalises S.active a few lines down. That resolves to
         "not past", which is the right way for the ambiguity to fall, and it
         corrects itself on the next pass. */
      var order = activeSteps();
      var iFit  = order.indexOf('fit'), iNow = order.indexOf(S.active);
      var past  = iFit >= 0 && iNow > iFit;

      var out = [];
      fitAxes().forEach(function(k){
        /* TYPED reads as the single figure it is — "Manica 74 cm" — and it
           reads back the moment it is typed, on the step itself. A number
           somebody entered is theirs to see straight away. */
        if(changed[k] != null){ out.push(fitText(k, changed[k])); return; }
        if(!past) return;
        /* LEFT ALONE reads as the BAND — "Manica 74-75 cm" — and is not
           marked or qualified. The band IS the distinction: a figure somebody
           typed is one number, and what we make as standard is a window,
           because 73.25 is a precision no knitting machine can hold to. */
        var std = fitStd(k, size);
        if(std != null) out.push(measLabel(k) + ' ' + band(k, std));
      });
      return out;
    }
    /* A GARMENT MEASUREMENT, quoted as the band we can actually hold it to.
       See FIT_TOL: never a decimal, never a single figure. */
    function band(k, cm){
      var lo = Math.floor(parseFloat(fromCanonical(k, cm)));
      if(!isFinite(lo)) return '';
      /* FIT_BAND, not FIT_TOL: the width of the window our own standard sits
         in, which is one whole unit and has nothing to do with how close the
         machine comes. */
      return lo + '-' + (lo + FIT_BAND) + ' ' + unitLabel(k);
    }
    /* Read back as what will be MADE: the finished length they asked for. It
       used to be signed, because it used to be a difference. */
    function fitText(k, cm){
      return measLabel(k) + ' ' + fromCanonical(k, cm) + ' ' + unitLabel(k);
    }

    /* ─────────── an accessory's dimensions ───────────
       custom.product_measurements_sentence is a SENTENCE, because that is what
       it was built to be: "180 x 50 cm, 400 g", printed under the product. It
       is also the only place a scarf's length and width exist on Shopify, so
       the Dimensioni step reads them back out of it.

       Machine-written by Octopus out of product_measurement_meta, in one
       format, on every row that has both numbers — 65 of the 141 accessories.
       The other 76 carry a weight and nothing else, and for those there is
       nothing to offer: no standard to depart from, no step.

       If that sentence is ever hand-edited into a different shape this returns
       null and the step quietly disappears, which is the right failure: an
       accessory we cannot state the size of is not one we should invite
       somebody to resize. */
    function dimStd(){
      var m = /(\d+(?:[.,]\d+)?)\s*[x×X]\s*(\d+(?:[.,]\d+)?)\s*cm/.exec(CFG.sentence || '');
      if(!m) return null;
      var l = parseFloat(m[1].replace(',', '.')), w = parseFloat(m[2].replace(',', '.'));
      if(!isFinite(l) || !isFinite(w) || l <= 0 || w <= 0) return null;
      return { length:l, width:w };
    }
    /* THE HOUSE LIMIT, in centimetres: how far a piece may be moved from the
       standard before it stops being a modification and becomes a
       development. ONE number for both kinds of piece — an accessory's length
       and width, and a garment's sleeve and body — because it is the same
       rule about the same workshop, not a fact about scarves.

       It bounds the accessory boxes outright (they will not accept a figure
       past it) and it re-prices a garment (see outcome(): past it the tier
       becomes STG). Split it in two if the two ever need different numbers. */
    function houseLimit(){
      var n = parseFloat(CFG.adjMaxCm);
      return isFinite(n) && n > 0 ? n : 7;
    }
    /* HOW FAR THE BIGGEST FIT REQUEST IS FROM OUR STANDARD, in centimetres,
       or 0 when nothing was asked for. Takes the size rather than working it
       out, because outcome() is what calls this and fitEntries() already
       calls outcome() — deriving it here would be a loop. */
    function fitMaxDelta(size){
      var worst = 0;
      fitAxes().forEach(function(k){
        var v = parseFloat(S.meas[k]), std = fitStd(k, size);
        if(!isFinite(v) || v <= 0 || std == null) return;
        var d = Math.abs(v - std);
        if(d > worst) worst = d;
      });
      return worst;
    }
    /* Only what was actually MOVED. Asking for the standard length back is not
       a customisation, and posting it would put production to work on a piece
       that is already in the catalogue. */
    function dimEntries(){
      var std = dimStd();
      if(!visible('dim') || !std) return [];
      return DIM_KEYS.filter(function(k){
        var n = parseFloat(S.dim[k]);
        return isFinite(n) && n > 0 && round1(n) !== round1(std[k]);
      }).map(function(k){ return { key:k, cm:parseFloat(S.dim[k]) }; });
    }

    /* ─────────── personalisation ───────────
       NOT "monogram", and the word matters. A monogram is initials. This is
       initials on an intarsio (3 characters), but it is also a word or a
       short phrase on a ricamo (10), and the two are not even the same
       operation: ricamo is EMBROIDERED onto the finished cloth, intarsio is
       KNITTED INTO it. One customer's is "MLL", another's is "Capri".

       So the umbrella word here is PERSONALISATION — which is also what
       Octopus calls it everywhere that counts: order_items.customization, the
       _customization_* properties, the customization_options metaobject. Where
       a sentence needs a noun for the thing itself, it is THE LETTERING, which
       is true of both techniques and of both lengths.

       monogram_option_id, product_monogram_options and maison_monogram_label()
       keep the old name because those are real identifiers in Octopus and
       renaming them here would only make them unsearchable.

       Ricamo and intarsio, read from the SAME metaobject the ordinary product
       page reads. Everything this step posts is the contract Octopus already
       ingests — the five _customization_* properties — so a Custom Studio line
       with lettering lands in order_items.customization exactly like any
       other, and RICAMO/INTARSIO routing, the packing note and the workshop
       ping all keep working without a change on that side.

       It is ALWAYS optional. Nothing is posted until there is text, because a
       font and a position with nothing written on them is not lettering. */
    function pers(){ return CFG.pers || null; }
    function persOn(){ return !!(pers() && visible('pers')); }
    /* Whether they have actually asked for one. TWO conditions: they said
       yes, and they wrote something. The text alone used to be the switch,
       which worked but left nowhere to say no — the only way to decline was to
       leave a box empty and hope that meant what you thought it meant. */
    function persWanted(){
      return persOn() && S.pers.on === true && !!String(S.pers.text || '').trim();
    }
    function persFonts(){ return (pers() && pers().fonts) || []; }
    function persPositions(){ return (pers() && pers().positions) || []; }
    function persSwatches(){ return (pers() && pers().colors) || []; }
    function persFree(){ return !!pers() && pers().colorMode === 'free_select'; }
    /* THE INTARSIA YARN. Shown, never chosen — and it belongs to the GARMENT
       COLOUR, not to the product: Octopus pairs each colour with the yarn that
       reads against it, so Nero takes Sabbia and Bianco takes Blu Notte. Pick a
       different colour on this step and the yarn named on the next one changes
       with it.

       The product-level custom.inlay_color is the fallback and is what every
       ordinary product uses, correctly: a product with one colour has one
       pairing. It is the wrong answer on a custom product and the right answer
       everywhere else, so it stays underneath rather than being removed.

       Null while no colour has been picked yet, which is a real state: the
       colour step comes immediately before this one but nothing forces it. */
    function persPairedColor(){
      var c = S.color ? colorByCode(S.color) : null;
      if(c && c.inlay && c.inlay.name) return c.inlay;
      var n = (pers() && pers().inlayColor) || '';
      return n ? { name:n, hex:'' } : null;
    }
    function persPaired(){ var pc = persPairedColor(); return pc ? pc.name : ''; }
    /* An ABSOLUTE amount in the visitor's currency, not a percentage — the one
       place in this file where an uplift is not a %. Same fallback as the
       ordinary drawer: the market's own figure, then eur.

       @TODO JPY. This multiplies by 100 to reach minor units, which is right
       for every decimal currency and wrong for yen — the same assumption
       money() already makes about variant.cents, so the two are at least
       consistent. Fix both together or neither. */
    function persUplift(){
      var pr = (pers() && pers().pricing) || null;
      if(!pr) return 0;
      var cur = String(CFG.currency || 'EUR').toLowerCase();
      var v = (pr[cur] != null) ? pr[cur] : pr.eur;
      v = parseFloat(v);
      return isFinite(v) ? Math.round(v * 100) : 0;
    }
    /* A font key as something to read. The product page shows a rendered
       preview instead; we have no filename for those, so the key is
       prettified rather than guessed at. */
    function persFontLabel(f){
      return String(f || '').replace(/_/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
    }
    function persPosLabel(p2){ return (STR.positions && STR.positions[p2]) || p2; }
    function persColorLabel(hex){
      var cs = persSwatches();
      for(var i = 0; i < cs.length; i++) if(cs[i].hex === hex) return cs[i].label;
      return hex;
    }
    /* Everything the option asks for has been answered. Only checked once
       there IS text — the sections that offer a single choice are preselected
       in go(), so in practice this is about the ones that offer several. */
    function persComplete(){
      if(!persOn()) return true;
      /* NOT ASKED YET is not an answer, and this is the whole of the change:
         until one of the two buttons has been pressed the step is
         incomplete, so Continue is dead and so is Add to bag. */
      if(S.pers.on == null) return false;
      /* Declined IS a complete answer, and the commonest one. */
      if(S.pers.on === false) return true;
      /* Said yes and wrote nothing: that is the one half-finished state, and
         it has to block the cart or the line would be charged for
         personalisation with nothing written on it. */
      if(!persText()) return false;
      if(persPositions().length && !S.pers.pos)  return false;
      if(persFonts().length     && !S.pers.font) return false;
      if(persFree() && persSwatches().length && !S.pers.color) return false;
      return true;
    }
    /* THE LABEL, and its shape is a contract with Octopus:
         "embroidery, MLL, goudy_bookletter, #3d3d3d, accessory"
         "inlay_109, LEOPOLD, times, accessory"
       type, text, font, [hex only when the colour was chosen], position —
       comma separated, which is why the TYPED TEXT has its own commas encoded
       as &#44; here. maison_decode_typed_text($v, true) protects exactly that
       entity so maison_monogram_label() can split on the commas afterwards;
       send a raw comma and the label parses into the wrong fields. */
    function persLabel(){
      /* UPPERCASE in the label, raw in _customization_input — which is what
         the drawer does and what the stored rows show: input "Capri", label
         "inlay_109, CAPRI, times, accessory". Production reads the label. */
      var parts = [pers().code, persText().toUpperCase().replace(/,/g, '&#44;')];
      if(S.pers.font) parts.push(S.pers.font);
      if(persFree() && S.pers.color) parts.push(S.pers.color);
      if(S.pers.pos) parts.push(S.pers.pos);
      return parts.join(', ');
    }
    /* THE LETTERING, as the customer reads it. The same shape the ordinary
       drawer builds in maison-personalization.js — text, then only the
       details they were actually given a choice about. A font nobody picked
       is not a detail worth printing. */
    function persVisibleLabel(){
      var parts = [persText().toUpperCase()];
      if(persFonts().length > 1 && S.pers.font) parts.push(persFontLabel(S.pers.font));
      if(persFree() && S.pers.color) parts.push(persColorLabel(S.pers.color));
      else if(persPaired()) parts.push(persPaired());
      if(persPositions().length > 1 && S.pers.pos) parts.push(persPosLabel(S.pers.pos));
      return parts.join(', ');
    }
    /* THE WHOLE LINE, AS THE CUSTOMER READS IT, and the only property here
       without a leading underscore — which is exactly why it is the only one
       that can say anything. A property KEY cannot be translated: it is an
       identifier the cart transform and the order ingest match on, so it is
       the same word in every market. The VALUE can be, and is.

       So everything customer-facing goes into this one string rather than
       into keys of its own. It is the property the ordinary drawer already
       posts and the cart template already labels, so a made-to-order line
       needs no new mechanism and no per-language alias on the function side.

       Size and colour stand BARE — "4XL", "Black" — because they explain
       themselves. A garment measurement does not: "77 cm" alone says nothing,
       so it keeps the field's own translated name through fitText(). That is
       the same sentence the rail prints, so the cart and the page cannot
       describe the piece differently.

       Built for EVERY line, not only a personalised one. Declining the
       lettering is the commonest answer, and a piece with none still has a
       size and a colour worth reading back. */
    function visibleLabel(o, c){
      var parts = [];
      /* U is the one-size sentinel. A scarf has no size to show, and
         "U" on one reads as a glitch rather than an answer. */
      if(o.size && o.size !== 'U') parts.push(o.size);
      if(c && c.name) parts.push(c.name);
      fitEntries().forEach(function(a){ parts.push(fitText(a.key, a.cm)); });
      dimEntries().forEach(function(a){
        parts.push(STR.dim[a.key] + ' ' +
                   fromCanonical(a.key, a.cm) + ' ' + unitLabel(a.key));
      });
      if(persWanted() && persComplete()) parts.push(persVisibleLabel());
      return parts.join(', ');
    }
    function persText(){ return String(S.pers.text || '').trim(); }
    /* THE STYLE PREVIEW, and it is ONE element for the life of the
       configurator rather than a new <img> per render. That is the whole fix
       for the page jumping every time a position or a font was clicked.

       go() rebuilds the step body from scratch on every click and every
       keystroke. A freshly created <img> has NO BOX until its resource is
       attached — height:auto on nothing is zero — so the panel laid out short,
       the picture arrived a frame later, and everything under it moved. From
       cache too: the bytes are instant, the second layout pass is not.

       appendChild on an element that already exists MOVES it, and it brings
       its resolved height with it, so there is no second pass and nothing to
       jump. The src is written only when it actually changes, for the same
       reason — reassigning the same URL would detach the resource and put the
       shift straight back.

       Not lazy: it is inside the panel the customer is looking at, and a lazy
       image is one more thing that resolves late. */
    var persImgEl = null, persImgBad = {};
    function persImg(){
      if(!persPhotos().length) return null;
      if(!persImgEl){
        persImgEl = document.createElement('img');
        persImgEl.className = 'mcfg__persimg';
        persImgEl.alt = '';
        persImgEl.decoding = 'async';
        /* Low, because this is warmed at boot for a step at the END of the
           flow — it must never compete with the garment photo, which is the
           LCP element. An old engine ignores the property and simply queues it
           normally, which is what it did before. */
        try { persImgEl.fetchPriority = 'low'; } catch(e){}
        /* THE BOX IS LOCKED TO THE FIRST PICTURE THAT LOADS. From then on the
           height is computed from the width by aspect-ratio, so a later swap —
           to a font's own photo, or through the fallback — cannot collapse it
           to nothing while the next file is in flight. Without this, EVERY
           change of src jumps, cache or no cache: an <img> between resources
           has no intrinsic size and height:auto on nothing is zero. */
        persImgEl.onload = function(){
          if(persImgEl.naturalWidth && persImgEl.naturalHeight)
            persImgEl.style.aspectRatio =
              persImgEl.naturalWidth + ' / ' + persImgEl.naturalHeight;
        };
        /* WALK THE NAMES. A miss is REMEMBERED, which is half the no-jump
           fix as well: the failed request is itself what empties the box for
           a frame, so the next render must not ask for it again and watch the
           buttons underneath snap up and back while the fallback loads. Only
           when every candidate has 404'd does the element hide — no broken
           frame, and no gap that opens later when one finally loads. */
        persImgEl.onerror = function(){
          var had = persImgEl.getAttribute('src');
          if(had) persImgBad[had] = true;
          var nx = persNextPhoto();
          if(nx && nx !== had){ persImgEl.setAttribute('src', nx); return; }
          persImgEl.style.display = 'none';
        };
      }
      /* Every name missing: hide rather than leave a frame with nothing in
         it. The box keeps whatever aspect-ratio it learned, so putting it back
         later costs no jump either. */
      var u = persNextPhoto();
      if(!u){ persImgEl.style.display = 'none'; return persImgEl; }
      if(persImgEl.getAttribute('src') !== u){
        persImgEl.style.display = '';
        persImgEl.setAttribute('src', u);
      }
      return persImgEl;
    }
    /* EVERY NAME THE PREVIEW MIGHT BE UNDER, best first. The drawer's
       convention is customization_<code>_<font>.jpg where a per-font shot
       exists and customization_<code>.jpg where it does not — and WHICH of
       them is actually on the CDN varies by option. Checked 25/09/2026:

         customization_embroidery.jpg                  404
         customization_embroidery_avante.jpg           200
         customization_embroidery_goudy_bookletter.jpg 200
         customization_inlay.jpg                       200
         customization_inlay_times.jpg                 404

       Exactly opposite, in other words, which is why neither name alone can
       be the answer.

       WITH NO FONT CHOSEN THE FIRST FONT LEADS, and that is why the step has
       a picture before anything is decided. Ricamo offers two fonts, so go()
       preselects neither, and ricamo has no plain shot at all: the question
       'do you want lettering, it adds 10' was being asked with nothing to
       look at, which is no way to ask it. The first font's own photo answers
       it, and asking for it FIRST rather than after the plain name means the
       opening request is the one that actually exists — no 404 to wait
       through before the picture appears.

       That photo is a SAMPLE, not a selection: nothing in the state changes,
       no font is marked chosen, and the moment one is picked the preview
       swaps to it. The plain name stays underneath as the catch, because it
       is the only one intarsio has. Nothing at all when the shop domain is
       unknown — an empty <img> is worse than no <img>. */
    function persPhotos(){
      if(!pers() || !pers().cdnBase) return [];
      var base = pers().cdnBase + 'customization_' + pers().code, fs = persFonts();
      /* The font in hand: the one they chose, or the first as a sample. */
      var f = S.pers.font || (fs.length ? fs[0] : ''), out = [];
      if(f) out.push(base + '_' + f + '.jpg');
      out.push(base + '.jpg');
      if(fs.length && fs[0] !== f) out.push(base + '_' + fs[0] + '.jpg');
      return out;
    }
    /* The best candidate not already known to 404. */
    function persNextPhoto(){
      var names = persPhotos();
      for(var i = 0; i < names.length; i++) if(!persImgBad[names[i]]) return names[i];
      return '';
    }

    /* ─────────── this product's tiers ─────────── */
    function variantFor(tier){
      var vs = CFG.variants || [], i;
      for(i = 0; i < vs.length; i++) if(vs[i].tier === tier) return vs[i];
      /* PLUS1..PLUS4 is the ladder STG replaced. Products migrated at different
         times, so a leftover PLUS variant still has to answer for STG. */
      if(tier === 'STG')
        for(i = 0; i < vs.length; i++) if(vs[i].tier.indexOf('PLUS') === 0) return vs[i];
      return null;
    }
    function offeredTiers(){
      return TIER_ORDER.filter(function(id){ return !!variantFor(id); });
    }
    function availableSizes(){
      if(CFG.oneSize) return [];
      return stockedSizes().filter(function(s){ return s !== 'U'; });
    }
    /* Whether this garment can be SIZED FROM A BODY at all. 13 products carry
       measurements but no ease profile, and without a profile there is no
       ladder, nothing to resolve against, and no way to tell somebody what
       size they are. They are not broken and they are not out of scale: they
       are products the new flow cannot run on.

       So they fall back to the old one — the tier is asked outright and the
       size is picked by hand. That is worse, and it is exactly as good as it
       was yesterday, which is the point: adding the measurement step must not
       take a product off sale. */
    function hasLadder(){ return !CFG.oneSize && rungs().length > 0; }
    /* The rung the customer's own measurement lands on, or null while there is
       nothing to land. Everything about the flow hangs off this one answer. */
    function sizeHit(){
      if(!hasLadder()) return null;
      return resolveSize(bodyValue());
    }
    /* WHICH TIERS THIS CUSTOMER MAY BE OFFERED — not which the product sells.
       The difference is the whole redesign.

       An accessory has no size, so it is asked the only question it has: the
       colour, or the colour and the dimensions.

       A garment is asked nothing until it has been measured. Once it has:

         the size IS in the catalogue  → colour only, or colour and fit.
                                         New size is not offered, because there
                                         is nothing to develop — the size
                                         exists. This is Rule 1, moved forward
                                         from the price to the question: it
                                         used to be a silent downgrade AFTER
                                         somebody chose New size, and now the
                                         choice is simply never put in front of
                                         them.
         the size is NOT in the catalogue → New size, alone. Not offered as a
                                         choice either: with one answer there is
                                         no question, the step disappears and
                                         the customer is told what is happening
                                         rather than asked to work it out.

       Nothing is filtered in that the product does not sell: offeredTiers() is
       still the outer bound, so a garment with no ADJ variant offers colour
       only, and one with no STG variant offers nothing at all for a size it
       does not stock — which falls through to contact us, as it must. */
    function allowedTiers(){
      var all = offeredTiers();
      if(CFG.oneSize)
        return all.filter(function(id){ return id === 'COL' || id === 'DIM'; });
      /* NEW SIZE IS NEVER A TILE. 29/09/2026, and it is the rule the ladder
         branch below has always followed — this line was the one place that
         broke it.

         An STG variant does not mean "this product offers new sizes to
         choose from". It means the product CAN be developed, which the flow
         reaches on its own in exactly two ways: the measurement resolves to
         a size we do not stock, or an alteration goes past the house limit
         and outcome() re-prices it. Both are decisions the form makes and
         tells the customer about. Neither is a question.

         Offered as a tile it was a third thing entirely — an invitation to
         ask for a development nobody had established was needed — and on a
         product with no ladder it could not even be priced, so it ended on
         the contact block. That is a dead end dressed as a choice.

         So: COL and ADJ, and nothing else. STG stays available to the two
         automatic paths, and the 'noranges' stop in outcome() stays as the
         last line of defence for a hand-written URL. */
      if(!hasLadder())
        return all.filter(function(id){ return id === 'COL' || id === 'ADJ'; });
      var hit = sizeHit();
      if(!hit || !isOffered(hit.size)) return [];
      if(isStocked(hit.size))
        return all.filter(function(id){ return id === 'COL' || id === 'ADJ'; });
      return all.filter(function(id){ return id === 'STG'; });
    }

    /* ─────────── the whole outcome ───────────
       One function decides the tier actually charged, the size actually made,
       the price, and whether we can proceed at all. Everything on screen reads
       from it, so the rail, the cart and the debug panel cannot disagree. */
    function outcome(){
      var o = { tier:S.tier, size:S.size, resolved:null, downgraded:false,
                upgraded:false, extrapolated:false, stop:null, cents:null,
                raw:null, upliftPct:0, variantId:null };

      /* THE MEASUREMENT COMES FIRST, for every tier and not only for New size.
         It is what the flow is built on now: until it resolves there is no
         size, no list of things that can be done to it, and nothing to price.
         Rule 2 lives here too — out of scale and unpriced are both answered by
         the same sentence, because to the customer they are the same sentence. */
      if(hasLadder()){
        if(!bodyValue()){ o.stop = 'nochest'; return o; }
        var hit = resolveSize(bodyValue());
        if(!hit){ o.stop = 'oversize'; return o; }                    /* RULE 2 */
        if(!isOffered(hit.size)){ o.stop = 'unpriced'; return o; }    /* RULE 2 */
        o.resolved     = hit.size;
        o.extrapolated = !!hit.extrapolated;
      }

      if(!S.tier){ o.stop = 'notier'; return o; }
      if(!variantFor(S.tier)){ o.stop = 'nodata'; return o; }

      /* On New size the size is the resolved one and cannot be anything else.
         On the other tiers it is what the customer left selected — which STARTS
         as the resolved one and may be overridden, so what is charged is always
         what is on screen. */
      /* New size with nothing to resolve against is the one place a product
         without a ladder still has to stop and talk to us — the same dead end
         it reached before, reached the same way. */
      if(S.tier === 'STG' && !hasLadder()){ o.stop = 'noranges'; return o; }
      o.size = (S.tier === 'STG') ? o.resolved : S.size;

      /* RULE 1, kept as the last line of defence. allowedTiers() no longer lets
         STG be chosen for a size that is stocked, so this cannot fire from the
         screen — only from a hand-written URL, which is exactly what a last
         line of defence is for. */
      if(S.tier === 'STG' && o.size && isStocked(o.size) && variantFor('ADJ')){
        o.tier = 'ADJ'; o.downgraded = true;
      }

      /* AND THE SAME RULE THE OTHER WAY. A size we stock, asked for with a
         sleeve 15cm longer than we make, is not an alteration of that size —
         it is a garment nobody has cut before, and it costs what developing
         one costs. The tier the BODY resolved to is only half the question;
         this is the other half, and it is why the fit step comes before the
         price is final.

         Past houseLimit() from our standard on either axis, ADJ becomes STG.
         The SIZE does not change — they still get the size they picked — only
         what it costs to make it.

         NOT SILENT, unlike the downgrade above, and that is deliberate: this
         one takes money. The rail reads back the charged tier by name and the
         price moves with it, so the change announces itself in the two places
         the customer is already looking. Only where the product actually
         sells a STG variant; where it does not there is nothing to move to
         and it stays an alteration. */
      if(o.tier === 'ADJ' && variantFor('STG') &&
         fitMaxDelta(o.size) > houseLimit()){
        o.tier = 'STG'; o.upgraded = true;
      }

      /* AND WHERE THERE IS NOTHING TO MOVE TO, THE BOX CAPS — there is no
         'overfit' stop any more, 01/10/2026.

         It was a REFUSAL: on the 25 of 75 products that sell ADJ and no STG,
         a sleeve past the house limit was routed to the dialog. That put an
         ALTERATION through the door marked "we cannot make this size", and
         those are not the same thing. The size was already agreed; only the
         change to it went too far.

         So the fit box holds the figure to the limit instead — see capFit in
         the fit branch of body(), which is the same clamp the dimensions use
         and for the same reason. Past the limit there is always a furthest
         thing we will do, and that is what they get.

         Nothing is left here to guard: with the box capped, fitMaxDelta()
         cannot exceed the limit on a product with no STG, and on one that has
         STG the rule above has already re-priced it. */

      /* NO 'overdim' STOP, 30/09/2026, and the dimensions are the one place
         that is right.

         It was here for a day: past the house limit an accessory could not be
         priced, so it was refused and routed to the dialog exactly as Rule 2
         routes an out-of-scale body. That reasoning is sound for a BODY and
         wrong for a RECTANGLE. A chest past the last rung is a fact about a
         person and there is nothing to offer them but a conversation. A scarf
         20cm longer than we make is a fact about our own workshop, and there
         is always a nearest length we do make — so the answer is that length,
         not an email.

         So the box clamps on commit instead (see numField) and nothing here
         has to refuse anything.

         THE FIT STEP NOW DOES THE SAME, 01/10/2026 — it kept an 'overfit'
         stop for a day on the reasoning that a sleeve is not a scarf, and
         that was the wrong line to draw. The right one is what the figure IS:
         the main size is a body we either can or cannot dress, and the dialog
         belongs to that; an adjustment is a change to a size already agreed,
         so it is re-priced where there is a tier to re-price it to and capped
         where there is not. Both steps follow that rule now. */

      var v = variantFor(o.tier);
      if(!v){ o.stop = 'nodata'; return o; }
      o.variantId = v.id;
      o.upliftPct = (o.size != null && UPLIFT[o.size] != null) ? UPLIFT[o.size] : 0;
      /* variant.cents ALREADY carries the tier %. Only the size uplift is left.
         Cart Transform must round the same way — see the @TODO in BLOCK 2. */
      o.raw   = v.cents * (1 + o.upliftPct / 100);
      o.cents = roundPrice(o.raw);
      /* The personalisation is added AFTER the size rounding, never multiplied
         by it: the size uplift is a percentage of the garment and this is a
         flat charge for a separate piece of work. Cart Transform composes them
         in this order too, or the cart disagrees with the page. */
      o.persCents = persWanted() ? persUplift() : 0;
      o.cents += o.persCents;
      return o;
    }

    /* A request has no price of its own: the highest this product sells for
       (top tier, largest size uplift) is shown as the starting figure. */
    function reqFromCents(){
      var top = 0, pct = 0;
      (CFG.variants || []).forEach(function(v){ if(v.cents > top) top = v.cents; });
      for(var k in UPLIFT){
        var u = parseFloat(UPLIFT[k]);
        if(Object.prototype.hasOwnProperty.call(UPLIFT, k) && isFinite(u) && u > pct) pct = u;
      }
      return top ? roundPrice(top * (1 + pct / 100)) : null;
    }
    /* Cheapest tier, so the rail says something before anything is chosen. */
    function fromCents(){
      var vs = CFG.variants || [], min = null;
      for(var i = 0; i < vs.length; i++) if(min === null || vs[i].cents < min) min = vs[i].cents;
      return min;
    }

    /* ─────────── the model list ───────────
       IT ARRIVES IN THE ISLAND NOW, 01/10/2026 — see "list" in BLOCK 1. It is
       resolved by Liquid out of the custom_studio_index metaobject, so every
       row is a real Product: translated title, translated type, and the
       metafields the fetched list could never reach.

       products.json IS STILL THE FALLBACK and the shape is deliberately its
       own, so one of them can answer without BLOCK 4 knowing which did. That
       endpoint returns thirteen keys and no metafield, so on the fallback the
       rows simply lose the material and the gauge — see rowFacts().

       What used to be here and is not any more: a lazy fetch, a sessionStorage
       cache, a cache key that had to carry the locale (one key served every
       language, which is how an Italian page came to be holding an English
       list), and the loading / failed / empty states that existed only because
       a network call can be any of those. None of that is a state the island
       can be in. */
    /* ─── THE GENDER IS A KEY, NOT A WORD ───
       30/09/2026. product_type is TRANSLATED by Shopify, so the first segment
       reads "Women" in English, "Donna" in Italian and "Femme" in French —
       and every rule in this file that names a gender was written in English:
       WHO_ORDER, the Unisex sentinel in whoMatches(), and the route-2
       derivation that refuses to open the list on Unisex.

       None of those threw. They simply stopped matching, so on a translated
       storefront the genders came out in whatever order the catalogue
       happened to list them and a Unisex product belonged to neither list.

       So the raw word is mapped back to a canonical English KEY the moment it
       is read, and every comparison after that is between keys. STR.who is
       the map — it already holds the translated word for each key, because
       that is what it was built to print — so nothing new has to be
       maintained and no second table can fall out of step with it.

       AN UNKNOWN WORD IS RETURNED UNCHANGED, which is what keeps this safe: a
       gender nobody has translated, or a fifth one added tomorrow, behaves
       exactly as it did before — it filters, it labels itself, it simply gets
       no canonical ordering. Nothing disappears.

       IT ALSO MAKES `?who=` LOCALE-STABLE. The parameter now carries "Women"
       on every storefront rather than whatever the visitor's language calls
       it, so a link built on one locale still reads on another. The garment
       is NOT canonicalised — there is no map for it and it is only ever
       compared within one page — and go() already drops a category that
       matches nothing on arrival. */
    function whoOf(p){ return whoKey((p.product_type || '').split('>')[0]); }
    function garmentOf(p){
      var s = (p.product_type || '').split('>');
      return s[s.length - 1].trim();
    }
    /* Unisex is a property, never a destination: those products belong to both
       lists rather than to a third one. */
    function whoMatches(p, who){
      var w = whoOf(p);
      if(w === 'Unisex') return who === 'Women' || who === 'Men';
      return w === who;
    }
    function whoLabel(w){ return STR.who[w] || w; }

    var listPromise = null;
    function getJSON(u){
      return fetch(u, { headers:{ 'Accept':'application/json' } }).then(function(r){
        /* A 404 returns an HTML page, and r.json() on it throws a parse error
           that reads like a data problem. Fail on the status instead. */
        if(!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }
    function loadList(){
      if(listPromise) return listPromise;

      /* THE ISLAND, WHERE THERE IS ONE. Synchronous, so the Modello step draws
         the models on its first render rather than drawing "loading" and then
         replacing itself — go() is called again by the old fetch path purely
         to repaint, and there is nothing to repaint here.

         A promise anyway, so the one caller does not have to know which source
         answered.

         LENGTH, NOT EXISTENCE. An empty array is what a section renders when
         the metaobject is missing, unpublished, or has not been synced yet —
         exactly the states the fallback is for. Treating [] as an answer would
         serve an empty catalogue and never ask products.json at all. */
      if(CFG.list && CFG.list.length){
        S.list = CFG.list;
        listPromise = Promise.resolve(S.list);
        return listPromise;
      }

      var cached = null;
      try { cached = sessionStorage.getItem(CFG.listKey); } catch(e){}
      if(cached){
        try {
          var c = JSON.parse(cached);
          /* Never trust a cached empty list. It is what an unpublished
             collection returns, and caching it means the page keeps showing
             "nothing here" for the rest of the session even after the cause is
             fixed. An empty answer is cheap to ask for again. */
          if(c && c.products && c.products.length){
            S.list = c.products;
            listPromise = Promise.resolve(S.list);
            return listPromise;
          }
        } catch(e){}
      }

      listPromise = getJSON(CFG.listUrl)
        .then(function(d){ return (d && d.products) || []; })
        .catch(function(){ S.listErr = true; return []; })
        .then(function(list){
          S.list = list;
          if(list.length){
            try {
              sessionStorage.setItem(CFG.listKey, JSON.stringify({ products:list }));
            } catch(e){}
          }
          return list;
        });
      return listPromise;
    }
    /* WHAT THE MODEL LIST SHOWS: the whole catalogue, narrowed by the gender
       and the category and by nothing else. See the block above filterBar()
       for the reasoning and for the other three decisions that go with it.

       THE TIER IS NOT ONE OF THEM, and that is the part worth stating here
       rather than leaving to the absence of a line. It used to be, and it
       meant anyone who walked forward and came back was browsing 58 of the
       74 styles with nothing on screen saying so. A tier is a question about
       the garment you CHOSE — the flow already re-prices or refuses one the
       garment cannot honour, a step later, with the answer in front of you.

       If it ever has to come back, the tier lives in variants[].title and
       the development tier answers to TWO spellings: STG, and PLUS1..PLUS4
       from before it was renamed. Both are still in the catalogue.

       `ignore` lets a control count the pool as it would be WITHOUT its own
       filter, which is what puts the numbers in the dropdowns. */
    function pool(ignore){
      return (S.list || []).filter(function(p){
        if(ignore !== 'who'     && S.who     && !whoMatches(p, S.who))        return false;
        if(ignore !== 'garment' && S.garment && garmentOf(p) !== S.garment)   return false;
        return true;
      });
    }

    /* Picking a model is NAVIGATION, not a state change: each custom product
       keeps its own URL, its own metafields and its own maps. Everything worth
       carrying travels in the query string — including the SIZE.

       It used to be left out, on the grounds that a size means nothing on
       another garment. That was half right and cost more than it saved: the
       same link is what syncUrl writes back over the address bar, so a plain
       refresh of the product you were already on lost the size while keeping
       the tier, the colour and the measurements.

       A size label travels perfectly well: L is L, and the guard at the top of
       go() drops it the moment the product on screen does not sell it. So it
       is carried everywhere and checked on arrival, which is the same contract
       `tier` and `col` already had. */
    function linkTo(handle){
      var q = [];
      if(S.who)     q.push('who='     + encodeURIComponent(S.who));
      if(S.garment) q.push('garment=' + encodeURIComponent(S.garment));
      if(S.tier)    q.push('tier='    + encodeURIComponent(S.tier));
      /* ONLY WHEN IT WAS CHOSEN — see sizePicked. A suggested size is left
         out on purpose: the measurements are in the link already, so it comes
         back by being worked out again rather than by being remembered, and
         it cannot arrive stale on a product whose ladder resolves differently. */
      if(S.size && S.sizePicked) q.push('size=' + encodeURIComponent(S.size));
      if(S.color)   q.push('col='     + encodeURIComponent(S.color));
      /* Always the canonical centimetres, whatever the boxes are showing.
         BOTH ROUNDS: they are measurements of the person, so they are the one
         thing that is just as true on the next garment as on this one, and
         carrying them means the model list can be browsed without being asked
         for a chest again on arrival. */
      ALL_MEAS.forEach(function(k){
        if(S.meas[k]) q.push(k + '=' + encodeURIComponent(S.meas[k]));
      });
      /* Same contract as `size`: carried everywhere, checked on arrival. A
         dimension the accessory you land on cannot take is dropped in go(). */
      DIM_KEYS.forEach(function(k){
        if(S.dim[k]) q.push('dim_' + k + '=' + encodeURIComponent(S.dim[k]));
      });
      PERS_KEYS.forEach(function(k){
        if(S.pers[k]) q.push('p_' + k + '=' + encodeURIComponent(S.pers[k]));
      });
      if(S.pers.on === true)  q.push('p_on=1');
      else if(S.pers.on === false) q.push('p_on=0');
      /* Only when it is not what this market would have chosen anyway. */
      if(S.unit !== defaultUnit()) q.push('u=' + S.unit);
      q.push('r=' + S.route);
      if(DEBUG) q.push('debug=1');
      /* rootUrl is '/' on the primary locale and '/en-it' on the others. */
      var base = (CFG.rootUrl || '/').replace(/\/$/, '');
      return base + '/products/' + handle + (q.length ? '?' + q.join('&') : '');
    }
    /* Keep the address bar honest without reloading, so a refresh or a shared
       link lands on the same configuration. */
    function syncUrl(){
      if(!window.history || !window.history.replaceState) return;
      /* ─── BROWSE MODE KEEPS A HASH, NOT A PATH ───
         linkTo() builds /products/<handle>, and on a collection template
         there is no handle — so writing one here would quietly rewrite the
         address bar from the collection to "/products/" the moment anything
         rendered, and a refresh would 404.

         There is no configuration to restore on that page either. There is
         one thing worth keeping and it is the gender: clear it from the
         dropdown and the hash the button wrote is suddenly a lie, so a
         refresh would put back a filter somebody had just taken off. Hence
         `#studio` — the same door, open, with nothing filtered.

         replaceState and never push, so the one entry the button pushed is
         the only one in the history: Back goes to the hero rather than
         walking out through every filter change on the way.

         CLOSED MEANS DON'T TOUCH IT. With the hero up there is no studio to
         describe, and writing a hash would make the address bar claim
         otherwise. The Theme Editor is left alone for the same reason — the
         preview's URL is Shopify's, not ours. */
      if(CFG.browse){
        if(!studioIsOpen()) return;
        if(window.Shopify && window.Shopify.designMode) return;
        var h = S.who ? '#who=' + encodeURIComponent(S.who) : '#studio';
        if(h !== window.location.hash)
          window.history.replaceState(null, '',
            window.location.pathname + window.location.search + h);
        return;
      }
      var to = linkTo(CFG.handle);
      if(to !== window.location.pathname + window.location.search)
        window.history.replaceState(null, '', to);
    }

    /* ══════════════════════════════════════════════════════════════════════
       COLOUR ENGINE — verbatim from the tuner. The six masks are baked per
       product and drive fold, detail, alpha, label and hardware; the colour
       itself is a tint, not a paint bucket.

       Two theme-only changes from the prototype, both required:
         · crossOrigin — the masks come from the Shopify CDN now, and without
           it getImageData taints the canvas and throws.
         · nothing is fetched until a colour is actually picked, so six mask
           downloads never compete with the hero image for bandwidth.
       ══════════════════════════════════════════════════════════════════════ */
    /* ─── NOTHING HERE EXISTS IN BROWSE MODE ───
       01/10/2026. The section renders on a COLLECTION template too, with no
       product behind it, and there it is only the model list: no photograph,
       no colours, no price, no cart. BLOCK 2 gates the stage and the cart on
       `{% if product %}`, so every element below is simply absent.

       Guarded rather than branched, and the distinction matters: there is no
       "browse mode" switch anywhere in this file. visible() already answers
       every question correctly from an island with no product data —
       activeSteps() collapses to ['prod'] on its own, because a step with
       nothing to ask does not appear. That was true before this change and is
       what makes the whole thing cost six guards instead of a second
       implementation.

       So all that is needed is that the handful of lines which reach for the
       stage and the cart do not throw when they are not there. Everything
       downstream of them is already unreachable: paint() is only called with
       a colour, and there are no colours. */
    var cv = $('[data-canvas]'), ctx = cv ? cv.getContext('2d') : null;
    var poster = $('[data-poster]'), capnote = $('[data-capnote]');
    /* The same colour name in the theme's badge shape, for the narrow layout.
       Only one of the two is ever on screen — which one is pure CSS — so both
       are written and both are hidden together. */
    var colbadge = $('[data-color-badge]'), colbadgeT = $('[data-color-badge-t]');
    var buf = document.createElement('canvas'); buf.width = W; buf.height = H;
    var bctx = buf.getContext('2d', { willReadFrequently:true });
    var out = bctx.createImageData(W, H);
    var D = null, cur = { hex:'#808080' }, mapsPromise = null, hasRendered = false;

    function hx(h){
      h = String(h || '').replace('#','');
      if(h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      return [parseInt(h.slice(0,2),16) || 0, parseInt(h.slice(2,4),16) || 0, parseInt(h.slice(4,6),16) || 0];
    }
    function ch(img){
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
      var d = x.getImageData(0, 0, W, H).data, a = new Float32Array(N);
      for(var i = 0; i < N; i++) a[i] = d[i*4] / 255;
      return a;
    }
    function rgbOf(img){
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
      return x.getImageData(0, 0, W, H).data;
    }
    function loadImg(u){
      return new Promise(function(res, rej){
        if(!u) return rej();
        var i = new Image();
        i.crossOrigin = 'anonymous';
        i.onload = function(){ res(i); };
        i.onerror = rej;
        i.src = u;
      });
    }
    function loadMaps(){
      if(mapsPromise) return mapsPromise;
      var m = CFG.maps || {};
      mapsPromise = Promise.all([
        loadImg(m.fold), loadImg(m.detail), loadImg(m.alpha),
        loadImg(m.label), loadImg(m.base), loadImg(m.hardware), loadImg(m.poster)
      ]).then(function(im){
        return { fold:ch(im[0]), detail:ch(im[1]), alpha:ch(im[2]),
                 label:ch(im[3]), base:ch(im[4]), hardware:ch(im[5]), orig:rgbOf(im[6]) };
      });
      return mapsPromise;
    }
    function render(p){
      var ds = D; if(!ds || !ctx) return;
      var d = out.data, fo = ds.fold, de = ds.detail, al = ds.alpha,
          lb = ds.label, ba = ds.base, hw = ds.hardware, orig = ds.orig;
      var col = hx(cur.hex), r = col[0], g = col[1], b = col[2];
      var tLum = (0.299*r + 0.587*g + 0.114*b) / 255;
      var fD = p.fold/100, dD = p.detail/100,
          con = p.contrast/100 * (1 + 1.2*(1 - tLum)), sh = p.sheen/100, sd = p.shadow/100;
      for(var i = 0; i < N; i++){
        var fold = 0.40 + fo[i]*0.90, det = -0.20 + de[i]*0.40;
        var dev = ((fold - 1)*fD + det*dD) * con, s = 1 + dev;
        if(s < 0.5) s = 0.5; if(s > 1.12) s = 1.12;
        var R = r*s, Gr = g*s, B = b*s;
        if(s > 1 && sh > 0){ var add = sh*(s - 1)*255; R += add; Gr += add; B += add; }
        var lum = 0.299*R + 0.587*Gr + 0.114*B, ss = 0;
        if(s < 0.9) ss = (0.9 - s)/0.5;
        if(s > 1.0){ var hsx = (s - 1.0)/0.12; if(hsx > ss) ss = hsx; }
        ss = Math.min(1, ss)*sd;
        R += (lum - R)*ss; Gr += (lum - Gr)*ss; B += (lum - B)*ss;
        var lm = lb[i];
        if(lm > 0){ var gg = ba[i]*255; R = R*(1-lm) + gg*lm; Gr = Gr*(1-lm) + gg*lm; B = B*(1-lm) + gg*lm; }
        if(hw){
          var hm = hw[i];
          if(hm > 0 && orig){
            var oR = orig[i*4], oG = orig[i*4+1], oB = orig[i*4+2];
            R = R*(1-hm) + oR*hm; Gr = Gr*(1-hm) + oG*hm; B = B*(1-hm) + oB*hm;
          }
        }
        var a = al[i];
        d[i*4] = R; d[i*4+1] = Gr; d[i*4+2] = B; d[i*4+3] = a*255;
      }
      bctx.putImageData(out, 0, 0);
      blit();
      hasRendered = true;
      /* The styling shot wins while it is up: a colour picked behind it is
         remembered and appears when the main photo comes back. */
      if(S.view === 'main'){
        if(cv) cv.hidden = false;
        if(poster) poster.style.visibility = 'hidden';
      }
    }
    function blit(){
      if(!cv || !ctx) return;
      var cssW = cv.clientWidth || W, dpr = window.devicePixelRatio || 1;
      var pxW = Math.round(cssW*dpr), pxH = Math.round(pxW*H/W);
      if(cv.width !== pxW || cv.height !== pxH){ cv.width = pxW; cv.height = pxH; }
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.clearRect(0, 0, pxW, pxH);
      ctx.drawImage(buf, 0, 0, pxW, pxH);
    }
    function toP(s){
      s = s || {};
      return { fold:(s.fold||0)*100, detail:(s.detail||0)*100, contrast:(s.contrast||0)*100,
               sheen:(s.sheen||0)*100, shadow:(s.shadow||0)*100 };
    }
    function paint(c){
      cur.hex = (c.settings && c.settings.hex) || c.hex || '#808080';
      var label = c.name + (c.code ? ' ' + c.code : '');
      if(capnote) capnote.textContent = label;
      if(colbadgeT) colbadgeT.textContent = label;
      loadMaps().then(function(d){ D = d; render(toP(c.settings)); })
                .catch(function(){
                  /* No masks, or one failed: the flat swatch colour is still the
                     truth about the colour. Falling back to the poster is better
                     than an empty stage. */
                  if(cv) cv.hidden = true;
                  if(poster && S.view === 'main') poster.style.visibility = 'visible';
                });
    }
    function colorByCode(code){
      for(var i = 0; i < COLORS.length; i++) if(COLORS[i].code === code) return COLORS[i];
      return null;
    }

    /* ══════════════════════════════════════════════════════════════════════
       STEPS
       visible() is the whole flow logic: a step that has nothing to ask does
       not appear, and no step is ever shown disabled.
       ══════════════════════════════════════════════════════════════════════ */
    function visible(id){
      /* Round one, asked of every GARMENT before anything else — and of
         nothing else. A scarf, a hat, a pair of gloves has no body to resolve
         against and is never asked: it goes straight to the question of what
         it wants changed. hasLadder covers the products we can size; the chart
         covers the ones we cannot but which are still worn on a torso, so they
         can still reach the contact block. */
      if(id === 'meas')  return !CFG.oneSize && (hasLadder() || hasBodyChart());
      /* A QUESTION, not a menu. It is drawn only when there is more than one
         answer — which means it is skipped entirely both before the customer
         has been measured (nothing can be offered yet) and when the size they
         resolved to is not one we stock (New size is the only answer, and go()
         has already selected it). */
      if(id === 'tier')  return allowedTiers().length > 1;
      /* Only where a size can be CHOSEN. New size has no picker: its size is
         the one the measurement resolved to. */
      if(id === 'size')  return (S.tier === 'COL' || S.tier === 'ADJ') && availableSizes().length > 0;
      /* Round two, for both paths that end in something being made to order.
         The chart decides which axes exist; a product with no chart at all is
         not asked, and is made to its standard. */
      if(id === 'fit')   return (S.tier === 'ADJ' || S.tier === 'STG' || requestMode()) && fitAxes().length > 0;
      /* Accessories, and only where we can state a standard to depart from. */
      if(id === 'dim')   return S.tier === 'DIM' && !!dimStd();
      if(id === 'color') return COLORS.length > 0;
      /* Offered wherever the product carries an option, on every tier — a
         lettering is not a fit decision and does not care which tier is being
         bought. Last in the order because it is the only optional step, and
         because an intarsio colour is paired with the garment colour, which is
         chosen immediately before it. */
      if(id === 'pers')  return !!pers();
      if(id === 'req')   return requestMode();
      return true;
    }
    function activeSteps(){ return STEP_ORDER.filter(visible); }

    /* HAS THIS STEP BEEN ANSWERED. Continue advances, and a button that
       advances past a question nobody answered is not a convenience — it is
       how somebody ends up at the end of the flow with no size.

       Optional steps count as answered when they are left alone, because
       leaving them alone IS the answer: an untouched round-two box means "make
       it your standard length", and no personalisation is the normal case.
       It is the one thing that can be half done — text typed, colour not
       picked — and persComplete() is already the test for that, the same one
       the add-to-cart button uses, so the two cannot disagree. */
    function stepAnswered(id){
      /* A STOP DOES NOT DEAD-END THE FLOW, 30/09/2026 — and this line used to
         say it did. `if(contactStop()) return false;` sat here, so out of
         scale, unpriced, past the fit limit or past the dimensions limit all
         killed Continue outright.

         That was the wrong instrument for the thing it was asked to do. What
         was wanted is that Continue cannot be pressed WHILE THE DIALOG IS UP,
         and showModal() already guarantees that for nothing: everything
         outside the <dialog> is inert while it is open, so the button cannot
         be clicked however it is styled. Nothing here has to enforce it.

         What the line actually did was strand somebody on a reload. The stop
         is restored with the measurement, the dialog is deliberately not
         shown on arrival, and the button was grey with no reason on screen —
         a page that had simply stopped. Walking on is the reasonable thing to
         do: read the rest, look at the colours, go back and try another
         figure.

         NOTHING IS SOLD THIS WAY. ready() still opens with `if(o.stop ...)`,
         so Add to bag stays dead for exactly these reasons, and that is the
         guard that matters — it is the one standing between a piece we have
         not agreed to make and an order for it. Continue only moves the
         screen. */
      if(id === 'meas')  return measComplete();
      if(id === 'fit')   return fitAnswered();
      if(id === 'tier')  return !!S.tier;
      if(id === 'size')  return !!S.size;
      if(id === 'dim')   return dimEntries().length > 0;
      if(id === 'color') return !!S.color;
      if(id === 'pers')  return persComplete();
      if(id === 'req')   return reqReady();
      return true;
    }

    /* ─── THE HOUSE LIMIT IN WORDS ───
       One figure, one function, quoted in three places: the ADJ tile's capped
       subtitle, the New dimensions tile, and the lede on the dimensions step.
       They read from here so they cannot print different numbers, and it is
       computed rather than typed into a locale file because a hardcoded
       "7 cm" stayed 7 cm for somebody working in inches.

       IT ROUNDS DOWN, and that is the opposite of tolText() a few lines up —
       deliberately, because the two state opposite kinds of promise.

         tolText   how far WE may miss the figure asked for. Over-stating is
                   safe: a wider tolerance is one we can always keep.
         this      how far THEY may go from our standard, and it is ENFORCED —
                   the dimension boxes refuse a figure past it and a garment
                   past it is re-priced or refused outright.

       So 7 cm is 2.756 in, and rounding it up to 2.8 or 3 advertises an inch
       and a bit that the form will turn down. Floored to the half unit it
       reads "2.5 in", which is a little less than the truth and never a lie.

       Half units rather than decimals because a figure a customer is asked
       to work within should be one they can picture. In centimetres the
       setting is a whole number already (the section's range has step 1), so
       this is a no-op there and 7 stays 7. */
    function limitFigure(){
      var n = parseFloat(fromCanonical('length', houseLimit()));
      if(!isFinite(n)) return '';
      return String(Math.floor(n * 2) / 2);
    }
    function tierLimit(){
      return limitFigure() + ' ' + unitLabel('length');
    }
    function tiles(ids, sel, onPick){
      var g = el('div','mcfg__tiles');
      ids.forEach(function(id){
        var def = STR.tiers[id] || { label:id, sub:'' };
        var b = el('button','mcfg__tile'); b.type = 'button';
        b.setAttribute('aria-pressed', sel === id ? 'true' : 'false');
        b.appendChild(el('span','mcfg__tt', def.label));
        /* WHICH SENTENCE IS TRUE OF THIS PRODUCT. Fit adjustments carry two,
           because past the house limit two different things happen and the
           tile is the only place the customer is told before they type:

             sells STG        -> a bigger change is allowed, priced as a new
                                 size. No cap to state, so `sub` names no
                                 figure.
             does not sell it -> a bigger change is REFUSED (see outcome()),
                                 so `subCapped` states the limit and somebody
                                 is spared typing a number that gets turned
                                 down.

           Off variantFor('STG'), the same test the rule itself uses, so the
           tile and the outcome cannot tell different stories.

           {v} is filled either way and simply goes unused by a sentence that
           does not mention it — which is also why New dimensions needs no
           special case: there the limit really is a bound and its one
           subtitle says so. */
        /* ─── THE FIT TILE NAMES WHAT IT WOULD CHANGE ───
           30/09/2026, and it is the same fix the fit step's lede already
           had: one sentence for every garment has to be vague enough to be
           true of all of them, which meant this tile offered a pair of
           trousers the chance to alter their sleeves.

           fitAxes() is what the chart says this garment HAS, and it is one or
           two. So the tile picks between TWO WHOLE SENTENCES on that count,
           exactly as fitLede / fitLedeBoth do — not one sentence with a
           clause bolted on, because the difference between them is a list and
           languages do not put lists in the same place.

           WHICH MAKES FOUR STRINGS FOR THIS TILE, and they are two questions
           crossed rather than four decisions:

                          one axis        two axes
             sells STG    sub             subBoth
             does not     subCapped       subCappedBoth

           The rows are the house limit — whether a bigger change is priced
           up or refused, see outcome(). The columns are the garment. Every
           one of them falls back to the string to its left, so a locale file
           that has only the two it had yesterday reads the shorter sentence
           rather than nothing.

           {a} and {b} are the two fields' own translated labels — the same
           pair the lede gets — so the sentence can name them or not. */
        var sub = def.sub, axesT = [];
        if(id === 'ADJ'){
          axesT = fitAxes();
          var bothT = axesT.length > 1;
          if(!variantFor('STG') && def.subCapped){
            sub = (bothT && def.subCappedBoth) ? def.subCappedBoth : def.subCapped;
          } else if(bothT && def.subBoth){
            sub = def.subBoth;
          }
        }
        /* {v} MEANS WHAT THE TILE NEEDS IT TO MEAN. On the two fit tiers it
           is the house limit — the centimetres past which this stops being an
           alteration — and on Solo colore there is no limit to state, so it is
           the number of colours instead. Each tier has its own string and only
           ever sees one of the two, so nothing is ambiguous in the locale
           file. {n} is the colour count on every tile, for a translation that
           wants to say both. */
        /* Solo colore is the one tile whose figure is a COUNT rather than a
           measurement, so it is the one with a singular twin. The fit tiers
           quote a limit in centimetres, which needs none. */
        if(sub) b.appendChild(el('span','mcfg__ts',
          (id === 'COL')
            ? tN(sub, def.sub1, COLORS.length, { v: COLORS.length })
            : t(sub, { v: tierLimit(), n: COLORS.length,
                       a: measLabel(axesT[0] || ''),
                       b: measLabel(axesT[1] || '') })));
        /* ─── PICKING, NOT TOGGLING ───
           05/10/2026, and it is the same change the SIZE tiles were given
           for the same reason — see the size step, which already says
           "clicking the selected one to clear it only ever left the
           configuration incomplete". This step never got it.

           IT TOGGLED: clicking the tile that was ALREADY selected cleared
           the tier. That is a natural thing to do — a form asks what you
           want, you press the thing you want — and it put the step into a
           state with no answer in it. Continue then greys out, and the only
           way forward is to press a tile, with Solo colore sitting first.

           ORDER 249511 IS WHY. A prefilled link opened on Modifica
           vestibilità and the order arrived as Solo colore, with the two
           fit lengths dropped (visible('fit') is false on COL, so
           fitEntries() posts nothing). The piece that was configured is not
           the piece that was made, and nothing on the way through said so.

           There is no answer to un-say here. The step is only drawn when
           there is more than one tier to choose between, so there is always
           something selected and deselecting is never what anybody meant.
           A tier can still be CLEARED — go() drops one the measurement
           rules out — but that is the flow deciding, not a stray click. */
        b.addEventListener('click', function(){ onPick(id); });
        g.appendChild(b);
      });
      return g;
    }

    /* Two controls, both of which can SET as well as unset.
       They used to be removable chips, which meant dropping Donna left no way
       of asking for Uomo — the only path back was reloading the page. A filter
       you can only take off is not a filter. */
    var WHO_ORDER = ['Women','Men','Lifestyle'];

    function selectEl(options, current, onPick){
      var sel = document.createElement('select');
      sel.className = 'mcfg__fsel';
      options.forEach(function(o){
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = o.label;
        if(current === (o.value || null)) opt.selected = true;
        sel.appendChild(opt);
      });
      sel.addEventListener('change', function(){ onPick(sel.value || null); });

      /* The house caret in place of the browser's. Only when the asset is
         actually there: without it the select keeps its native arrow, which
         is worse-looking but never invisible. The icon is inert — the click
         goes through it to the select underneath. */
      var arrow = CFG.icons && CFG.icons.arrow;
      if(!arrow) return sel;
      var wrap = el('span','mcfg__selwrap');
      var ic = el('span','mcfg__caret svg-wrapper');
      ic.innerHTML = arrow;
      wrap.appendChild(sel);
      wrap.appendChild(ic);
      return wrap;
    }

    /* ═══════════════════════════════════════════════════════════════════
       HOW THE MODEL LIST FILTERS — settled 29/09/2026, one way

       After a run of "sometimes it filters and sometimes it does not". There
       is no switch here and nothing to remember: the behaviour below IS the
       behaviour, and changing it means changing the code, which is the point.
       Everything about browsing is decided in this function and in pool();
       nothing about it is decided anywhere else.

       THE RULE, in one line: the list is the whole catalogue, narrowed only
       by the two questions the visitor was actually asked, and it is always
       one click back to all of it.

       1. TWO FILTERS, GENDER AND CATEGORY. The tier is not one of them — see
          pool(). The funnel asks these two in this order and so does this bar.

       2. A FILTER THAT IS ON ALWAYS HAS ITS CONTROL ON SCREEN. Each dropdown
          is drawn when it has a choice to offer OR when a choice is already
          in force. Drawn only on the first of those, a control could vanish
          exactly when it was the one thing that would have undone the filter
          — narrow to a gender whose products are all one category and the
          category dropdown is gone with the category still applied. Worst on
          a cold landing, which derives a gender from the product and has no
          "Modifica" in the rail, so the dropdown is the only exit.

       3. THE TWO REMEMBER EACH OTHER. Changing the gender keeps the category,
          because somebody looking at cardigans who switches to Uomo wants
          men's cardigans, not the whole men's catalogue. It cannot strand
          anybody: go() drops a category with nothing filed under it in the
          gender now selected, on the render the change triggers.

       4. ONE BUTTON CLEARS BOTH, beside the dropdowns, drawn only when there
          is something to clear.

       WHAT IS NOT PART OF THIS, and is easy to mistake for it:
         · "Back to <garment>" restores the filters the visitor ARRIVED with,
           which on a cold landing is a gender. It is not a clear.
         · "Modifica" in the rail clears everything AND ends the search, but
           it is route 1 only — a cold landing never sees it.
       ═══════════════════════════════════════════════════════════════════ */
    function filterBar(){
      var bar = el('div','mcfg__fbar');

      /* Gender. Counted with whoMatches, so a Unisex product is counted under
         both Donna and Uomo rather than getting a list of its own. */
      var wp = pool('who');
      var whos = WHO_ORDER.filter(function(w){
        return wp.some(function(q){ return whoMatches(q, w); });
      });
      uniq(wp.map(whoOf)).forEach(function(w){
        if(w !== 'Unisex' && whos.indexOf(w) < 0) whos.push(w);
      });
      /* More than one gender to choose from, OR one already chosen — see
         decision 2. Never both hidden and applied. */
      if(whos.length > 1 || S.who){
        var wopts = [{ value:'', label:t(STR.allGenders, { n:wp.length }) }];
        whos.forEach(function(w){
          wopts.push({
            value: w,
            label: whoLabel(w) + ' (' + wp.filter(function(q){ return whoMatches(q, w); }).length + ')'
          });
        });
        bar.appendChild(selectEl(wopts, S.who, function(v){
          /* Decision 3: the category is NOT cleared here. go() drops one
             that has nothing filed under it in the gender now selected, so
             keeping it cannot strand anybody. To go back, put
             `S.garment = null;` on the line below. */
          S.who = v; S.searched = true; go();
        }));
      }

      /* Category, within whatever gender is selected. */
      var ps = pool('garment');
      var gs = uniq(ps.map(garmentOf)).sort();
      /* Same rule as the gender above, and this is the one that stranded a
         visitor who had narrowed to a gender with a single category. */
      if(gs.length > 1 || S.garment){
        /* PRODUCTS, not categories, and that is the fix of 28/09/2026. It
           counted gs.length — how many entries were in the dropdown — while
           every other row in this bar counts PRODUCTS: "Men (22)" is 22
           garments, "Cardigan (3)" is 3 garments, and "All categories (10)"
           was 10 CATEGORIES sitting in the same row as them. Two numbers
           beside each other meaning different things is worse than either
           one being absent.

           ps is already the pool with the gender applied, so this is the
           same figure the gender's own row shows — All genders and All
           categories now agree, which is what "all" ought to mean. */
        var gopts = [{ value:'', label:t(STR.allCategories, { n:ps.length }) }];
        gs.forEach(function(g){
          gopts.push({
            value: g,
            label: g + ' (' + ps.filter(function(q){ return garmentOf(q) === g; }).length + ')'
          });
        });
        bar.appendChild(selectEl(gopts, S.garment, function(v){
          S.garment = v; S.searched = true; go();
        }));
      }

      /* Decision 4, and it is the only control on this bar that is about
         BOTH filters. The dropdowns clear one each, which is two gestures
         and a number nobody has seen yet — "All genders (12)" counts inside
         the category still set, so the size of the catalogue does not appear
         until the second one is cleared. This says it outright.

         DRAWN ONLY WHEN THERE IS SOMETHING TO CLEAR. On the full list it
         would be a button that does nothing, sitting beside two controls
         that do.

         NOT "Back to <garment>", which is a few lines further down and reads
         as though it might be the same thing: that one restores the filters
         the visitor ARRIVED with — on a cold landing, a gender — and ends
         the search. This one goes to everything and leaves them browsing. */
      /* WHENEVER A FILTER IS ON, 30/09/2026. It was `S.searched && …`, on
         the reasoning that in the pinned-style view the filters are a way IN
         to browsing rather than something the visitor has done, so offering
         to clear them offers to undo a search nobody started.

         That held while the rail carried the criteria chips and "Modifica",
         which was the other way back. The chips are gone, so this is the ONLY
         reset on the screen — and S.searched does not survive a page load by
         design, so after any reload the dropdowns stood there with a gender
         applied and nothing beside them to take it off.

         A filter that is ON always has the control that clears it, which is
         the same rule the two dropdowns already follow two blocks up. */
      /* ─── ON THE LANDING PAGE IT IS A DIFFERENT BUTTON ───
         02/10/2026. Same control, same place, same metrics — and a job that
         is one size larger, so it says so.

         On a product page this clears both filters and leaves you browsing,
         because it is the ONLY reset on screen. On the landing page it is
         not: the gender dropdown carries its own "All genders" row, which is
         the widen. What that page has no control for is LEAVING — Back is a
         browser button, not something on the screen — so this becomes the
         way back to the hero and its three gender buttons.

         DRAWN WHETHER OR NOT A FILTER IS SET, unlike the product page's
         version, because its reason for existing is no longer "something is
         filtered". You can always leave.

         AND IT FALLS BACK. No back_to_studio key means a section not yet
         redeployed beside this file, and the button is then exactly what it
         was yesterday rather than a control with no words on it. */
      /* ...EXCEPT THE GENDER THE PAGE GAVE ITSELF, 09/10/2026. The rule above
         is right about filters the VISITOR set and wrong about the one they
         did not: route 2 derives S.who from the product a few hundred lines
         up — `if(S.route === 2 && !S.who && cfgWho ...)` — precisely so the
         model list opens on the right gender, and the comment on S.searched
         calls that out as "the page being helpful, not the visitor
         searching". Reading it as a filter put the button on nearly every
         product page from the first paint, offering to undo the page's own
         gender. Not a reload bug: a cold landing did it too.

         MEASURED AGAINST ARRIVED, not against S.searched. ARRIVED is captured
         right after that derivation and before anything on screen can touch
         either value, so "the visitor changed something" is a comparison
         rather than a flag — it cannot fall out of step on a reload, which is
         the exact failure that made 30/09 loosen this in the first place.
         After a reload the gender is derived again, equals ARRIVED again, and
         the button correctly stays away: there is nothing to put back.

         The garment counts on its own. On route 2 it starts null, so setting
         it is always the visitor; on a funnel arrival it is what the funnel
         chose, and that IS a search — just one made on the previous screen.

         Still the full reset the note at "Modifica" describes: whenever a
         filter the visitor applied is on, the control that clears it is
         there. Only the page's own opening state hides it, where "reset"
         would mean nothing. */
      var isExit  = !!(CFG.browse && STR.backToStudio);
      var touched = !!S.garment || (S.who !== ARRIVED.who);
      if(isExit || (touched && STR.clearFilters)){
        var clear = el('button','mcfg__fclear');
        clear.type = 'button';
        /* TWO LABELS, ONE BUTTON, and CSS picks. Side by side there is room
           for the sentence and it says what it does; on a phone the bar is
           two dropdowns wide already and a third full-width control pushed
           them into a third row — so there it shrinks to a cross.

           BOTH ARE ALWAYS IN THE MARKUP and the stylesheet hides one, rather
           than JS choosing: go() does not re-run on every resize, only on one
           that crosses the breakpoint, and a button that had to be rebuilt to
           change shape would be the wrong shape in between.

           aria-label carries the WORDS at both widths, so the cross is never
           a bare glyph to a screen reader, and title gives the same on hover. */
        /* No {n} on the exit: it names a destination, not a number. */
        var clearWords = isExit ? t(STR.backToStudio)
                                : t(STR.clearFilters, { n: (S.list || []).length });
        clear.appendChild(el('span','mcfg__fclear-t', clearWords));
        /* THE HOUSE CROSS, the same asset the search field's reset button
           uses — it comes through the island because BLOCK 4 holds no Liquid
           and inline_asset_content cannot run here. A typed × is the fallback
           and is not a lesser one: it is the same mark in the same place, set
           in the page's own face, for the case where the file is not in
           assets/ or has been renamed. */
        var x = el('span','mcfg__fclear-x svg-wrapper');
        if(CFG.icons && CFG.icons.close) x.innerHTML = CFG.icons.close;
        else x.textContent = '×';
        clear.appendChild(x);
        clear.setAttribute('aria-label', clearWords);
        clear.title = clearWords;
        clear.addEventListener('click', function(){
          if(isExit){ closeStudio(); return; }
          S.who = null; S.garment = null; S.searched = true; go();
        });
        bar.appendChild(clear);
      }
      return bar;
    }

    /* ─── ASK FOR THE SIZE WE ARE GOING TO DRAW ───
       products.json hands back the FULL-SIZE image — 1200px and up — and the
       row draws it at 46 x 58. The browser will do that, and it does it
       badly: downscaling by a factor of twenty in one step throws away
       detail a knitted texture needs, so every thumbnail came out mushy and
       slightly grey. It is also a megabyte a row for 74 rows.

       The Shopify CDN resizes on request, so we ask for roughly what will be
       painted. THREE TIMES the CSS size, not one: these are 46px boxes on a
       phone with a 3x screen, and a 46px file on one of those is worse than
       the original. The CDN caches per size, so this is one extra variant,
       not one per visitor.

       Width only. Height is left to the CDN so the aspect ratio is the
       photograph's own; .mcfg__li-t crops it with object-fit.

       Anything that is not a Shopify CDN URL is handed back untouched — a
       width parameter on someone else's host is at best ignored. */
    function cdnThumb(src, w){
      if(!src) return '';
      if(src.indexOf('cdn.shopify.com') < 0) return src;
      if(src.indexOf('width=') >= 0) return src;
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
    }

    /* ─── WHAT A ROW SAYS ABOUT A STYLE ───
       Gender, then what it is made of and how heavily it is knitted. The
       category used to be here instead, and it was the weaker pair: the rows
       are already grouped by what you filtered to, so repeating the category
       on every line says what the dropdown above it just said.

       MATERIAL AND GAUGE COME TRANSLATED — they are metaobject fields and the
       metaobject sync pushes their translations, so nothing here looks them
       up in a locale file. Absent is a real state: the fallback list carries
       neither, and a product whose material nobody has set carries one.

       SO THE CATEGORY COMES BACK WHEN NEITHER DOES, rather than leaving a row
       with nothing but a gender on it. That is what makes the products.json
       fallback still readable instead of merely functional. */
    function rowFacts(q){
      var parts = [whoLabel(whoOf(q))];
      if(q.material) parts.push(q.material);
      if(q.gauge)    parts.push(q.gauge);
      /* NOTHING BUT A GENDER IS NOT A ROW. The fallback list carries neither
         material nor gauge, so the category comes back there — judged on what
         actually arrived rather than on which source answered, because a
         product whose material nobody has set lands in the same place. */
      if(parts.length === 1) parts.push(garmentOf(q));
      /* ─── AND THE PRICE GOES ON ITS OWN LINE ───
         02/10/2026. It used to be the last item in the same middot-separated
         run as the gender, the material and the gauge, which put a FIGURE in
         a list of descriptions — the one thing on the row that is not a word
         about the garment, reading as though it were.

         SO THIS RETURNS NODES, NOT A STRING. A <br> cannot travel through
         textContent, and nothing in this file builds content with innerHTML —
         see tNodes() for the same reasoning about a span. A fragment costs
         one line at the call site and keeps that rule intact.

         STILL ONE SPAN. It stays inside .mcfg__li-s so it takes that line's
         size and colour; only the break is new. Give it a span of its own
         the day it wants its own ink — that is the version to reach for if
         the price should ever be set apart rather than merely moved down.

         money() is the shop's own formatter, so the row and the rail cannot
         quote a price two different ways.

         Both guards are needed and they fail differently: no fromCents is the
         products.json fallback, where the figure was never fetched; no
         fromPrice is deploy skew, this file live and the section not — and a
         bare number with no "from" in front of it reads as THE price, which
         is the one direction worth being careful about. */
      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(parts.join(' · ')));
      var cents = parseInt(q.fromCents, 10);
      if(isFinite(cents) && cents > 0 && STR.fromPrice){
        frag.appendChild(document.createElement('br'));
        frag.appendChild(document.createTextNode(t(STR.fromPrice, { v: money(cents) })));
      }
      return frag;
    }

    function listRow(q){
      /* A link, not a button: this is navigation, so it can be opened in a new
         tab, and it still works if JS dies after this point. */
      var a = document.createElement('a');
      a.href = linkTo(q.handle);
      if(q.handle === CFG.handle) a.setAttribute('aria-current','true');
      var im = document.createElement('img');
      im.className = 'mcfg__li-t'; im.alt = ''; im.loading = 'lazy';
      im.width = 46; im.height = 58;
      var src = (q.images && q.images[0] && q.images[0].src) || q.featured_image || '';
      if(src) im.src = cdnThumb(src, 140);
      var l = el('span','mcfg__li-l');
      l.appendChild(el('span','mcfg__li-n', styleName(q.title)));
      /* Two lines, because rowFacts() returns a FRAGMENT now — see there. The
         span is built empty and filled, which is what el() cannot do with a
         node. */
      var fx = el('span','mcfg__li-s');
      fx.appendChild(rowFacts(q));
      l.appendChild(fx);
      a.appendChild(im); a.appendChild(l);
      return a;
    }

    /* One measurement box: its label, its unit, its bounds, and the two-line
       contract that keeps typing from eating digits — what is in the box is
       kept VERBATIM, and the centimetre value is derived from it, never the
       other way round while the box has focus.

       Three steps ask for numbers now, and they all ask the same way, so they
       all ask through here. `range` is CANONICAL, like everything stored.

       There is no slot for an instruction any more: they used to hang under
       their own field and shoved everything below them down when opened, so
       each step now carries ONE panel at its foot — see howPanel(). */
    /* `clamp` — WHAT HAPPENS TO A FIGURE OUTSIDE THE BOUNDS, and there are
       exactly two answers in this file, one per kind of number.

         false (every body measurement, and the two fit lengths)
               nothing. The bounds only stop an impossible figure reaching
               production; a chest we cannot dress is a real answer and is
               answered by the dialog.

         true  (an accessory's dimensions)
               it is pulled back to the nearest figure inside the window. The
               limit here is a HOUSE RULE about our own workshop rather than a
               fact about the customer, so past it there is nothing to discuss
               — there is a nearest thing we make, and that is what they get.

       ON `change`, NEVER ON `input`, and that is the whole reason this is a
       listener of its own rather than a line in the input handler. Clamping
       per keystroke is what made the old dimension boxes read as arithmetic:
       the window is 173-187, so clearing the box and typing 1 snapped it to
       173 before the 8 and the 0 could be typed, and the number could never
       be replaced at all. `change` fires when the field is left, which is the
       first moment there is a finished figure to judge.

       go(true) rather than go(), so focus follows the visitor — by the time
       `change` fires on a blur, document.activeElement is already whatever
       they moved to, and that is what gets restored. */
    function numField(key, label, id, get, set, range, note, ph, clamp){
      var rg = range || MEAS_RANGE[key] || [0,999];
      var l = el('label');
      /* The unit lives HERE, not in the translated string: the label has to
         change when the switch is thrown, and a locale file cannot. */
      l.appendChild(el('span', null, label + ' (' + unitLabel(key) + ')'));
      var i = document.createElement('input');
      /* ─── A TEXT BOX, NOT A NUMBER BOX ───
         02/10/2026, and it is the same defect twice: the second half of the
         bug the fit comment at the top of this file records against the minus
         sign, now caught on the decimal point.

         <input type=number> DOES NOT HAND BACK WHAT IS ON SCREEN. Its `value`
         is specified to return the EMPTY STRING whenever what the field holds
         is not a valid floating-point number — and "24." is not one, any more
         than "-" was. So the keystroke that typed the point stored "", go(true)
         rebuilt the field from state a moment later, and the point vanished as
         it was typed. The only way through was to type "245" and go back to
         insert the point, because every intermediate string there IS valid.

         A COMMA NEVER WORKED AT ALL, which is the worse half. "24,5" is
         invalid in a number box on every locale, so on the Italian, French,
         German and Spanish storefronts — where the keypad's decimal key IS a
         comma — a decimal could not be entered by any route. Nobody reported
         it because nobody types decimals in centimetres; it took inches to
         make it visible.

         There is no fix available inside type=number. The typed text is not
         readable through `value`, and `validity.badInput` can only tell you
         that something unreadable is there, not what it was.

         So: a text box that says it wants digits. inputmode="decimal" keeps
         the numeric keypad on a phone, which is the one thing type=number was
         really buying here — the spinners are no use on a chest measurement,
         and min/max/step were never load-bearing. These fields are not in the
         cart form, so nothing submits them and no native validation runs on
         them; the bounds are enforced by clampNow() below, which reads `rg`
         directly and never read the attributes. Nothing in BLOCK 3 selects on
         the type either — the rules are all `.mcfg__meas input`.

         WHAT IT COSTS: letters can now be typed into the box. They were
         always possible to paste, and the handling is unchanged — num()
         returns NaN, toCanonical() stores '', measComplete() stays false and
         Continue stays dead. The box shows what was typed, which is the
         honest thing for it to show. */
      i.type = 'text'; i.inputMode = 'decimal';
      /* A hint to the browser and to anything reading the page aloud, since
         there is no longer a type saying so. Not a pattern: a pattern would
         refuse "24." mid-word and we are back where we started. */
      i.autocomplete = 'off';
      i.setAttribute('enterkeyhint', 'done');
      /* WHAT THE BOX WILL BE READ AS IF IT IS LEFT ALONE, shown in grey in
         the box itself. Only the fit pair pass one, and it is their standard:
         it says what the piece will be made to without asking for a click,
         and it makes the box unmistakably a LENGTH rather than a difference,
         because the example sitting in it is one. */
      if(ph) i.placeholder = ph;
      i.id = id;
      i.value = get();
      i.addEventListener('input', function(){ set(i.value); go(true); });
      /* ─── IT WAITS UNTIL THE FIELD IS ACTUALLY LEFT ───
         02/10/2026, and this is the THIRD attempt at the same question, so
         the two that failed are worth stating.

         `input` was first: clamped per keystroke, so clearing the box and
         typing 1 gave 173 before the 8 and the 0 could be typed. Obvious in
         hindsight.

         `change` was second, on the reasoning that it fires when the field
         is COMMITTED rather than per keystroke. That is true of an ordinary
         form. It is not true here, and the reason is three functions away:
         go(true) EMPTIES AND REBUILDS THE STEP ON EVERY KEYSTROKE. So this
         element is detached a few milliseconds after each character, while
         it is focused and while its value differs from what it was given —
         which is precisely the condition for a commit. The browser fires
         `change` on the way out. Mid-word, every time, and the floor of a
         180cm standard is 173, so every partial number came back 173 and it
         read as the box adding to what was typed.

         So the test is not WHICH EVENT but WHERE THE FOCUS WENT. On blur,
         look again on the next tick: by then the rebuild has finished and
         put a replacement in place with the same id.

           the replacement has focus  -> that blur was our own re-render,
                                         the visitor is still typing, do
                                         nothing
           anything else has focus    -> they really left. Clamp.

         Deterministic, and it does not care whether a given browser fires
         blur on detach at all: if it does, the id check catches it; if it
         does not, nothing spurious fires in the first place.

         IT READS THE STATE, NOT THE BOX. `i` may be detached by the time
         this runs, and its value would be whatever it held when it was torn
         out. get() is what the last `input` actually stored, which is what
         was typed.

         NOTHING IS WRITTEN TO `i` EITHER. go(true) re-renders the field from
         state, so setting i.value would be setting a value on an element
         about to be replaced. */
      if(clamp){
        var clampNow = function(){
          /* num(), not parseFloat: the box is text now and may hold "24,5".
             parseFloat would read that as 24 and clamp a figure nobody typed. */
          var n = num(get());
          if(!isFinite(n)) return;
          /* In DISPLAY units, because that is what is in the box: the bounds
             are stored canonically and converted exactly as the value is. */
          var lo = parseFloat(fromCanonical(key, rg[0]));
          var hi = parseFloat(fromCanonical(key, rg[1]));
          var c = (n < lo) ? lo : (n > hi ? hi : n);
          if(c === n) return;
          set(String(round1(c)));
          go(true);
        };
        i.addEventListener('blur', function(){
          setTimeout(function(){
            var live = document.getElementById(id);
            if(live && document.activeElement === live) return;
            clampNow();
          }, 0);
        });
      }
      l.appendChild(i);
      /* What we make as standard, and what it becomes once they have typed.
         A reading, not something to fill in — and the only line here that
         changes while they work. */
      /* A HINT MAY BE A STRING OR A NODE. It was always a string; the fit
         step's standard line now arrives as a fragment, because its size
         sits in a span of its own — see tNodes(). Both go into the same
         .mcfg__hint wrapper, so the line is styled once whichever it is. */
      if(note) [].concat(note).forEach(function(n){
        if(!n) return;
        var h = el('span','mcfg__hint');
        if(n.nodeType) h.appendChild(n); else h.textContent = n;
        l.appendChild(h);
      });
      return l;
    }

    /* ─────────── how to measure ───────────
       ONE PANEL PER STEP, holding every instruction that step has, and it is
       the LAST thing in the step. It used to be one panel per field, tucked
       inside the field's own label, and that was the problem: on a step with
       two boxes, the sleeve's instruction pushed the length box, the unit
       switch and everything after them down the page. At the bottom there is
       nothing underneath to push — which matters more now that it is always
       open rather than opened on request. See howPanel(). */
    /* THE FOOT ROW every step that asks for a number ends with: the
       instructions on the left where there are any, the cm/in switch on the
       right always. Built here rather than three times over, so the three
       steps cannot end up with different feet. */
    function stepFoot(how){
      var f = el('div','mcfg__stepfoot');
      if(how) f.appendChild(how);
      f.appendChild(unitSwitch());
      return f;
    }

    /* A body we can't size (past the last size, a size with no price, or no
       ladder): no popup, the customer carries on and sends a request. */
    function contactStop(){
      var st = outcome().stop;
      if(st === 'oversize' || st === 'unpriced' || st === 'noranges') return st;
      return null;
    }
    function requestMode(){ return !!contactStop(); }
    function reqEmailOk(){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(S.req.email || '').trim()); }
    function reqReady(){
      if(!requestMode() || !measComplete() || !persComplete()) return false;
      if(COLORS.length && !S.color) return false;
      return !!String(S.req.name || '').trim() && reqEmailOk();
    }

    /* ALWAYS OPEN, 28/09/2026. It was a <details> behind a link that said
       "how to measure", on the reasoning that somebody who has done this
       before should not scroll past a diagram to reach the box. In practice
       the drawing is the instruction, and a drawing nobody opens teaches
       nobody anything — the link was a door in front of the only thing on
       the step that answers the question.

       So: no summary, no open/closed state, and no HOW_OPEN to remember
       across the rebuild go() does on every keystroke. A plain block.
       STR.fitHelp is now unused.

       `items` is [{label, words, svg}]. Anything with no words is dropped —
       an unfilled locale key is a missing instruction, not an empty one —
       and if nothing survives there is no panel at all. */
    function howPanel(key, items, src){
      var use = (items || []).filter(function(it){ return it && it.words; });
      if(!use.length) return null;
      var d = el('div','mcfg__howbox');
      var bd = el('div','mcfg__howbody');

      /* THE PICTURE BELONGS TO THE STEP, NOT TO THE FIELD, and that is the
         change of 28/09/2026. A top is photographed ONCE with both tapes on
         it — the sleeve and the body length — so the two fields share one
         photograph, and drawing it per section would print the same sweater
         twice under two headings.

         It leads, because a photograph of a tape on a garment answers the
         question faster than a sentence about one. Missing, it simply is not
         drawn: the words are the instruction and a panel without a picture is
         an answer, where a broken frame is not. */
      if(src){
        var fig = el('span','mcfg__howfig');
        var im = document.createElement('img');
        im.alt = '';
        im.decoding = 'async';
        /* The name is in the island but not in Files, or the CDN refused it.
           Hide rather than leave the browser's broken-image glyph sitting
           where a photograph should be. */
        im.onerror = function(){ fig.style.display = 'none'; };
        im.src = src;
        fig.appendChild(im);
        bd.appendChild(fig);
      }

      /* ONE TEXT BLOCK, however many paragraphs are in it — 28/09/2026, and
         it is what makes the fit panel and the measurements panel the same
         object instead of two that merely look alike.

         The sections used to be SIBLINGS of the figure, one grid row each,
         with the picture spanning them. That gave the two panels different
         geometry for no reason anybody chose: the measurements step has one
         section, so its picture filled a single row and looked right, and the
         fit step has two, so its picture had its height distributed across
         both rows and came out smaller — beside a column split by a rule, as
         though the sleeve and the length were two separate worlds.

         They are two paragraphs about the same garment. So they go in one
         block, the block goes beside the picture, and BOTH PANELS ARE NOW
         THE SAME TWO-ITEM GRID: figure, words. Nothing spans, nothing is
         distributed, and the picture is the same size on both.

         The headings stay — with two paragraphs they are the only thing
         saying which is the sleeve and which is the length — but the rule
         between them has gone with the wrapper. */
      var tx = el('div','mcfg__howtext');
      use.forEach(function(it){
        var sec = el('div','mcfg__howsec');
        /* Named only when there are two of them. One instruction on a step
           that is plainly about measuring needs no heading of its own. */
        /* ONE PARAGRAPH, LABEL INSIDE IT. The name used to be a sibling of
           the <p> and therefore its own block whatever the stylesheet said;
           now it opens the paragraph the words are in, so CSS alone decides
           whether it runs in — "Sleeve: measure from…" — or sits above them.

           The space between them is written here rather than left to CSS: it
           is what the sentence needs if nothing is styled at all, and it
           collapses to nothing the moment .mcfg__howt is given display:block.
           A colon, a dash or a margin belongs in the stylesheet, on
           .mcfg__howt or its ::after. */
        var para = el('p');
        if(use.length > 1 && it.label){
          para.appendChild(el('span','mcfg__howt', it.label));
          para.appendChild(document.createTextNode(' '));
        }
        para.appendChild(document.createTextNode(it.words));
        sec.appendChild(para);
        tx.appendChild(sec);
      });
      bd.appendChild(tx);
      d.appendChild(bd);
      return d;
    }

    /* WHETHER THE OTHER MODELS ARE FOLDED OPEN, carried across renders.
       The step body is rebuilt from scratch by go(), so the <details> is a
       new element every time and starts closed unless something remembers —
       and go() fires on a resize across 1080 as well as on a filter change,
       which would otherwise shut the fold under someone who had just opened
       it. Closed is still what a first visit gets. */
    var othersOpen = false;

    function body(id, head){
      if(id === 'prod'){
        var box = el('div');
        if(S.list === null){
          box.appendChild(el('div','mcfg__none', STR.loadingModels));
          loadList().then(function(){ go(); });
          return box;
        }
        /* Nothing came back at all: that is the collection or the network,
           not the criteria. Showing the filter bar here would invite the
           visitor to widen a search that was never run. */
        if(!S.list.length){
          box.appendChild(el('div','mcfg__none', S.listErr ? STR.listFailed : STR.listEmpty));
          return box;
        }
        /* The filters and the model you are on are written into the slot
           ABOVE the scroller, so they do not move because they are not in
           anything that scrolls. */
        var prodhead = el('div','mcfg__prodhead');
        (head || box).appendChild(prodhead);
        head = prodhead;
        head.appendChild(filterBar());

        /* THE WAY OUT OF A SEARCH, and it exists because browsing and
           configuring are two different jobs sharing one screen. While the
           results are up, the garment you came for is still on the left —
           its photograph, its price, its recap — and Continue still walks
           forward into ITS measurements. That is all correct and it reads as
           confusing, because nothing says the two halves are about the same
           piece or how to get back to it.

           So: one line that names the garment and puts the step back the way
           it arrived — pinned at the top, the rest folded away. It restores
           ARRIVED rather than clearing, so a funnel visitor gets their
           criteria back instead of losing them.

           IN THE PINNED HEAD, under the filters that started the search and
           above the results it ends, so it holds its place while they scroll.

           NOT a replacement for Continue, which stays exactly where it is: it
           is still the way forward for the garment you are on, and taking it
           away mid-search would leave somebody who changed their mind with no
           way out at all. This is the second exit, not the only one. */
        /* STR.backToModel guards the whole thing: a section that has not been
           redeployed yet carries no such key, and a button with no words on
           it is worse than no button. The flat list still has Continue and
           the rail's own way back. */
        /* AND NOT IN BROWSE MODE. There is no model to go back TO: the
           landing page arrived on a collection, CFG.title is empty, and the
           button would have read "Back to " with nothing after it. The way
           back there is the browser's own Back, which undoes the hash and
           puts the hero up — see the browse block at the end of this file. */
        if(!CFG.browse && S.searched && STR.backToModel){
          var exit = el('button','mcfg__edit', t(STR.backToModel, { v: styleName(CFG.title) }));
          exit.type = 'button';
          exit.addEventListener('click', function(){
            S.searched = false;
            S.who = ARRIVED.who; S.garment = ARRIVED.garment;
            go();
          });
          head.appendChild(exit);
        }

        /* ARE THEY SEARCHING? S.searched, and only S.searched: it is set by
           the two dropdown handlers and by nothing else. See its declaration
           for why "is a filter set" is the wrong question — S.who arrives
           already set on most cold landings, so testing the values put every
           arrival straight into the flat list.

           It decides the SHAPE of this step, because the two cases want
           opposite things:

             NOT SEARCHING — you arrived on a garment and the page is about
             that garment. It is pinned at the top under its own heading and
             taken out of the list, and the other seventy-odd fold away behind
             a closed accordion. Most visits never open it.

             SEARCHING — you have started looking, so the list IS the step.
             Nothing is pinned and nothing is folded: one flat set of results
             with the garment you are on sitting wherever the sort puts it,
             marked as current (listRow writes aria-current) rather than
             lifted out. A result list with one row held above it is not a
             result list, and pinning a row the criteria exclude is worse —
             it answers a question nobody asked.

           Going back to All genders does not end it. Once someone has started
           looking they are looking, and snapping the pinned row back over the
           list mid-browse would be the jumpiest thing on the step. Clearing
           every criterion from the rail does end it — that is the one gesture
           that says "take me back to the start".

           If the criteria exclude the garment you are on, it is simply not
           there. That is the honest answer to a search, and the recap on the
           left still says what you have chosen. */
        var searching = S.searched;

        /* THE PINNED ROW IS SOMETIMES A RESULT AND SOMETIMES NOT, and the
           difference decides whether "no styles match" is true — see below.

             hereMatched   it came out of the POOL, so it passed the filters
                           and IS a result; it is merely shown above the list
                           rather than in it.
             here only     the pool did not contain it, so it was fetched
                           from the full list to be pinned. The criteria
                           genuinely exclude it. */
        var here = null, list = [], hereMatched = false;
        pool(null).forEach(function(q){
          if(!searching && q.handle === CFG.handle){ here = q; hereMatched = true; }
          else list.push(q);
        });
        if(!searching && !here){
          (S.list || []).forEach(function(q){ if(q.handle === CFG.handle) here = q; });
        }

        if(here){
          head.appendChild(el('div','mcfg__k', STR.thisModel));
          var H = el('div','mcfg__list');
          H.appendChild(listRow(here));
          head.appendChild(H);
        }
        if(!list.length){
          /* "No styles match these criteria" is a FALSE STATEMENT when the
             filters narrowed to exactly one style and that style is the one
             you are on: it matched, it is on screen, and it is sitting under
             its own heading two lines above the sentence denying it exists.

             So the message is for an empty RESULT, not an empty LIST. With
             the pinned row counted, nothing at all matched only when it was
             not itself a match — see hereMatched above.

             Nothing is put in its place. The filters carry their own counts,
             so "Women (1)" has already said how many there are, and a line
             explaining that the one result is the one above it would be
             narrating the screen back to the person looking at it. */
          if(!hereMatched) box.appendChild(el('div','mcfg__none', STR.noModels));
          return box;
        }

        /* THE LONG ONE. It is the fold's content on the desktop layout and
           the fold's own scroller on a narrow screen (40svh, see BLOCK 3),
           and it is also the flat result list, which does not scroll at all —
           scrollBox covers all three without being told which. */
        var L = scrollBox('mcfg__list');
        list.forEach(function(q){ L.appendChild(listRow(q)); });

        /* Results, flat and open. No heading: the dropdowns are directly
           above and they say what this list is — a label between the two
           would only repeat them. */
        if(searching){
          box.appendChild(L);
          return box;
        }

        {
          /* AT EVERY WIDTH, 28/09/2026 — this was narrow-only and the wide
             layout printed the whole list open under a heading.

             The 70-odd other models are a wall you have to scroll past to
             reach anything else, and most visits do not want them at all —
             you came here for this garment. So they fold away behind their
             own heading, with the count on it so what is inside the fold is
             never a mystery. <details> rather than a class we toggle: the
             browser already knows how to open and close one, including from
             the keyboard, and it still works if this script dies.

             It starts CLOSED but does not re-close itself: go() rebuilds the
             step body from scratch, so without othersOpen above a resize
             across 1080 — or simply stepping forward and coming back — would
             shut the fold under someone who had just opened it. */
          /* The theme's accordion, element for element: <accordion-custom>
             wrapping a .details / .details__header / .details-content, with
             the same three icon spans. Built here rather than rendered by
             Liquid because the list inside is built here, but the shape is
             the theme's, so it inherits the theme's behaviour and styling and
             looks like every other fold on the site.

             No open-by-default attribute: this one starts closed on purpose. */
          var acc = document.createElement('accordion-custom');
          var d = document.createElement('details');
          d.className = 'details mcfg__acc-box';
          var sum = document.createElement('summary');
          sum.className = 'details__header mcfg__acc';
          sum.appendChild(el('span','mcfg__acc-t', t(STR.otherModelsN, { n:list.length })));

          /* All three icons, as the theme's own markup carries them; which one
             shows is CSS, and ours shows plus shut / minus open. Skipped
             entirely when the assets are missing, so the drawn chevron in the
             stylesheet takes over rather than three empty spans appearing. */
          if(CFG.icons && CFG.icons.plus && CFG.icons.minus){
            sum.className += ' mcfg__acc--icon';
            if(CFG.icons.arrow){
              var ic = el('span','svg-wrapper icon-caret icon-animated');
              ic.innerHTML = CFG.icons.arrow;
              sum.appendChild(ic);
            }
            var ip = el('span','svg-wrapper icon-plus');  ip.innerHTML = CFG.icons.plus;
            var im = el('span','svg-wrapper icon-minus'); im.innerHTML = CFG.icons.minus;
            sum.appendChild(ip);
            sum.appendChild(im);
          }
          if(othersOpen) d.open = true;
          d.addEventListener('toggle', function(){
            othersOpen = !!d.open;
            /* The content has no box until the browser has opened it, so this
               cannot be measured from the click — only from the toggle. */
            sizeFold();
          });
          d.appendChild(sum);

          /* The desktop fold's scroller — sizeFold() gives it its height,
             so this is the box the mask belongs on. */
          var dc = scrollBox('details-content mcfg__acc-body');
          dc.appendChild(L);
          d.appendChild(dc);
          acc.appendChild(d);
          box.appendChild(acc);
          return box;
        }
      }

      if(id === 'tier'){
        var boxT = el('div');
        /* An accessory is TOLD ITS OWN SIZE before it is asked whether it wants
           a different one. Nobody can answer "do you want other dimensions"
           without first being told what the dimensions are, and a scarf has no
           size on the left-hand recap the way a sweater does.

           For a garment that sentence is already on the left: the size was
           worked out a step ago, and this question is only being asked at all
           because it came out as one we stock. */
        if(CFG.oneSize){
          var std0 = dimStd();
          /* ITS OWN STRING, 29/09/2026. It used to borrow dim_standard, which
             is the READING printed under a field — "Standard: 180 x 50 cm",
             short because it sits beside a box and is read as a caption.

             Here the same figure does a different job: it opens the step, and
             it is the only thing that makes the question answerable, because
             nobody can say whether they want other dimensions without being
             told what the current ones are. That wants a sentence, and a
             sentence that reads well under a field is not one that reads well
             as a lede.

             Falls back to dim_standard, which is what it said before it had a
             key — the deploy-skew case, this file live and the section not. */
          if(std0) boxT.appendChild(el('div','mcfg__lede',
            t(STR.dimStandardLede || STR.dimStandard,
              { v: fromCanonical('length', std0.length) + ' × ' +
                   fromCanonical('width',  std0.width) + ' ' + unitLabel('length') })));
        }
        /* allowedTiers, not offeredTiers: what this customer may be offered,
           which at this point is never more than two things. */
        boxT.appendChild(tiles(allowedTiers(), S.tier, function(v){ S.tier = v; go(); }));
        return boxT;
      }

      if(id === 'size'){
        var boxS = el('div');
        var hitS = sizeHit();
        /* The size is PRESELECTED — go() put the resolved one there — so this
           line is what stops it reading as a default nobody chose. It is the
           difference between "L, because that is the first tile" and "4XL,
           because that is what your measurements come out as". */
        if(hitS) boxS.appendChild(el('div','mcfg__lede', t(STR.sizeSuggested, { v:hitS.size })));
        var box2 = el('div','mcfg__sizes');
        availableSizes().forEach(function(sz){
          var b = el('button','mcfg__size' + (hitS && hitS.size === sz ? ' mcfg__size--reco' : ''), sz);
          b.type = 'button';
          b.setAttribute('aria-pressed', S.size === sz ? 'true' : 'false');
          /* Picking, not toggling. There is always a size now, so clicking the
             selected one to clear it only ever left the configuration
             incomplete — and left the customer with no size at all, which is
             the one state this redesign exists to prevent. */
          /* THE ONLY PLACE sizePicked IS SET. From here on the measurement
             stops moving the size — they have decided, and a later change of
             chest must not quietly overrule them. */
          b.addEventListener('click', function(){ S.size = sz; S.sizePicked = true; go(); });
          box2.appendChild(b);
        });
        boxS.appendChild(box2);
        return boxS;
      }

      if(id === 'fit'){
        var boxF = el('div');
        /* ─── THE LEDE FOLLOWS WHAT THE STEP ACTUALLY ASKS ───
           29/09/2026. It was one sentence for every garment, and it had to
           be vague enough to be true of all of them — which meant it told a
           pair of trousers they could adjust their sleeves.

           The step already knows: fitAxes() is what the chart says this
           garment HAS, and it is one or two. A sweater is asked for a sleeve
           and a body length, so it is worth saying that either or both can
           move; a pair of joggers is asked for one length, so naming it
           twice would be noise.

           TWO STRINGS, not one with a clause switched on — the difference
           between them is a whole sentence, and stitching sentences together
           from fragments is how a translation ends up ungrammatical in
           languages that do not put the list where English does.

           {a} and {b} ARE AVAILABLE but not required: they are the two
           fields' own translated labels, for a language that would rather
           name them than write them out. A string that ignores them is
           exactly as correct.

           Falls back to the single-axis string when the pair key is missing,
           which is the deploy-skew case — this file live, the section not. */
        var axesF = fitAxes();
        var ledeF = (axesF.length > 1 && STR.fitLedeBoth) ? STR.fitLedeBoth : STR.fitLede;
        boxF.appendChild(el('div','mcfg__lede', t(ledeF, {
          a: measLabel(axesF[0] || ''),
          b: measLabel(axesF[1] || '')
        })));
        var gridF = el('div','mcfg__meas');
        var sizeF = outcome().size;
        /* Gathered as the fields are built and drawn ONCE, under everything —
           see howPanel(). */
        var hows = [];
        fitAxes().forEach(function(k){
          /* ONE line under the box: what we make as standard, as a band.

             It used to be two, and the second carried an arrow to the result
             — "73—74 cm  ->  75—76 cm" — which was the only way to read back
             what a difference actually came to. The box holds the result
             itself now, so that arrow would have pointed at the number they
             had just typed.

             On a size we have not made, or a garment whose shoulder nobody
             has measured, there is no standard to print and no placeholder to
             show. The question still stands: name the length you want. */
          var std = fitStd(k, sizeF), lines = [];
          /* ─── CAP IT OR RE-PRICE IT, NEVER REFUSE IT ───
             01/10/2026, and it is the rule for the whole flow rather than a
             detail of this step:

               THE DIALOG IS FOR THE SIZE WE CANNOT MAKE. A chest past the
               last rung, or on a rung nobody priced, is a body we cannot
               dress — there is nothing to offer and a conversation is the
               honest answer.

               AN ADJUSTMENT IS NEVER THAT. It is a change to a size we have
               already agreed to make, so past the house limit there are only
               two outcomes: it costs more, or it stops at the limit.

             Which of the two is decided by the product, exactly as it is in
             outcome():

               sells STG   -> the full range stays open. Typing past the limit
                              must be POSSIBLE, because that is what promotes
                              the line to a development and re-prices it. A cap
                              here would make that promotion unreachable.
               no STG      -> there is nothing to promote to, so the limit is
                              a real bound and the box holds the figure to it.

             It replaced an 'overfit' stop that refused the line outright and
             sent it to the dialog. That was the wrong instrument twice over:
             it treated an alteration like an unmakeable size, and it did so
             on exactly the 25 of 75 products that cannot absorb it.

             NO STANDARD, NO CAP. A size nobody has made has no chart row, and
             7 products have a sleeve figure but no shoulder, so the composite
             cannot be computed — see fitStd(). With nothing to measure the
             limit FROM there is no window to hold anything to, and inventing
             one would cap against a figure we do not have. */
          var capFit = !variantFor('STG') && std != null;
          /* NAMED WITH ITS SIZE. "Standard 73-74 cm" invited the question
             "standard for what?" — on this step the answer is never obvious,
             because the size was resolved a step ago and the fit boxes are
             the first thing that does not restate it. {s} is that size; a
             translation that leaves it out still works. */
          /* {s} IS A SPAN, {v} IS PLAIN TEXT. The size is the part of this
             line that answers "standard for what?", so it is the part worth
             being able to set apart; the band reads as the sentence's own
             figure. Give {v} a class the same way — { text:…, cls:… } — the
             day that changes. */
          if(std != null) lines.push(tNodes(STR.fitStandard, {
            v: band(k, std),
            s: { text: sizeF || '', cls: 'mcfg__stdsize' }
          }));
          /* WHICH WORDS. Still per field, because a hem on a top is not an
             inside leg on a pair of trousers and they are not measured the
             same way. The PICTURE is chosen once for the step, below. */
          var which = (k !== 'bodyLen') ? 'sleeve'
                    : (axisKey() === 'hips' ? 'outseam' : 'length');
          hows.push({ label: measLabel(k), words: STR.fitHow[which] });
          gridF.appendChild(numField(k, measLabel(k), 'mcfg-f-' + k + '-' + CFG.handle,
            function(){ return S.typed[k]; },
            function(v){ S.typed[k] = v; S.meas[k] = toCanonical(k, v); },
            capFit ? [std - houseLimit(), std + houseLimit()] : null, lines,
            /* SHOWN, never filled in. A filled box is a value: it would be
               written into the URL, carried to the next model and read there
               as a length somebody asked for. A placeholder says the same
               thing and leaves the field empty, which is what "make it the
               way you make it" has to look like. Floored to match the band
               printed underneath — both are the same number. */
            /* THE SAME "e.g." the first step uses, for the same reason: an
               unqualified number sitting in a box reads as a value somebody
               entered, and this one is the more dangerous of the two —
               a filled-looking fit box is a REQUEST, and a request is priced.
               What the figure means is said properly underneath, in the
               standard line, which names the size it belongs to. */
            (function(){
              var ex = (std != null) ? std : fitExample(k);
              return ex == null ? '' : eg(String(Math.floor(parseFloat(fromCanonical(k, ex)))));
            })(),
            /* See capFit above. Clamped on commit, like the dimensions, so a
               figure can be typed through and only the finished one is pulled
               back to the furthest we will go. */
            capFit));
        });
        boxF.appendChild(gridF);
        /* ONE PHOTOGRAPH FOR THE WHOLE STEP: a top is shot with both tapes
           on it, a bottom has one axis anyway. So the picture follows the
           GARMENT — which the axis tells us — and not the field. */
        var fitPic = (CFG.diagrams || {})[axisKey() === 'hips' ? 'outseam' : 'top'];
        /* LAST, so the instructions push nothing: there is nothing under the
           row. */
        boxF.appendChild(stepFoot(howPanel('fit', hows, fitPic)));
        return boxF;
      }

      if(id === 'dim'){
        var boxD = el('div');
        var std = dimStd();
        /* visible() already checked this, so it is a state you pass through
           rather than land in — but the step is drawn from a sentence that a
           person can edit, and a step that cannot say what the standard is has
           nothing to offer. */
        if(!std){ boxD.appendChild(el('div','mcfg__none', STR.dimNone)); return boxD; }
        boxD.appendChild(el('div','mcfg__lede',
          /* The same figure the tiles quote — see limitFigure(). It used to
             be fromCanonical() raw, which printed "2.8 in" for a bound that
             is really 2.756, so the sentence allowed a tenth of an inch the
             boxes underneath refused. */
          t(STR.dimLede, { n: limitFigure(), u: unitLabel('length') })));
        var gridD = el('div','mcfg__meas');
        DIM_KEYS.forEach(function(k){
          /* THE BOUNDS ARE THE HOUSE RULE, and they are back — 30/09/2026.
             The box states the window it will take, so the limit quoted in
             the lede above and the figure the form accepts are one number.

             They were briefly DIM_RANGE, which is absolute and generous, and
             that threw the limit out with the bug it was trying to fix.

             THE BUG WAS NEVER THE BOUNDS. It was WHEN they were applied: go()
             clamped on every keystroke, so clearing the box and typing 5 gave
             173 before the rest of the number could be typed, and it read as
             though the figure had been added to something. The clamp now runs
             on `change` — when the field is left, which is the first moment
             there is a finished number to judge — so any figure can be typed
             through and only the finished one is pulled into the window.

             So: the box says what it takes, the commit pulls a stray figure
             back to the nearest thing we make, a URL is clamped once where it
             is read, and nothing anywhere adds to what was typed. */
          gridD.appendChild(numField(k, STR.dim[k], 'mcfg-d-' + k + '-' + CFG.handle,
            function(){ return S.typedDim[k]; },
            function(v){ S.typedDim[k] = v; S.dim[k] = toCanonical(k, v); },
            [std[k] - houseLimit(), std[k] + houseLimit()],
            t(STR.dimStandard, { v: fromCanonical(k, std[k]) + ' ' + unitLabel(k) }),
            /* These boxes are PREFILLED with the standard by go(), so the
               placeholder is only ever seen by somebody who has cleared one —
               which is exactly the moment an example is worth having. Same
               wording as everywhere else. */
            eg(String(Math.round(parseFloat(fromCanonical(k, std[k]))))),
            /* CLAMPED — see numField. Past the house limit there is nothing
               to talk about on an accessory: there is a nearest size we make
               and the box moves to it when the field is left. */
            true));
        });
        boxD.appendChild(gridD);
        /* No instructions on this step — a length and a width need none — so
           the row carries the switch alone. */
        boxD.appendChild(stepFoot(null));
        return boxD;
      }

      if(id === 'pers'){
        var boxP = el('div');
        if(!pers()){ boxP.appendChild(el('div','mcfg__none', STR.persNone)); return boxP; }
        /* The option's own description, as the product page prints it, then
           what it costs — a flat charge, so it can be stated outright rather
           than hidden until the total moves. */
        if(pers().desc) boxP.appendChild(el('div','mcfg__lede', pers().desc));

        /* WHAT IT LOOKS LIKE, BEFORE THE QUESTION. It used to draw only after
           they clicked Yes, which put it on the wrong side of the decision —
           nobody can answer "do you want this" without being shown what "this"
           is, and a price with no picture is a worse offer than no offer.

           Same files the drawer already shows — customization_<code>[_<font>]
           .jpg — so nothing new has to be uploaded. Before a font is picked
           the name has no font in it, which is exactly the generic shot this
           moment wants; once they say yes and choose one, it swaps to that
           font's own photo. The element is kept and MOVED rather than rebuilt,
           so neither the reorder nor the swap makes the panel jump — see
           persImg(). */
        var persIm = persImg();
        if(persIm) boxP.appendChild(persIm);

        /* YES OR NO, and it is a real control rather than an inference. There
           was no way to decline before: an empty text box meant none, which is
           true but invisible — nothing on screen said so, and nothing confirmed
           the choice back.

           Plain yes and no. The button briefly carried the option's own name —
           Ricamo, Intarsio — and that was one place too many: the question
           above already names it, and the subtext beside the question already
           says what it adds. A button that repeats the question is noise.

           What it costs is not stated on this step at all, by choice as of
           28/09/2026: the subtext beside the question is gone along with every
           other count, and the charge shows itself where it lands — the total
           in the rail moves the moment Yes is pressed. */
        var onRow = el('div','mcfg__sizes');
        [[false, STR.persNo], [true, STR.persYes]].forEach(function(opt){
          var b = el('button','mcfg__size', opt[1]); b.type = 'button';
          b.setAttribute('aria-pressed', S.pers.on === opt[0] ? 'true' : 'false');
          b.addEventListener('click', function(){ S.pers.on = opt[0]; go(); });
          onRow.appendChild(b);
        });
        boxP.appendChild(onRow);
        /* NOT YES — either declined, or not answered at all. Both show the
           same thing, which is nothing more: the photo and the two buttons.
           They part company one layer up, in persComplete(): declined lets
           the cart through and unanswered does not.

           The photo above stays either way, so changing your mind is one
           click and the panel does not resize under the cursor. */
        if(S.pers.on !== true) return boxP;

        /* A heading, and nothing else. It used to echo the current choice on
           the right of every one of these, which said the same thing twice: the
           control immediately underneath already shows what is picked, by being
           pressed. The only value still printed here is the character counter,
           which is not an echo of a choice — it counts down as you type.

           var, not a declaration: a function declared inside a block is
           annex-B behaviour and this file is ES5 everywhere else. */
        var section = function(label, value){
          var h = el('div','mcfg__persk');
          h.appendChild(el('span', null, label));
          if(value) h.appendChild(el('span','mcfg__persv', value));
          return h;
        };

        /* POSITION — only a question where there is more than one. go()
           preselects the single case, so this is never an empty control.

           A row of named buttons, the same control the fonts and the sizes use.
           It was briefly points drawn on a photo of the garment, the way the
           ordinary drawer asks it, and that is gone on purpose: the photo it
           had to sit on is `product.images | last`, which is whatever image
           happens to be last on THIS product, and the coordinates were
           calibrated against a different one. A marker in roughly the right
           place is worse than a word in exactly the right place. */
        if(persPositions().length > 1){
          boxP.appendChild(section(STR.persPosition));
          var pg = el('div','mcfg__sizes');
          persPositions().forEach(function(pp){
            var b = el('button','mcfg__size', persPosLabel(pp)); b.type = 'button';
            b.setAttribute('aria-pressed', S.pers.pos === pp ? 'true' : 'false');
            b.addEventListener('click', function(){ S.pers.pos = pp; go(); });
            pg.appendChild(b);
          });
          boxP.appendChild(pg);
        }

        /* FONT — same rule. The product page shows a rendered preview of each
           one; we have no filename for those, so the name is set in the face
           it names where the browser has it and prettified otherwise. */
        if(persFonts().length > 1){
          boxP.appendChild(section(STR.persFont));
          var fg = el('div','mcfg__sizes');
          persFonts().forEach(function(f){
            var b = el('button','mcfg__size', persFontLabel(f)); b.type = 'button';
            b.setAttribute('aria-pressed', S.pers.font === f ? 'true' : 'false');
            b.addEventListener('click', function(){ S.pers.font = f; go(); });
            fg.appendChild(b);
          });
          boxP.appendChild(fg);
        }

        /* COLOUR, two worlds. free_select is a palette; pre_paired is a
           statement — Octopus already decided which yarn goes with this
           garment colour, and offering a choice there would be a lie. */
        if(persFree() && persSwatches().length){
          boxP.appendChild(section(STR.persColor));
          var cg = el('div','mcfg__perscols');
          persSwatches().forEach(function(c){
            var b = el('button','mcfg__perscol'); b.type = 'button';
            b.title = c.label;
            b.setAttribute('aria-label', c.label);
            b.setAttribute('aria-pressed', S.pers.color === c.hex ? 'true' : 'false');
            b.style.background = c.hex;
            b.addEventListener('click', function(){ S.pers.color = c.hex; go(); });
            cg.appendChild(b);
          });
          boxP.appendChild(cg);
        } else if(persPairedColor()){
          /* STATED, not chosen — and it is the YARN paired with the garment
             colour the customer picked one step ago, so it changes when they
             change their mind about the colour. No button, no pressed state,
             nothing to click: there is no choice here to offer.

             ITS OWN HEADING, persYarn, and not the one above it. An intarsio
             is KNITTED IN out of a second yarn; a ricamo is EMBROIDERED ON
             with a thread. They are different operations and calling them the
             same thing on the same screen is how somebody ends up expecting
             stitching on a piece that will be knitted.

             NO SWATCH. The name is the answer on its own — a dot beside it
             said nothing the name did not, and on a yarn we have not paired
             yet it was a grey hole standing in for an absence. The hex still
             travels in the island; nothing here draws it. */
          boxP.appendChild(section(STR.persYarn));
          var yarn = el('div','mcfg__persyarn');
          yarn.appendChild(el('span', null, persPairedColor().name));
          boxP.appendChild(yarn);
        }

        /* THE TEXT — the initials, the word or the phrase, depending on what
           the option allows. Empty means none: nothing is posted or charged. */
        var wrap = el('div','mcfg__perstext');
        var left = Math.max(0, (pers().maxChars || 10) - String(S.pers.text || '').length);
        wrap.appendChild(section(STR.persText, tN(STR.persChars, STR.persChars1, left)));
        var ti = document.createElement('input');
        ti.type = 'text';
        ti.id = 'mcfg-p-text-' + CFG.handle;
        ti.maxLength = pers().maxChars || 10;
        ti.autocomplete = 'off';
        /* AN EXAMPLE, IN THE SAME WORDS AS EVERY OTHER BOX. It goes through
           eg(), so the "e.g." is the locale file's and there is nothing new
           to translate — only {v} changes, and initials are the one value
           that reads the same in every language this shop sells in.

           A CONSTANT, not a guess at the customer's own initials and not a
           word: intarsio allows three characters, so a word would not fit
           half the options, and two letters is unmistakably an example of
           the SHAPE rather than a suggestion of the content. */
        ti.placeholder = eg(PERS_EG);
        ti.value = S.pers.text || '';
        ti.addEventListener('input', function(){ S.pers.text = ti.value; go(true); });
        wrap.appendChild(ti);
        boxP.appendChild(wrap);

        /* NO terms line here, deliberately. The drawer's own
           maison.product.customization_terms asks for 2-3 extra working days,
           and on a made-to-order piece that is not true: the garment is being
           knitted from scratch either way and the lettering happens inside
           that time. The delivery promise in the rail — custom.production_time_full,
           per product — is the only lead time this page states. */
        return boxP;
      }

      if(id === 'req'){
        var boxR = el('div');
        if(STR.reqIntro) boxR.appendChild(el('div','mcfg__lede', STR.reqIntro));
        /* Name and email share a row; the notes take the full row under them. */
        var gridR = el('div','mcfg__meas mcfg__reqgrid');
        [['name',STR.reqName], ['email',STR.reqEmail], ['note',STR.reqNote]]
          .forEach(function(f){
            var isNote = f[0] === 'note';
            var l = el('label', isNote ? 'mcfg__reqnote' : null);
            l.appendChild(el('span', null, f[1]));
            var i = document.createElement('input');
            /* Text, not type=email: go(true) restores the caret and email boxes refuse it. */
            i.type = 'text';
            if(f[0] === 'email') i.inputMode = 'email';
            var ph = isNote ? STR.reqNotePh : (f[0] === 'email' ? STR.reqEmailPh : STR.reqNamePh);
            if(ph) i.placeholder = ph;
            i.id = 'mcfg-r-' + f[0] + '-' + CFG.handle;
            i.autocomplete = (f[0] === 'note') ? 'off' : f[0];
            i.value = S.req[f[0]];
            i.addEventListener('input', function(){ S.req[f[0]] = i.value; go(true); });
            l.appendChild(i);
            gridR.appendChild(l);
          });
        boxR.appendChild(gridR);
        /* Shopify refused the last send (e.g. invalid email). */
        if(elReqErr && elReqErr.textContent.trim())
          boxR.appendChild(el('div','mcfg__none', elReqErr.textContent.trim()));
        return boxR;
      }

      if(id === 'color'){
        var g = el('div','mcfg__grid3');
        COLORS.forEach(function(c){
          var b = el('button','mcfg__cell'); b.type = 'button';
          b.title = c.name + (c.code ? ' ' + c.code : '');
          b.setAttribute('aria-pressed', S.color === c.code ? 'true' : 'false');
          var sw = el('span','mcfg__sw');
          /* backgroundColor, NOT the `background` shorthand: the photo is laid
             over it as a child, and the flat colour has to survive underneath
             — while the file loads, on the colours that have no file, and if
             one fails. */
          sw.style.backgroundColor = (c.settings && c.settings.hex) || c.hex || '#ccc';
          /* AN <img>, not a background-image, and for two reasons. It can be
             lazy: 62 swatches would otherwise all be fetched the moment the
             step is opened, and on the desktop layout the grid is a scroller,
             so most of them are not on screen. And it can FAIL — a background
             that 404s leaves the cell looking like the colour is missing,
             where an <img> tells us so and stands aside for the hex.

             Nothing moves when it arrives: .mcfg__sw is square by
             aspect-ratio before there is anything inside it. */
          if(c.swatch){
            var si = document.createElement('img');
            si.alt = ''; si.loading = 'lazy'; si.decoding = 'async';
            si.onerror = function(){ si.style.display = 'none'; };
            si.src = c.swatch;
            sw.appendChild(si);
          }
          b.appendChild(sw);
          b.appendChild(el('span','mcfg__cn', c.name));
          if(c.code) b.appendChild(el('span','mcfg__cc', c.code));
          b.addEventListener('click', function(){
            S.color = c.code;
            /* Back to the garment first. The styling shot is never tinted, so
               picking a colour while it is up repaints something you cannot
               see — it looked like the swatch had done nothing. */
            setView('main');
            paint(c);
            go();
          });
          g.appendChild(b);
        });
        return g;
      }

      if(id === 'meas'){
        var box3 = el('div'), grid = el('div','mcfg__meas');
        /* THE LEDE, FIRST, like every other step. It used to sit UNDER the
           fields as a .mcfg__note and appear only while nothing had resolved
           yet, which made this the one step in the flow whose opening sentence
           was not at the top — and the only one you had to scroll past the
           question to find the framing for.

           The conditionality had a reason and the position did not. Unbending
           it also removes a layout shift: shown above and then withdrawn on
           the first keystroke, the whole grid jumped up under the cursor
           mid-typing. Standing, it costs a line and moves nothing. fitLede and
           dimLede stand the same way once their step is answered. */
        box3.appendChild(el('div','mcfg__lede', STR.measPrompt));

        /* The graded measurement first, then the two that travel as context
           rather than resolving anything. The hidden body key is never
           rendered, so a pair of joggers is asked for hips and never for a
           chest. */
        [axisKey()].concat(EXTRA_KEYS).forEach(function(k){
          /* Height in an inch market is spoken as feet and inches, so it is
             asked for that way — the one field that does not go through
             numField, because it is two boxes holding one answer. Either of
             them rewrites the same S.meas.height, and S.typed.height is kept in
             step so a switch back to cm has something to convert. */
          if(k === 'height' && S.unit === 'in'){
            var l = el('label');
            l.appendChild(el('span', null, STR.meas[k] + ' (' + unitLabel(k) + ')'));
            var pair = el('div','mcfg__ftin');
            var fB = document.createElement('input'), iB = document.createElement('input');
            /* TEXT, for the reason numField() gives at length: a number box
               returns "" for anything that is not yet a valid number, so the
               inches box could not be given a decimal point and could not be
               given a comma at all. This is the box that needs one most —
               5 ft 4.5 in is an ordinary height.

               The bounds went with the type. They were never enforced here:
               this pair has no clamp, it writes straight to S.meas.height, and
               MEAS_RANGE is what actually holds height to 120-220 cm when the
               figure is read back. Carrying a min of 3 and a max of 7 on a box
               the browser no longer validates would be decoration. */
            fB.type = iB.type = 'text';
            fB.inputMode = iB.inputMode = 'decimal';
            fB.autocomplete = iB.autocomplete = 'off';
            fB.id = 'mcfg-m-height-ft-' + CFG.handle;
            iB.id = 'mcfg-m-height-in-' + CFG.handle;
            /* One <label> cannot name two boxes, so each says which it is. */
            fB.setAttribute('aria-label', STR.meas[k] + ' (ft)');
            iB.setAttribute('aria-label', STR.meas[k] + ' (in)');
            fB.value = S.typed.heightFt; iB.value = S.typed.heightIn;
            /* ONE example, split the way the field is. Both boxes carry it
               because either alone would look like the other had been filled
               in already — and the split comes from the same centimetre
               figure the cm layout shows, so the two units never give a
               visitor different examples of the same person. */
            (function(){
              var h = egValue('height');
              if(!isFinite(h)) return;
              var f = ftFromCanonical(h);
              fB.placeholder = eg(f.ft);
              iB.placeholder = eg(String(Math.round(parseFloat(f.inch) || 0)));
            })();
            var onFtIn = function(){
              S.typed.heightFt = fB.value;
              S.typed.heightIn = iB.value;
              S.meas.height  = canonicalFromFt(fB.value, iB.value);
              S.typed.height = fromCanonical('height', S.meas.height);
              go(true);
            };
            fB.addEventListener('input', onFtIn);
            iB.addEventListener('input', onFtIn);
            pair.appendChild(fB); pair.appendChild(iB);
            l.appendChild(pair); grid.appendChild(l);
            return;
          }

          grid.appendChild(numField(k, STR.meas[k], 'mcfg-m-' + k + '-' + CFG.handle,
            function(){ return S.typed[k]; },
            function(v){ S.typed[k] = v; S.meas[k] = toCanonical(k, v); },
            null, null, egFor(k)));
        });
        box3.appendChild(grid);
        /* Size we can't sell: say so here, where it is decided. */
        if(requestMode()) box3.appendChild(el('div','mcfg__note mcfg__notice', STR.reqLede));
        /* HOW TO MEASURE YOURSELF, behind the same link the fit step uses and
           in the same place. Only the graded axis has one: weight and height
           need no instruction, and the axis this garment does NOT grade on is
           never rendered, so it is never explained either.

           One item, so howPanel prints no sub-heading — the link already says
           what it is. A missing locale key drops the item and the link simply
           does not appear, which is the same silence every other instruction
           keeps. */
        var mhow = [];
        if((STR.measHow || {})[axisKey()]){
          mhow.push({ label: STR.meas[axisKey()],
                      words: STR.measHow[axisKey()] });
        }
        /* Under the boxes, and BEFORE the contact block below — the row
           belongs to the fields, not to whatever the measurement resolved
           to. */
        box3.appendChild(stepFoot(
          howPanel('meas', mhow, (CFG.diagrams || {})[axisKey()])));

        return box3;
      }
      return el('div');
    }


    /* What a question may name. Computed per step rather than all at once,
       because sizeHit() walks the ladder and there is no reason to do that
       while somebody is choosing a colour.

         n  a count — how many colours there are to choose from
         v  a value — the size the measurements resolved to

       Both are always defined for the step that has them and blank otherwise,
       so an unfilled placeholder prints as nothing rather than "undefined". */
    function questionVars(id){
      /* BOTH NAMES CARRY THE COUNT on the colour step, because the step has
         only one number to give and there is nothing for the other name to
         mean. A locale file that says {v} and one that says {n} both come out
         right, which is one fewer thing to get wrong in six languages. */
      if(id === 'color') return { n: COLORS.length, v: COLORS.length };
      /* The size step DOES have two, so here they differ and the names have
         to be read: {v} is the size we resolved to, {n} is how many sizes are
         on offer. */
      if(id === 'size'){
        var hit = sizeHit();
        /* {v} IS A SPAN HERE. "We recommend size L" is one sentence with one
           word in it that is not prose — the size — and this is what lets the
           stylesheet say so. tNodes() takes the object; t() would print
           [object Object], which is why the question is the one string that
           no longer goes through t(). */
        return {
          n: availableSizes().length,
          v: hit ? { text: hit.size, cls: 'mcfg__qval' } : ''
        };
      }
      return { n:'', v:'' };
    }

    /* THE QUESTION FOR A STEP, as NODES rather than a string — because one
       of them puts a value in a span of its own (see questionVars), and a
       span cannot survive a round trip through textContent.

       The singular twin is chosen here rather than in tN(), which returns a
       finished string and would substitute before there was anything to
       wrap. Same rule, same condition: only the colour step has one, because
       only its number sits beside a noun.

       questionVars() supplies BOTH names to every question, so a locale file
       may use {n} or {v} in any of them without a change here. */
    function questionNodes(id){
      var str = STR.questions[id];
      if(id === 'color' && COLORS.length === 1 && STR.qColor1) str = STR.qColor1;
      return tNodes(str, questionVars(id));
    }

    /* ─── THE FOLD IS MEASURED, NOT LAID OUT ───
       29/09/2026, and it replaces a flex chain that was correct on paper and
       produced no height in the browser.

       The intent has not changed: on the wide layout the section is held to
       one screenful, the filters and the pinned model stay put in the head,
       and the OTHER STYLES list scrolls inside its own fold so the opener
       does not scroll away with it.

       That was built as a chain of flex items — step body, box,
       accordion-custom, details, details-content — every link `flex:1 1 auto`
       with `min-height:0`, ending in `overflow:auto`. Every link is still
       there and it still computes nothing: inspected, .details-content has no
       height at all, so `overflow:auto` has nothing to overflow and the list
       simply runs on. A <details> is not an ordinary box — the open/closed
       machinery is the browser's own — and a definite height was never
       arriving at the end of that chain.

       So the height is TAKEN rather than asked for: from the top of the list
       to the bottom of the scroller it sits in, which is exactly "what is
       left on the page". getBoundingClientRect on both, once, after the step
       is in the DOM.

       MAX-HEIGHT, NOT HEIGHT, so a short list is still short — twelve rows
       do not get stretched down the column with white under them.

       CLEARED BEFORE IT IS MEASURED. The old value is what is making the box
       the size it is, so measuring through it would ratchet: each render
       would read back the figure the last one wrote.

       AND CLEARED ON THE NARROW LAYOUT, which has its own rule (60svh) and
       where the page itself scrolls. A stale pixel figure from a desktop
       render must not survive a rotation.

       Called from go() after the step is appended, from the fold's own toggle
       — an opening fold has no height until it is open — and from the resize
       handler, which is the only other thing that changes the answer. */
    function sizeFold(){
      var dc = elBody.querySelector('.mcfg__acc-box[open] > .details-content');
      if(!dc) return;
      dc.style.maxHeight = '';
      if(narrow()) return;
      /* NO +1 ANY MORE. It was here to push the fold's own bottom border into
         the scroller's overflow, which worked and was the wrong instrument:
         the border is simply not drawn while the fold is open on this layout
         — see .mcfg__acc-box[open] in BLOCK 3 — because a list that is still
         scrolling has no end to mark.

         With nothing left to hide, the exact leftover is the right figure and
         one pixel more is one pixel of overflow, which is enough to put a
         scrollbar on the step body for no reason. */
      var avail = Math.floor(elBody.getBoundingClientRect().bottom -
                             dc.getBoundingClientRect().top);
      /* A floor rather than a guard, because the alternative to a small fold
         is a fold with no scrollbar at all. Under this the column is too
         short for the step regardless and .mcfg__stepbody takes over. */
      if(avail < 120) avail = 120;
      dc.style.maxHeight = avail + 'px';
    }

    /* ─── TWO WAYS TO HEAD A STEP, ONE PER LAYOUT ───
       29/09/2026. The question and the title used to be the same string, and
       on a wide screen that is right: "Scegli fra 28 colori" reads as a
       question because there is a whole row for it, and it says more than
       "Colore" ever could.

       On a phone that row is shared with Back and Continue and wraps at about
       twenty characters, so the same sentence became two or three lines of
       heading above a step that had not started yet. Hence a SHORT TITLE
       there — step_prod, step_meas and the rest, which are one or two words
       each and were written for exactly this.

       AND THE QUESTION IS NOT LOST, which is the other half. Two of them
       carry information nothing else on the step says — the size we resolved
       to, and how many colours there are — so on a phone the question moves
       DOWN into the step's own lede rather than being dropped. Same sentence,
       same locale key, a different place on a narrower screen.

       Falls back to the question wherever a step title is missing from the
       island, which is the deploy-skew case and also what a half-filled
       locale file looks like: a long heading, never an empty one. */
    function stepTitleNodes(id){
      var short = (STR.steps || {})[id];
      if(narrow() && short) return document.createTextNode(short);
      return questionNodes(id);
    }

    /* THE QUESTION, WHERE THE LEDE IS — narrow layout, TWO STEPS ONLY.

       The short title takes the heading everywhere, but ONE question is worth
       moving rather than dropping:

         size    "Recommended size: {v}" — the size we resolved to. It is the
                 whole result of the measurements step and it appears nowhere
                 else on this screen, so dropping it would lose the answer.

       COLOUR WAS THE OTHER ONE AND IS NOT ANY MORE, 29/09/2026. "Choose from
       28 colors" states a count, and the count is already on screen: it is
       the grid, right underneath, in colours you can see. A sentence above it
       saying how many there are is a caption for a picture that does not need
       one — and on a phone it cost a line of the screen the swatches wanted.

       Every other question is a label with a verb in front of it. "Choose a
       style" above a list of styles is the heading said twice, and putting it
       in the lede as well would be three times.

       It JOINS an existing lede rather than opening a block of its own — the
       size step already opens with one — and where there is none, which is
       the colour step, one is made for it.

       AND A NEW ONE GOES BESIDE THE STEP, NOT INSIDE IT. That is the whole
       of the fix of 29/09/2026: body() does not always return a wrapper. The
       size step returns a <div> holding a lede and the size buttons, so
       anything put inside it is another block in a stack — but the COLOUR
       step returns .mcfg__grid3 itself, which is a three-column grid, so a
       lede inserted into it became a CELL. A sentence sat in the top-left
       corner where a swatch belongs and pushed the colours along by one.

       So the new lede is inserted before the step box rather than into it,
       which is right for either shape and needs no test for which one we
       have. It also lands as the first child of .mcfg__stepbody, so the
       header spacing rules pick it up exactly as they do a step's own lede.

       This is why the call happens AFTER the step is appended: the box has
       to have a parent for anything to be put beside it.

       Its own class, .mcfg__qlede, so it can be set apart from the sentence
       it now sits in front of. Nothing here styles it. */
    var Q_IN_LEDE = { size:1 };
    function qLedeInto(host, id){
      if(!narrow() || !host || !Q_IN_LEDE[id]) return;
      var q = el('span','mcfg__qlede');
      q.appendChild(questionNodes(id));
      var lede = host.querySelector('.mcfg__lede');
      if(lede){
        lede.insertBefore(document.createTextNode(' '), lede.firstChild);
        lede.insertBefore(q, lede.firstChild);
        return;
      }
      if(!host.parentNode) return;
      lede = el('div','mcfg__lede');
      lede.appendChild(q);
      host.parentNode.insertBefore(lede, host);
    }

    /* ══════════════════════════════════════════════════════════════════════
       RENDER — one function, called after every change. Cheap enough to be
       total: no partial updates to fall out of sync with each other.
       ══════════════════════════════════════════════════════════════════════ */
    var elPrice   = $('[data-price]');
    /* THE CRITERIA BLOCK IS GONE, 30/09/2026 — [data-crit-key], [data-crit]
       and [data-crit-edit] with it, in BLOCK 2.

       It was three chips and a "Modifica", route 1 only, and every one of
       them had come to be said better somewhere else. The gender and the
       category are the two dropdowns on the Modello step, which CHANGE them
       rather than reporting them; the tier is the first line of the summary
       immediately underneath, and that line is the more honest of the two
       because it reads back the tier being CHARGED after any re-pricing,
       where the chip showed what was clicked.

       "Modifica" was the full reset — route 2, both filters cleared, the
       search ended. The clear button beside the dropdowns is that now, which
       is why it stopped being gated on S.searched (see filterBar); "Back to
       <style>" restores what the visitor arrived with. STR.criteria and
       STR.edit are unused. */
    var elSelK    = $('[data-sel-key]');
    var elSummary = $('[data-summary]'),    elNav    = $('[data-stepnav]');
    var elQ       = $('[data-step-q]');
    var elBody    = $('[data-step-body]'),  elThumb  = $('[data-thumb]');
    var elHead    = $('[data-step-head]');
    /* THE WRAPPER, not the form. [data-cart] is <product-form-component>
       since 29/09/2026 — see BLOCK 2 — and it is what go() moves between the
       rail and the options column, because the component throws if the form
       is not one of its own descendants.

       elCartForm is the real <form> inside it, needed only for its id: a
       submit button may sit outside its form as long as it names it, and both
       of ours do. elCartBtns is where the button lives when it is not in the
       nav row. */
    var elCart    = $('[data-cart]');
    var elCartBtns= $('[data-cart-btns]');
    /* RESOLVED WHEN IT IS NEEDED, never cached. The form is written by
       {% form 'product' %} and lives inside the wrapper; looking it up each
       time costs nothing and cannot go stale. */
    function cartForm(){ return elCart ? elCart.querySelector('form') : null; }
    /* ─── HOW THE BUTTON SUBMITS, 29/09/2026 ───
       By asking the form, not by being attached to it.

       It used to rely on `form=`: a submit button may sit outside its form as
       long as it names it by id. That is true, and it is also one more thing
       that has to be right — the id has to exist, the attribute has to have
       been set, and both have to survive the button being moved between the
       nav row and the form. The first time any link in that chain broke, the
       button did NOTHING: no submit, no error, no console output, because a
       submit button with no form is not an error in HTML. It is just inert.
       A whole afternoon went into finding that once.

       requestSubmit() removes the chain. It fires a real `submit` event on
       the form — which is what .submit() does NOT do, and why .submit()
       bypassed the theme and redirected to /cart — so
       <product-form-component> catches it, cancels it, posts to /cart/add.js
       and opens the drawer, exactly as it does for every other button on the
       site. It also runs validation first, like a real click.

       So both buttons are type="button" and both come through here. One path
       at every width and wherever the button happens to be sitting.

       The fallback is for an engine without requestSubmit (Safari below 16).
       It posts natively and lands on /cart — the drawer is lost, the item is
       not. */
    function submitCart(){
      var f = cartForm();
      if(!f) return;
      if(f.requestSubmit) f.requestSubmit();
      else f.submit();
    }

    /* ─── THE LOADING STATE, COPIED OFF THE THEME ───
       Not invented here, and not listening for an event whose name we would
       have to guess. <product-form-component> calls disableAfterAdd() on
       every <add-to-cart-component> inside itself when it posts, and
       enableAfterAdd() when it is done — that pair is what puts `is-loading`
       on a button everywhere else on the site.

       BLOCK 2 gives it one to call: an invisible proxy that never moves and
       is never pressed. We watch that proxy's own button and copy what the
       theme did to it onto the buttons a customer can actually see. So the
       spinner starts and stops on the real lifecycle of the request, not on a
       timer and not on a guess.

       BOTH BUTTONS, always. On a narrow screen the row and the recap each
       have one and they must not disagree; on a wide screen there is only
       ever one and the second half of this costs nothing.

       DISABLED IS TWO QUESTIONS, and they have to be kept apart: `busy` is
       "an add is in flight", ATC_OK is "the configuration is complete". The
       button is dead if either says so, and re-enabling after an add must not
       undo an incomplete configuration — which is why ATC_OK is remembered
       rather than recomputed here. */
    /* THE LABEL, IN THE THEME'S OWN MARKUP.

       It was plain textContent, and the loading state then half worked: the
       spinner appeared and "Aggiungi al carrello" stayed on top of it. The
       theme does not hide a button's text by colouring it — it hides
       `.add-to-cart-text`, an element every other button on the site has and
       ours did not.

       So the label is nested the way the theme nests it. Three spans for one
       word looks like a lot until you notice what it buys: the spinner, the
       added state and anything else keyed on that structure work on our
       button for free, and keep working when the theme changes them.

       Rebuilt rather than patched on each call, so there is no state to get
       wrong when the string is set a second time. */
    function setAtcLabel(b, text){
      if(!b) return;
      b.innerHTML = '';
      var outer = el('span','add-to-cart-text');
      var inner = el('span','add-to-cart-text__content');
      inner.appendChild(el('span', null, text));
      outer.appendChild(inner);
      b.appendChild(outer);
    }

    var elAtcProxy = root.querySelector('[data-atc-proxy] button');
    var ATC_OK = false;
    function atcButtons(){
      return elAtcTwin ? [elAtc, elAtcTwin] : [elAtc];
    }
    function paintAtc(){
      var busy = !!(elAtcProxy &&
        (elAtcProxy.disabled || elAtcProxy.classList.contains('is-loading')));
      atcButtons().forEach(function(b){
        if(!b) return;
        /* toggle(name, force) is not in every engine we still see, so it is
           done the long way. */
        if(busy) b.classList.add('is-loading');
        else     b.classList.remove('is-loading');
        b.disabled = busy || !ATC_OK;
      });
    }
    if(elAtcProxy && window.MutationObserver){
      new MutationObserver(paintAtc).observe(elAtcProxy,
        { attributes:true, attributeFilter:['class','disabled'] });
    }
    var elRail    = $('.mcfg__rail'),       elOpts   = $('.mcfg__opts');
    var elAtc     = $('[data-atc]'),        elAtcNote= $('[data-atc-note]');
    /* THE SECOND ADD-TO-CART, for the narrow layout's last step, where the
       row keeps its button AND the form under the recap keeps its own. Two
       buttons rather than one moved, because on a narrow screen both places
       are on screen at once and a button that teleports between them as you
       scroll is worse than two that agree.

       AND THEY CANNOT DISAGREE. It is not a copy of the behaviour: it is a
       real submit button naming the same form through `form=`, so the browser
       submits the same inputs whichever one is pressed. The only state it
       carries is `disabled`, set beside elAtc's on the same line below.

       Built once, lazily, and re-appended on every render — elNav is emptied
       each time, so the element survives but its place in the DOM does not.

       NO NOTE UNDER IT, by design. The row has no width for a sentence, and
       a disabled button in the place Continue has occupied all the way down
       the flow already says what it means. The note stays on the form's own
       button, under the recap, where there is room for it. */
    var elAtcTwin = null;
    function navAtc(){
      if(!elAtcTwin){
        /* The theme's class too, so the house spinner and the added state
           apply to it exactly as they do to the real one. */
        elAtcTwin = el('button','mcfg__atc add-to-cart-button');
        elAtcTwin.type = 'button';
        elAtcTwin.addEventListener('click', submitCart);
      }
      setAtcLabel(elAtcTwin, STR.addToCart);
      return elAtcTwin;
    }

    /* ─── request instead of an order ─── */
    var REQ_SENT = !!root.querySelector('[data-req-sent]');
    var elReqErr = root.querySelector('[data-req-error]');
    var elReqBtn = null;
    function reqButton(){
      if(!elReqBtn){
        elReqBtn = el('button','mcfg__atc');
        elReqBtn.type = 'button';
        elReqBtn.addEventListener('click', submitRequest);
        setAtcLabel(elReqBtn, STR.reqSend);
      }
      elReqBtn.disabled = !reqReady();
      return elReqBtn;
    }
    /* The request email, in Italian for the office whatever the storefront
       language. Labels come from CFG.reqMail (BLOCK 1). */
    function reqMailText(){
      var L = CFG.reqMail || {}, out = [];
      function line(k, v){ if(v != null && v !== '') out.push((L[k] || k) + ': ' + v); }
      function val(v, u){ var n = parseFloat(v); return (isFinite(n) && n > 0) ? round1(n) + ' ' + u : ''; }
      var st = contactStop();
      if(st) line('reason', L[st] || st);
      var c = S.color ? colorByCode(S.color) : null;
      if(c) line('color', c.name + (c.code ? ' (' + c.code + ')' : ''));
      if(visible('meas')){
        line(axisKey(), val(S.meas[axisKey()], 'cm'));
        line('weight',  val(S.meas.weight, 'kg'));
        line('height',  val(S.meas.height, 'cm'));
      }
      fitEntries().forEach(function(a){
        var k = (a.key === 'bodyLen') ? (axisKey() === 'hips' ? 'lenLeg' : 'lenBody') : a.key;
        line(k, val(a.cm, 'cm'));
      });
      if(persOn()) line('pers', (persWanted() && persComplete()) ? persVisibleLabel() : L.persNone);
      return out.join('\n');
    }
    /* Shopify's contact form, posted normally so its captcha can run. */
    function submitRequest(){
      /* Found through its own input: Shopify's form tag may not print data-req-form. */
      var n0 = root.querySelector('[data-req="name"]'), f = n0 && n0.form;
      if(!f || !reqReady()) return;
      function set(k, v){
        var n = f.querySelector('[data-req="' + k + '"]');
        if(n) n.value = (v == null ? '' : String(v));
      }
      set('name',    String(S.req.name).trim());
      set('email',   String(S.req.email).trim());
      set('body',    String(S.req.note).trim());
      set('model',   styleName(CFG.title) + ' (' + CFG.handle + ')');
      set('summary', reqMailText());
      set('link',    window.location.origin + linkTo(CFG.handle));
      elReqBtn.disabled = true;
      if(f.requestSubmit) f.requestSubmit(); else f.submit();
    }
    /* Shopify reloads the page after a sent request WITHOUT the query string,
       so nothing configured survives: show only the confirmation, laid out
       like the landing page (.mcfg--sent hides the rail and the photo). */
    var sentTopDone = false;
    function renderSent(){
      /* Shopify returns to /contact#<form id>, so the browser jumps to the
         form at the foot of the page. Drop the hash and go back to the top. */
      if(!sentTopDone){
        sentTopDone = true;
        var top = function(){ try { window.scrollTo(0, 0); } catch(e){} };
        if(window.location.hash && window.history && window.history.replaceState)
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
        top();
        window.addEventListener('load', top);
      }
      root.classList.add('mcfg--sent');
      if(elCart) elCart.hidden = true;
      elQ.textContent = STR.reqSentTitle || '';
      elNav.innerHTML = '';
      if(STR.reqSentBack && CFG.collectionUrl){
        var back = el('button','mcfg__fine', STR.reqSentBack); back.type = 'button';
        back.addEventListener('click', function(){ window.location.href = CFG.collectionUrl; });
        elNav.appendChild(back);
      }
      if(elHead) elHead.innerHTML = '';
      elBody.innerHTML = '';
      elBody.setAttribute('data-step', '');
      elBody.appendChild(el('div','mcfg__lede mcfg__notice', STR.reqSent));
    }
    var elScaffold= $('[data-scaffold]'),   elState  = $('[data-state]');
    var elTerms   = $('[data-terms]');
    var elDlv     = $('.mcfg__dlv');
    /* Under the price on a request, in the delivery line's style. */
    var elFrom    = null;
    if(elPrice){
      elFrom = el('div','mcfg__dlv'); elFrom.hidden = true;
      elPrice.parentNode.insertBefore(elFrom, elPrice.nextSibling);
    }
    /* Two of them: the theme badge for narrow, the plain line for wide. Only
       one is ever displayed — that is CSS — so both are raised together. */
    var elFitBadges = root.querySelectorAll('[data-fit-badge]');
    function showFitBadge(on){
      for(var i = 0; i < elFitBadges.length; i++) elFitBadges[i].hidden = !on;
    }

    /* The standing notice. Written once: it never changes with the choices.

       There used to be two, and the other one promised that nothing went into
       production before somebody rang to check the measurements. That promise
       has been withdrawn, so the sentence had to go with it — an unkept
       promise on the page is worse than no promise. What is left now carries
       the whole weight: a piece cut to these numbers cannot be taken back, and
       nothing between this form and the knitting machine will question them. */
    /* ONE PARAGRAPH, not two. They are a single thought — the piece cannot
       come back, and here is how closely it will match what you asked for —
       and as separate <p>s they read as two unrelated warnings. */
    var elTermsP = el('p');
    elTermsP.appendChild(document.createTextNode(STR.termsReturns + ' '));
    if(elTerms) elTerms.appendChild(elTermsP);
    /* The production tolerance. It is the companion the no-returns line
       needs: that one says the piece cannot come back, and this one says how
       exactly it will match the numbers.

       EMPTY HERE, filled in go(), because it carries a figure and that figure
       is in whatever unit the switch is showing. Written once at boot it said
       centimetres to somebody working in inches. */
    var elTol = el('span');
    elTermsP.appendChild(elTol);

    /* ─────────── main photo / styling photos ───────────
       The masks are cut for the FIRST image only, so no styling shot is ever
       tinted. Switching to one drops the canvas and raises the badge;
       switching back restores whatever the colour step had painted. That is
       the whole rule, and it does not change with the number of photos: there
       is the garment, which the colour engine owns, and there are styling
       shots, which it does not.

       VIEWS is built from the elements BLOCK 2 actually drew, so it is
       ['main'] on a product with one photo, ['main','fit'] on most, and
       ['main','fit','fit2'] on the few with three. Everything that steps
       between photos — the thumbnails, the swipe, the colour step sending you
       back to the garment — walks THIS list, so none of them has to know how
       many there are, and a fourth photo one day is one more entry here and
       one more block in BLOCK 2. */
    var FIT_EL = { fit: $('[data-fit]'), fit2: $('[data-fit2]') };
    var VIEWS  = ['main'].concat(['fit','fit2'].filter(function(k){ return !!FIT_EL[k]; }));

    function setView(v){
      /* A name that is not on this product falls back to the garment rather
         than blanking the stage — the only ways in are a thumbnail that
         exists and this function itself, but the stage is the one thing on
         the page that must never end up showing nothing. */
      if(VIEWS.indexOf(v) < 0) v = 'main';
      S.view = v;
      var thumbs = root.querySelectorAll('[data-view]');
      for(var i = 0; i < thumbs.length; i++)
        thumbs[i].setAttribute('aria-pressed', thumbs[i].getAttribute('data-view') === v ? 'true' : 'false');
      /* One photo: there is nothing to switch to and nothing to switch back
         from, so the canvas and the poster are left entirely to paint() and
         go(). This is the old `if(!elFit) return`, unchanged in effect. */
      if(VIEWS.length < 2) return;
      for(var k in FIT_EL) if(FIT_EL[k]) FIT_EL[k].hidden = (k !== v);
      if(!cv || !poster) return;
      if(v !== 'main'){
        showFitBadge(true);
        cv.hidden = true;
        poster.style.visibility = 'hidden';
      } else {
        showFitBadge(false);
        if(hasRendered){ cv.hidden = false; poster.style.visibility = 'hidden'; }
        else { cv.hidden = true; poster.style.visibility = 'visible'; }
      }
    }
    (function(){
      var thumbs = root.querySelectorAll('[data-view]');
      for(var i = 0; i < thumbs.length; i++){
        (function(b){
          b.addEventListener('click', function(){ setView(b.getAttribute('data-view')); go(); });
        })(thumbs[i]);
      }
    })();

    /* Swipe between the photos. One photo per flick, along VIEWS, and it
       STOPS at both ends rather than wrapping: a loop has no edge, and with
       three photos you cannot tell by feel whether a flick went forward or
       all the way back round. The thumbnails are the random-access control;
       this is the nudge.

       THREE input kinds, because "swipe" means three different things:
         · pointer events cover finger, pen AND mouse drag in one API, so a
           phone and a trackpad drag take the same path. touchstart/touchend
           alone fired on a phone and NEVER on a desktop, which is why this
           did nothing on the Magic Mouse.
         · a horizontal WHEEL is what a Magic Mouse and a trackpad two-finger
           swipe actually send — no pointer is ever down, so no drag handler
           could have seen it. It arrives as many small deltas, so they are
           added up and the gesture locks for half a second once it fires,
           or one flick would run through both photos and back.
       A short drag, or a mostly-vertical one, is the page being scrolled. */
    (function(){
      if(VIEWS.length < 2) return;
      var stage = $('.mcfg__stage');
      if(!stage) return;

      var x0 = null, y0 = null;
      function swipe(dx){
        var i = VIEWS.indexOf(S.view) + (dx < 0 ? 1 : -1);
        if(i < 0 || i >= VIEWS.length) return;   /* at an end: nothing to do */
        setView(VIEWS[i]); go();
      }

      if(window.PointerEvent){
        stage.addEventListener('pointerdown', function(e){
          x0 = e.clientX; y0 = e.clientY;
        });
        stage.addEventListener('pointerup', function(e){
          if(x0 === null) return;
          var dx = e.clientX - x0, dy = e.clientY - y0;
          x0 = null;
          if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          swipe(dx);
        });
        stage.addEventListener('pointercancel', function(){ x0 = null; });
      } else {
        stage.addEventListener('touchstart', function(e){
          var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY;
        }, { passive:true });
        stage.addEventListener('touchend', function(e){
          if(x0 === null) return;
          var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
          x0 = null;
          if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          swipe(dx);
        }, { passive:true });
      }

      var acc = 0, lock = 0, decay;
      stage.addEventListener('wheel', function(e){
        var now = Date.now();
        if(now < lock) return;
        /* A vertical wheel is the page scrolling; leave it alone. */
        if(Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        acc += e.deltaX;
        clearTimeout(decay);
        decay = setTimeout(function(){ acc = 0; }, 200);
        if(Math.abs(acc) < 60) return;
        lock = now + 500;
        var dx = acc; acc = 0;
        /* deltaX is positive when the content should move LEFT, which is the
           same direction a finger swiping left means. */
        swipe(-dx);
      }, { passive:true });
    })();

    /* THE GARMENT'S OWN NAME, not "La tua selezione". The name was already
       the first line of the summary underneath, so the heading was spending a
       line to say something the next line said better. What follows it is the
       list of choices, and a heading that names the thing they are choices
       ABOUT is the more useful of the two. STR.yourChoice is now unused. */
    /* Through styleName() as well, and it has to be: the pinned row two
       inches away is stripped, so leaving the prefix here printed the
       programme's name once and the style's name once, about the same
       garment, side by side. */
    if(elSelK) elSelK.textContent = styleName(CFG.title);
    setAtcLabel(elAtc, STR.addToCart);
    /* The real button takes the same path as its twin — see submitCart(). */
    if(elAtc) elAtc.addEventListener('click', submitCart);

    function go(keepFocus){
      if(REQ_SENT){ renderSent(); return; }
      var focus = document.activeElement && document.activeElement.id;
      /* WHERE THE CARET WAS, 02/10/2026. Captured here because the rebuild a
         few lines down destroys the element it belongs to.

         It is new because it only became POSSIBLE today: setSelectionRange
         throws on an <input type=number>, so the restore below has always
         been a no-op on these fields, swallowed by its own try/catch. The
         boxes are text now (see numField) and it works — which means that
         without this it would start actively forcing the caret to the end on
         every keystroke, and correcting the middle of "124" to "104" would
         become impossible.

         Read defensively: selectionStart is null on an input type that does
         not support it, and reading it can still throw on an old engine. */
      var caret = null;
      try {
        var fa = document.activeElement;
        if(fa && fa.selectionStart != null)
          caret = [fa.selectionStart, fa.selectionEnd];
      } catch(e){}

      /* A tier or a size that this product does not offer cannot survive the
         jump from another product. Drop it rather than render it broken. */
      if(S.tier && !variantFor(S.tier)) S.tier = null;
      /* AND THE FLAG GOES WITH IT. A size dropped on arrival at another
         product was never chosen HERE, so leaving sizePicked set would stop
         the new product ever suggesting one. */
      if(S.size && availableSizes().indexOf(S.size) < 0){ S.size = null; S.sizePicked = false; }
      /* Carried in from another product or another gender: a category nothing
         is filed under would silently empty the list. */
      if(S.garment && S.list && !pool('garment').some(function(q){ return garmentOf(q) === S.garment; }))
        S.garment = null;

      /* ── THE MEASUREMENT DECIDES WHAT MAY BE ASKED ──
         A tier the measurement rules out cannot survive — not from a funnel,
         not from a link, not from having been chosen before the customer
         typed a different chest. It is dropped, and if exactly one thing is
         left it is selected outright: with one answer there is no question,
         and visible('tier') will not draw the step at all.

         That is where "we go forward to New size on our own" happens. Nobody
         is asked whether they would like a size that does not exist; they are
         told which one they are getting and the flow moves on. */
      (function(){
        var allow = allowedTiers();
        if(S.tier && allow.indexOf(S.tier) < 0) S.tier = null;
        if(!S.tier && allow.length === 1) S.tier = allow[0];
      })();
      /* The size we worked out, put in the picker for them — and KEPT in step
         with the measurement for as long as it is only a suggestion.

         It used to run `if(!S.size)`, i.e. once, which is what let a stale
         3XL survive a change of chest. Now it runs on every render until
         somebody clicks a tile, and stops the moment they do.

         NULL WHERE NOTHING RESOLVES, rather than leaving the last answer
         standing: past the last rung there is no suggestion to make, and a
         size left over from a measurement that no longer resolves is exactly
         the thing this is here to prevent. outcome() stops at 'oversize'
         there anyway, so nothing is priced off the empty value. */
      if((S.tier === 'COL' || S.tier === 'ADJ') && !S.sizePicked){
        var hitG = sizeHit();
        S.size = (hitG && availableSizes().indexOf(hitG.size) >= 0) ? hitG.size : null;
      }
      /* Round two is NOT dropped on arrival, and that is deliberate — it is
         the one rule the tier and the size do not share. An arm is 62 cm long
         on a gilet too; it is simply not asked about there, and fitEntries()
         sees to it that nothing unasked is ever posted. Wiping it would mean
         browsing to a sleeveless model and back cost the customer a
         measurement they had already given us. */
      /* A dimension is a number against a standard. Land on a product with a
         different standard — or none — and it goes with it. Whatever survives
         is clamped: the limit is a house rule, and a URL can say anything. */
      (function(){
        var std = dimStd();
        DIM_KEYS.forEach(function(k){
          /* NOT PREFILLED, 29/09/2026 — the same treatment the fit boxes get,
             and for the same reason.

             They used to open holding the standard, so somebody who wanted a
             longer scarf edited one number and left the other alone. That
             reads well and it teaches the wrong thing: a box with a figure in
             it, in the input's own ink, is a figure somebody entered. On this
             step every filled box is a REQUEST and a request is made to
             order, so the one state that must be unmistakable — "leave this
             as you make it" — looked identical to a request for the standard.

             Empty, with the standard greyed out behind it, says both at once:
             what you get if you type nothing, and that you have not typed it.
             It is also simply what the fit step does two screens earlier, and
             the two are the same question about different pieces.

             NOTHING IS LOST TO PRODUCTION. renderCart() fills a blank with
             the standard when the other axis moved, so the rectangle posted
             is still whole — see there. */
          /* NOT CLAMPED, 30/09/2026 — see DIM_RANGE. A figure past the house
             limit is a real request that we cannot price, and outcome() says
             so; silently moving it to the nearest figure we CAN price is the
             one thing that must not happen on a form nobody checks by hand.

             Dropped only where there is nothing to measure against, which is
             a product with no standard — the same rule as before. */
          if(!S.dim[k]) return;
          var n = parseFloat(S.dim[k]);
          if(!std || !isFinite(n) || n <= 0){ S.dim[k] = ''; S.typedDim[k] = ''; }
        });
      })();

      /* Personalisation carried in from another product: an option the garment
         you landed on does not offer, a font it does not cut, a position it
         cannot embroider. Dropped rather than posted as something we do not
         make. Whatever is left with ONE possible answer is chosen outright,
         which is what makes the step two controls rather than five. */
      (function(){
        /* No option on this garment: back to unanswered rather than to
           "no", so landing on one that DOES have an option asks the question
           instead of assuming it was declined on the previous product. It
           makes no difference while there is no option — persComplete()
           returns true before it ever reads this — but it is the honest
           value to hold. */
        if(!pers()){ S.pers = { on:null, text:'', font:'', color:'', pos:'' }; return; }
        var fs = persFonts(), ps = persPositions();
        if(S.pers.font && fs.indexOf(S.pers.font) < 0) S.pers.font = '';
        if(S.pers.pos  && ps.indexOf(S.pers.pos)  < 0) S.pers.pos  = '';
        if(!persFree()) S.pers.color = '';
        else if(S.pers.color && !persSwatches().some(function(c){ return c.hex === S.pers.color; }))
          S.pers.color = '';
        if(!S.pers.font && fs.length === 1) S.pers.font = fs[0];
        if(!S.pers.pos  && ps.length === 1) S.pers.pos  = ps[0];
        var mx = pers().maxChars || 10;
        if(S.pers.text && S.pers.text.length > mx) S.pers.text = S.pers.text.slice(0, mx);
      })();

      var o = outcome();

      /* rail: the tolerance, in the unit on screen */
      elTol.textContent = t(STR.termsTolerance, { v: tolText() });

      /* rail: price */
      var shown = (o.cents != null) ? o.cents : fromCents();
      var asking = requestMode();
      var askCents = asking ? reqFromCents() : null;
      if(elPrice) elPrice.textContent = asking
        ? (askCents != null ? money(askCents) : '\u00a0') : money(shown);
      if(elFrom){
        elFrom.textContent = asking ? (STR.reqPriceNote || '') : '';
        elFrom.hidden = !asking;
      }
      /* A request promises nothing: no delivery time, no terms. */
      if(elDlv)   elDlv.hidden   = asking;
      if(elTerms) elTerms.hidden = asking;

      /* rail: running summary */
      /* The title is the HEADING now, so the list starts at the choices. */
      var lines = [];
      /* o.tier, not S.tier: the one being charged. They differ exactly when
         outcome() has re-priced the line — down to ADJ on a size we stock, or
         up to STG on an alteration past the house limit — and the recap has
         to say what is being bought, not what was clicked. */
      /* ALWAYS, now that the chips are gone. It used to be `!onFunnel`,
         because on a funnel arrival the tier already sat in the criteria
         above — so with those removed a route-1 visitor read a summary that
         never named what they were buying. */
      if(o.tier && STR.tiers[o.tier]) lines.push(STR.tiers[o.tier].label);
      /* The graded measurement, as soon as there is one. It is the first thing
         asked now, so it is the first thing there is to read back.

         ONLY WHERE IT WAS ASKED, 30/09/2026. The measurements travel between
         products on purpose — an arm is the same length on the next garment —
         so landing on a wrap after configuring a sweater carried a chest with
         it. visible('meas') is false on an accessory, so the step is never
         drawn, but this line read S.meas directly and printed "Torace 166 cm"
         in the recap of a scarf: a measurement nobody was asked for, about a
         piece it means nothing for. Remembered, not shown. */
      if(visible('meas') && bodyValue()){
        lines.push(STR.meas[axisKey()] + ' ' +
                   fromCanonical(axisKey(), bodyValue()) + ' ' + unitLabel(axisKey()));
      }
      /* ONE size line, always o.size: the one being charged for and made.
         On New size that is the resolved rung, on the other tiers it is
         whatever is selected — which starts as the resolved rung. There used
         to be two lines here, a remembered one and a resolved one, and they
         could disagree. They cannot now, because there is only one. */
      if(o.size && !o.stop) lines.push(t(STR.sizeIs, { v:o.size }));
      if(S.color){
        var c0 = colorByCode(S.color);
        if(c0) lines.push(c0.name);
      }
      /* WHAT THE PIECE WILL MEASURE, not what was typed. An axis left alone
         still has an answer — our standard — and the recap says it, because a
         summary that mentions the sleeves only when they were changed leaves
         somebody who changed nothing wondering whether they were asked. */
      /* EVERY axis the step asked about, standard ones included — see
         fitReadback(). The cart still posts only what was changed. */
      fitReadback().forEach(function(ln){ lines.push(ln); });
      dimEntries().forEach(function(a){
        lines.push(STR.dim[a.key] + ' ' +
                   fromCanonical(a.key, a.cm) + ' ' + unitLabel(a.key));
      });
      /* It reads back as what will be MADE, not as a list of keys: the text
         first, because that is the thing they will look at. Not "stitched" —
         an intarsio is knitted in, not sewn on. */
      if(persWanted()){
        var pl = [pers().label, '“' + String(S.pers.text).trim() + '”'];
        if(persFonts().length > 1 && S.pers.font) pl.push(persFontLabel(S.pers.font));
        if(persFree() && S.pers.color) pl.push(persColorLabel(S.pers.color));
        else if(persPaired()) pl.push(persPaired());
        if(persPositions().length > 1 && S.pers.pos) pl.push(persPosLabel(S.pers.pos));
        lines.push(pl.join(' · '));
      }
      /* A REAL LIST, not lines separated by <br>. These are items — one per
         choice made — and marking them up as items is what lets them be
         bulleted, indented or spaced from the stylesheet alone. */
      elSummary.textContent = '';
      var ul = el('ul','mcfg__sellist');
      lines.forEach(function(ln){ ul.appendChild(el('li', null, ln)); });
      elSummary.appendChild(ul);

      /* ─── the way back and the way forward ───
         THE TAB STRIP IS GONE, 28/09/2026. It let you jump to any step you
         had earned, which meant it also had to say which ones you had not —
         a disabled tab, a rule about what "earned" meant, and a row that grew
         a second line on a narrow screen. The flow is a line and it is now
         walked like one.

         Both buttons live on the question's own row, so the question and the
         way out of it are read in one glance instead of two. */
      var steps = activeSteps();
      if(!S.active || steps.indexOf(S.active) < 0) S.active = steps.length ? steps[0] : null;
      var at = steps.indexOf(S.active);
      var atLast = steps.length > 0 && at === steps.length - 1;
      elNav.innerHTML = '';

      /* BACK IS NEVER DRAWN ON THE FIRST STEP — there is nothing behind it —
         and it is never disabled anywhere else: every step behind you is
         answered by definition, and changing your mind is the whole reason
         to offer it. */
      if(at > 0){
        var back = el('button','mcfg__back', STR.back); back.type = 'button';
        back.addEventListener('click', function(){
          var i = steps.indexOf(S.active);
          if(i > 0){ S.active = steps[i - 1]; go(); }
        });
        elNav.appendChild(back);
      }

      /* ON THE LAST STEP THERE IS NO CONTINUE AT ALL: Add to cart takes its
         place in the row, at EVERY width, and renderCart() puts it there.

         WHICH BUTTON depends on the layout, and only on where the form is:
         side by side the form is not drawn at all, so the REAL button is
         moved into the row; stacked, the form is on screen under the recap
         with its own button, so the row gets a twin — see navAtc(). Both are
         submit buttons of the same form and share one disabled state, so
         neither arrangement can produce two buttons that disagree.

         Either way the row carries a real button on the last step, so there
         is nothing here to reserve space for. */
      var navCart = atLast;

      /* It advances, so it says so. */
      var fine = el('button','mcfg__fine', STR.done); fine.type = 'button';
      fine.addEventListener('click', function(){
        var i = steps.indexOf(S.active);
        if(i > -1 && i < steps.length - 1){ S.active = steps[i + 1]; go(); }
      });
      /* On the last step there is nothing to advance to, so the button is not
         drawn — and nothing has to hold its place, because Add to cart stands
         exactly where it stood. It used to be kept as an invisible
         placeholder on a narrow screen, back when the row ended empty there;
         removing it from the flow shrank the row and everything below jumped
         up as you reached the end. There is a real button in it now. */
      if(navCart){
        /* Nothing to draw: a cart button is about to be appended here in its
           place, and it is a real button rather than a placeholder, so the
           row needs no reserved space. */
      } else if(S.active && !stepAnswered(S.active)){
        /* Still VISIBLE — there is a next step and hiding the button would
           make that a secret — but not usable until the question on screen
           has an answer. With the tabs gone this is the ONLY guard left on
           moving forward, where it used to be one of two. */
        fine.disabled = true;
        elNav.appendChild(fine);
      } else {
        elNav.appendChild(fine);
      }

      /* step */
      /* THE QUESTION CARRIES THE FIGURE. It replaces the count that used to
         sit beside it, and it reads better for the same words: "Scegli fra 28
         colori" is a question, where "Colore — 28 colori" was a heading with a
         tally stapled to it.

         Every question gets both placeholders whether it uses them or not, so
         a translator can put either in any string without a change here. A
         string with no {n} or {v} simply ignores them. */
      /* The colour question names a COUNT of colours, so it is the one
         question with a singular twin. Everything else either names no
         number or names a size label. */
      elQ.textContent = '';
      if(S.active) elQ.appendChild(stepTitleNodes(S.active));
      elBody.innerHTML    = '';
      /* Which step is in the scroller. Only the two long ones actually scroll —
         see the CSS. A short step in an overflow box still rubber-bands, and
         the whole panel springs for no reason. */
      elBody.setAttribute('data-step', S.active || '');
      /* The head is emptied on every render and only refilled by a step that
         wants it, so a step without one leaves no orphan behind. */
      if(elHead) elHead.innerHTML = '';
      var stepBox = S.active ? body(S.active, elHead) : el('div','mcfg__none', STR.noStep);
      elBody.appendChild(stepBox);
      /* AFTER THE APPEND, both of them. qLedeInto may put a lede BESIDE the
         step rather than inside it — see there — which needs a parent; and
         the fold has no place on the page to measure against until it is in
         the document. */
      if(S.active) qLedeInto(stepBox, S.active);
      sizeFold();

      /* add to cart */
      renderCart(o, atLast);

      /* Stacked, the form goes under the recap: you read back what you chose
         and the button is the next thing your thumb reaches. Side by side it
         belongs under the choices, where it has been all along. The form is
         moved whole, so the hidden inputs and the id travel with it. */
      var host = oneCol() ? elRail : elOpts;
      if(host && elCart && elCart.parentNode !== host) host.appendChild(elCart);

      /* stage: back to the poster whenever there is no colour yet */
      if(poster && cv && S.view === 'main' && !S.color && !hasRendered){
        poster.style.visibility = 'visible';
        cv.hidden = true;
      }
      if(elThumb && CFG.thumb) elThumb.src = CFG.thumb;

      /* The colour name belongs to the garment, not to the styling shot, and
         an empty plate in the corner is just a white box. Both conditions are
         checked here because every path that changes either one ends in go(). */
      /* ANY styling shot, not just the second image: the colour name names
         the garment being configured, and none of the styling shots is it. */
      /* capnote FIRST, and that is not belt-and-braces — it is the bug.
         02/10/2026: the two lines below were guarded and this one was not,
         so in browse mode, where there is no stage and no colour name to
         put in it, `capnote.textContent` threw on EVERY render and took the
         whole of go() with it. A guard underneath a dereference guards
         nothing. */
      var hideColor = (S.view !== 'main') || !capnote || !capnote.textContent;
      if(capnote)  capnote.hidden  = hideColor;
      if(colbadge) colbadge.hidden = hideColor;


      if(DEBUG) renderState(o);
      syncUrl();

      if(keepFocus && focus){
        var f = document.getElementById(focus);
        if(f){
          /* preventScroll, because focus() scrolls the element into view by
             default — and this runs on EVERY keystroke. On a panel that is
             already its own scroller that was a second, smaller jump on top of
             the image one. Wrapped: the option is ignored by older engines,
             which then behave exactly as before rather than throwing. */
          try { f.focus({ preventScroll:true }); } catch(e){ f.focus(); }
          /* Back where it was, falling back to the end of the value — which
             is what this line did for every field that supported it, and what
             the browser does by itself when .value is assigned.

             Clamped to the length, because the value on screen may be shorter
             than the one the caret was measured against. That cannot happen on
             a keystroke, where the field echoes exactly what was typed, but it
             can on any other render that reaches here. */
          var selA = caret ? Math.min(caret[0], f.value.length) : f.value.length;
          var selB = caret ? Math.min(caret[1], f.value.length) : f.value.length;
          try { f.setSelectionRange(selA, selB); } catch(e){}
        }
      }
    }

    /* ─────────── add to cart ───────────
       It lives on the LAST step and nowhere else. Showing it as soon as the
       configuration happened to be complete meant it followed you backwards:
       pick a colour, go back to change the model, and there it still was,
       offering to buy a configuration you were in the middle of rethinking.
       Putting it at the end makes walking to the end the confirmation — you
       pass back through every choice on the way.

       A silent downgrade posts the ADJ variant, which is Rule 1 working end to
       end: the customer never sees the word, the cart never sees STG. */
    function ready(o){
      if(o.stop || o.cents == null) return false;
      /* ALL THREE MEASUREMENTS, not just the graded one. outcome() already
         stops at 'nochest' without the axis, so this is what adds the weight
         and the height — and it is the same measComplete() the Continue
         button asks, so a step that will not let you past cannot leave the
         cart button live. */
      if(!measComplete()) return false;
      if(!S.color) return false;
      if(visible('size') && !S.size) return false;
      /* Dimensions are the thing being bought on an accessory, so at least one
         of them has to differ from the standard: "New dimensions" that are the
         catalogue's own dimensions is a made-to-order charge for a piece we
         already stock. Round two on a garment stays optional, and an
         unanswered box means the standard. */
      if(visible('dim') && !dimEntries().length) return false;
      /* The garment's half of the same rule — see fitAnswered(). An ADJ line
         that altered nothing is the standard piece at the altered price. */
      if(!fitAnswered()) return false;
      /* Personalisation half answered is the one thing that can be INCOMPLETE
         without being empty: text typed but no colour picked. Never asked for
         at all is fine and costs nothing. */
      if(!persComplete()) return false;
      return true;
    }
    /* The made-to-order spec as one JSON blob, for the cart property. */
    function studioSpec(o){
      var spec = {};
      function put(k, v){
        if(v == null) return;
        v = String(v);
        if(v !== '') spec[k] = v;
      }
      put('tier',       o.tier);
      put('size',       o.size || (CFG.oneSize ? 'U' : ''));
      put('color_code', S.color);
      /* Audit only, and only when there is a price. */
      if(o.cents != null){
        put('uplift_pct',  o.upliftPct);
        put('price_shown', String(o.cents / 100));
      }
      put('axis',       axisKey());
      if(visible('meas')) MEAS_KEYS.forEach(function(k){ put(k, S.meas[k]); });
      var fitPost = {};
      fitEntries().forEach(function(a){ fitPost[a.key] = String(round1(a.cm)); });
      put('sleeve_length', fitPost.sleeveLen);
      put('body_length',   fitPost.bodyLen);
      /* Both dimensions as soon as one moved; a blank one means the standard. */
      var moved = dimEntries().length > 0, dstd = dimStd();
      DIM_KEYS.forEach(function(k){
        if(!moved) return;
        var v = S.dim[k];
        if(!v && dstd) v = String(dstd[k]);
        put('dim_' + k, v);
      });
      return spec;
    }

    function renderCart(o, atLast){
      /* NO FORM, NOTHING TO DO — browse mode. This also quietly answers a
         question it would otherwise have had to: with one step, atLast is
         true, so go() draws no Continue and renderCart would have put an Add
         to bag in the nav row. There is nothing to add to a bag from a list
         of styles, and returning here leaves the row empty, which is right. */
      if(!elCart || !elAtc) return;
      if(requestMode()){
        elCart.hidden = true;
        if(atLast) elNav.appendChild(reqButton());
        return;
      }
      var ok = ready(o);
      /* Stacked, the button is always there. It is the last thing in the last
         panel — under the recap, at the bottom of the page — so it is not in
         the way of anything and you never have to walk to the last step to
         find out it exists. Reaching it is already a scroll to the end, which
         is the confirmation the desktop layout gets from the tab row.

         Side by side it stays on the LAST STEP only: there it sits in the
         options column, beside whatever you are choosing, and showing it early
         meant it followed you backwards — go back to change the model and it
         was still offering to buy a configuration you were rethinking.

         Either way it is disabled until the choice is complete, and says why. */
      /* WHERE THE BUTTON LIVES. On the LAST STEP the nav row carries one at
         every width, standing exactly where Continue stood — but which
         button it is depends on where the form is.

         Side by side the form at the foot of the column is not drawn at all,
         so the REAL button is moved into the row and there is only ever one.
         Stacked, the form IS on screen, under the recap at the end of the
         page, so moving its button up would leave the recap without one; the
         row gets a twin instead (navAtc()) and both are live. Two, because on
         a narrow screen both places are on screen as you scroll and a single
         button that jumps between them is worse than two that agree.

         Everywhere else — every step that is not the last — the form keeps
         the button, as it always did.

         A submit button may sit OUTSIDE its form as long as it names it, so
         the button is simply moved and `form` is set once. The form itself
         never moves: it holds the hidden inputs, and a hidden form still
         submits every one of them (only `disabled` fields are skipped).
         Moving the form instead would have dragged eight inputs and the id
         through the DOM on every render. */
      var navCart = atLast && !oneCol();
      if(navCart){
        if(elAtc.parentNode !== elNav) elNav.appendChild(elAtc);
        elCart.hidden = true;
      } else {
        /* Back where it came from: before the note, inside the form. This
           runs on a resize across the breakpoint, so it has to be able to
           undo itself. */
        if(elCartBtns && elAtc.parentNode !== elCartBtns)
          elCartBtns.insertBefore(elAtc, elAtcNote.parentNode === elCartBtns ? elAtcNote : null);
        elCart.hidden = !(atLast || oneCol());
        /* Stacked, the last step carries the SECOND button in the nav row as
           well — the form's own is further down the page, under the recap,
           and both are on screen at once. */
        if(atLast) elNav.appendChild(navAtc());
      }
      ATC_OK = ok;
      paintAtc();
      /* THE NOTE NEVER LEAVES THE FORM, 29/09/2026. It used to be parked
         under the question's row whenever the button moved up there, and it
         was the wrong sentence in the wrong place: a greyed-out button
         standing where Continue has stood all the way down the flow already
         says "not yet", and a line of explanation under a two-button row read
         as an error the visitor had caused.

         So it stays with the form's own button, under the recap, which is the
         one place with width for a sentence. Side by side the form is hidden
         on every step, so the note is simply never seen there; stacked it is
         under the button it describes, which is where it made sense all
         along.

         Only the reason the button is disabled. The standing facts —
         delivery, and that this cannot be returned — are said once, in the
         rail, where they are true on every step; saying them again under the
         button was the same sentence twice on the same screen. */
      elAtcNote.textContent = ok ? '' : STR.atcIncomplete;
      if(!ok) return;

      var c = colorByCode(S.color);
      $('[data-cart-id]').value = o.variantId;
      function setProp(sel, v){ var n = root.querySelector(sel); if(n) n.value = (v == null ? '' : v); }
      var spec = studioSpec(o);
      var sizeStr = o.size || (CFG.oneSize ? 'U' : '');

      /* _size STAYS A PROPERTY OF ITS OWN: the cart transform prices from it,
         keying custom.size_uplift on this exact string, and it is the only
         posted value that changes the price. */
      setProp('[data-prop="size"]',        sizeStr);
      setProp('[data-prop="studio_spec"]', JSON.stringify(spec));
      /* The five keys api/shopify/order.php already reads, in the shape it
         already expects. Blank across the board when none was asked
         for — every one of them empty is how a plain line looks, and the
         truthiness guard on the Octopus side then writes NULL rather than an
         empty object.

         @TODO that guard tests exactly these five. Adding Custom Studio keys
         to the same JSON without extending it would make a measurements-only
         line write NULL. */
      var wantPers = persWanted() && persComplete();
      setProp('[data-prop="pers_type"]',   wantPers ? pers().code : '');
      setProp('[data-prop="pers_input"]',  wantPers ? persText() : '');
      setProp('[data-prop="pers_uplift"]', wantPers ? String(persUplift() / 100) : '');
      setProp('[data-prop="pers_suffix"]', wantPers ? pers().code : '');
      setProp('[data-prop="pers_label"]',  wantPers ? persLabel() : '');
      /* NOT gated on the lettering: this is the whole line now, and a
         made-to-order piece with none still has a size and a colour. */
      setProp('[data-prop="pers_visible"]', visibleLabel(o, c));
    }

    /* ─────────── ?debug=1 ───────────
       The only place the silent downgrade is visible, which is what makes
       Rule 1 testable. Delete with the matching markup block. */
    function renderState(o){
      elScaffold.hidden = false;
      var q = [];
      if(S.who)     q.push('who=' + S.who);
      if(S.garment) q.push('garment=' + S.garment);
      if(S.tier)    q.push('tier=' + S.tier);
      if(S.size)    q.push('size=' + S.size);
      if(S.color)   q.push('col=' + S.color);
      if(bodyValue()) q.push(axisKey() + '=' + bodyValue());
      FIT_KEYS.forEach(function(k){ if(S.meas[k]) q.push(k + '=' + S.meas[k]); });
      DIM_KEYS.forEach(function(k){ if(S.dim[k]) q.push('dim_' + k + '=' + S.dim[k]); });
      if(S.unit !== defaultUnit()) q.push('u=' + S.unit);

      var v = S.tier ? variantFor(S.tier) : null;
      var res = '\n<b>prezzo</b>  variante ' + (v ? v.tier + ' ' + money(v.cents) : '—');
      var why = { notier:'nessuna modifica scelta', nodata:'variante mancante',
                  noranges:'nessun profilo di vestibilità → contattaci',
                  nochest:'misure non inserite — prima domanda',
                  oversize:'OLTRE LA SCALA → contattaci',
                  unpriced:'gradino senza percentuale → contattaci' };
      if(o.stop){
        res += '  →  ' + (why[o.stop] || o.stop);
      } else {
        res += (o.downgraded ? '  ⟵ STG DECLASSATO A ADJ (silenzioso)' : '') +
               (o.upgraded ? '  ⟶ ADJ PROMOSSO A STG (oltre ±' +
                             houseLimit() + 'cm dallo standard)' : '') +
               (o.size ? '  × ' + o.size + ' +' + o.upliftPct + '%' +
                         (o.extrapolated ? ' (gradino estrapolato)' : '') : '') +
               '  =  ' + money(o.cents) +
               (o.raw != null && roundPrice(o.raw) !== Math.round(o.raw)
                  ? '  (grezzo ' + money(Math.round(o.raw)) + ', passo ' + (STEP / 100) + ')'
                  : '');
      }
      elState.innerHTML =
        '<b>URL</b>  /products/' + CFG.handle + (q.length ? '?' + q.join('&') : '') + res +
        '\n<b>profilo</b>  ' + (CFG.ranges ? CFG.ranges.profile + ' su ' + CFG.ranges.axis : 'nessuno') +
        '\n<b>offribili</b>  ' + (allowedTiers().join(' ') || 'nessuno — fuori scala o senza variante') +
        '\n<b>misure 2</b>  ' + (visible('fit')
              ? ((fitAxes().join(' ') || 'nessun asse nella tabella misure') +
                 (fitEntries().length
                    ? '   →  ' + fitEntries().map(function(a){
                        return a.key + ' ' + a.cm + 'cm'; }).join('  ')
                    : '   (nessuna)'))
              : '—') +
        '\n<b>dimensioni</b>  ' + (function(){
              var std = dimStd();
              if(!std) return '—';
              return std.length + '×' + std.width + 'cm   max ±' + houseLimit() + 'cm' +
                     (dimEntries().length
                        ? '   →  ' + dimEntries().map(function(a){
                            return a.key + ' ' + a.cm + 'cm'; }).join('  ')
                        : '   (standard)');
            })() +
        '\n<b>a catalogo</b>  ' + (stockedSizes().join(' ') || '—') +
        '\n<b>sviluppabili</b>  ' + (Object.keys(UPLIFT).join(' ') || '—') +
        '\n<b>varianti</b>  ' + (CFG.variants || []).map(function(v){
              return v.tier + ' ' + money(v.cents);
            }).join('   ') + '   [' + (CFG.currency || '?') + ', passo ' + (STEP / 100) + ']' +
        '\n<b>tier</b>  ' + offeredTiers().join(' ') +
        '\n<b>lista</b>  ' + CFG.listUrl +
          (S.list ? '  (' + S.list.length + ' caricati)' : '  (non ancora caricata)');
    }

    /* ─────────── boot ─────────── */
    var rz, wasNarrow = narrow(), wasOneCol = oneCol();
    window.addEventListener('resize', function(){
      clearTimeout(rz);
      rz = setTimeout(function(){
        /* Either breakpoint changes the shape of the thing: the model list is
           a fold on a phone and a plain list above it, and the cart form sits
           under the recap in one column and under the choices in three. */
        if(narrow() !== wasNarrow || oneCol() !== wasOneCol){
          wasNarrow = narrow(); wasOneCol = oneCol();
          go();
        }
        /* Unconditionally: a resize that does not cross the breakpoint does
           not rebuild the step, and the fold's share of the column has
           changed anyway. */
        sizeFold();
        if(hasRendered) blit();
      }, 150);
    });

    /* A colour carried in from the funnel repaints straight away; one this
       product does not offer is dropped rather than shown as chosen. */
    if(S.color){
      var pre = colorByCode(S.color);
      if(pre) paint(pre); else S.color = null;
    }

    /* WARM THE STYLE PREVIEW, and this is what stops it flashing. The element
       used to be created the first time its step rendered, so opening that tab
       was ALSO the moment the download started — the panel drew, then the
       picture faded in under it.

       Building it here starts the request at boot instead, and the step it
       belongs to is the last one in the flow, so by the time anybody opens it
       the file is decoded and simply appears. Detached from the DOM is fine:
       the browser loads it anyway, and body() only ever moves it in.

       At this point no font is selected yet — go() has not run — so the name
       asked for is the plain one, which is exactly the shot that step opens
       with. fetchPriority low keeps it behind the garment. */
    if(pers()) persImg();

    /* ══════════════════════════════════════════════════════════════════════
       BROWSE MODE — THE LANDING PAGE'S THREE GENDER BUTTONS     01/10/2026
       ══════════════════════════════════════════════════════════════════════

       The Custom Studio landing page is a hero with three buttons sitting
       over this same section with no product behind it. Pressing one has to
       LOOK like a navigation and must not be one: no reload, the hero gone,
       and the model list already standing there filtered to that gender.

       SO THE BUTTONS ARE ORDINARY LINKS TO A HASH:

           <a href="#who=Women">     <a href="#who=Men">
           <a href="#who=Lifestyle">

       That is the whole contract, and it is deliberately the dullest thing
       that could work. They can be built with the theme editor's own button
       block; they are real links, so middle-click, the keyboard and the
       context menu all behave; they need no theme JS; and the browser's own
       Back button undoes the entire gesture for nothing — back to no hash is
       back to the hero.

       A HASH AND NOT A QUERY STRING. `?who=Women` is a page load, and Liquid
       cannot read a query parameter anyway, so the hero could not have hidden
       itself on the way through. A hash changes nothing on the server and
       everything here.

       WHAT IS ON SCREEN IS DECIDED BY ONE CLASS ON <html> — mcfg-studio —
       and by BLOCK 3, which starts the section hidden so nothing flashes on a
       cold landing. This is the only thing that puts that class on or takes
       it off; see html.mcfg-lock for the same arrangement and the same reason
       for it being in one place.

       NOTHING ELSE IN THIS FILE KNOWS ABOUT ANY OF IT. visible() already
       collapses the flow to ['prod'] with no product data, so the steps, the
       filters, the rows and the links are the ones the configurator has
       always drawn. This is a door, not a second implementation.
       ══════════════════════════════════════════════════════════════════════ */
    function studioOpen(on){
      var de = document.documentElement;
      if(on) de.classList.add('mcfg-studio');
      else   de.classList.remove('mcfg-studio');
    }
    function studioIsOpen(){
      return document.documentElement.classList.contains('mcfg-studio');
    }
    /* THE HASH, READ INTO STATE. Two doors — `#who=<gender>` and a bare
       `#studio` — and no hash at all, which is the hero's own state. */
    function readHash(){
      var h = String(window.location.hash || '').replace(/^#/, '');
      var m = /(?:^|&)who=([^&]*)/.exec(h), w = null;
      /* ─── EXACTLY THESE TWO, AND NOTHING ELSE OPENS IT ───
         02/10/2026. It used to open on ANY non-empty hash, which was loose
         in both directions. An ordinary anchor somewhere else on the page —
         #contact, a theme accordion's id — would have opened the studio; and
         it no longer agrees with the inline no-flash script in BLOCK 1,
         which has to make the same decision a beat earlier. The two now run
         the same test, so a cold landing never paints one answer and then
         the other.

         An unrecognised hash is treated as no hash: hero up, nothing
         filtered, which is what a visitor who did not ask for the studio
         should get. */
      if(!(h === 'studio' || m)){
        S.who = null; S.garment = null; S.searched = false;
        studioOpen(false);
        return;
      }
      if(m){
        var raw = m[1];
        try { raw = decodeURIComponent(raw.replace(/\+/g, ' ')); } catch(e){}
        /* Through whoKey(), so a link written in the visitor's own language —
           #who=Donna, #who=Femme — resolves exactly as the dropdown's own
           values do. WHO_ORDER rather than WHO_KEYS: Unisex is a property of
           a product and never a destination, and whoMatches() folds it into
           Women and Men, so a list filtered to it would come back empty. */
        var k = whoKey(String(raw).trim());
        if(WHO_ORDER.indexOf(k) >= 0) w = k;
      }
      /* A GENDER THAT DOES NOT RESOLVE STILL OPENS, with no filter. A button
         somebody mistyped showing all 74 styles is a small wrong; a button
         that visibly does nothing is the kind that gets reported as the whole
         page being broken. */
      S.who = w;
      S.garment = null;
      /* SEARCHING, ALWAYS, and it is not cosmetic. body('prod') draws two
         different shapes off this flag — the model you are on pinned at the
         top with the other seventy-odd folded away, or one flat list of
         results. There is no model to pin here: CFG.handle is empty. Left
         false, the whole catalogue would be sitting inside a closed accordion
         labelled "Other styles (74)", which is not a landing page. */
      S.searched = true;
      studioOpen(true);
    }
    /* ─── THE WAY OUT, AS A HISTORY NAVIGATION ───
       Not a state change dressed up as one. Pressing "Back to Custom Studio"
       has to leave the page in exactly the state a cold landing is in — no
       hash, no gender, hero up — or a refresh would put the list straight
       back and the button would read as not having worked.

       pushState RATHER THAN replaceState, which is the opposite of what
       syncUrl does and for a reason: this is a navigation the visitor asked
       for, so it earns an entry, and Back from the hero then returns to the
       list they left. Going back across it changes the fragment, which fires
       hashchange — the listener below — so the return journey needs nothing
       written for it.

       pushState ITSELF fires nothing, so readHash() and go() are called by
       hand. Without history at all, the hash is cleared the old way: it
       leaves a bare '#' in the address bar and fires hashchange on its own,
       which is untidy and correct.

       THE THEME EDITOR IS THE ONE PLACE IT MUST NOT CLOSE. The section is
       only on screen there because designMode forced it open; letting this
       hide it would make the button look like it had broken the preview. It
       clears the filters there instead, which is what the same control does
       everywhere else. */
    function closeStudio(){
      if(window.Shopify && window.Shopify.designMode){
        S.who = null; S.garment = null; go();
        return;
      }
      if(window.history && window.history.pushState){
        window.history.pushState(null, '',
          window.location.pathname + window.location.search);
      } else {
        window.location.hash = '';
      }
      readHash();
      try { window.scrollTo(0, 0); } catch(e){}
      go();
    }

    if(CFG.browse){
      /* The hero and the configurator are never both up, so the change of
         hash IS the transition. Scrolled to the top through it: the buttons
         may sit at the foot of a tall hero, and landing halfway down a list
         that has just replaced it does not read as having arrived anywhere. */
      window.addEventListener('hashchange', function(){
        readHash();
        try { window.scrollTo(0, 0); } catch(e){}
        go();
      });
      /* Before the boot render below, so the first paint is already right —
         a link opened in a new tab lands on the list, not on the hero. */
      readHash();
      /* THE THEME EDITOR WOULD SEE AN EMPTY SLOT OTHERWISE. The section is
         hidden until a gender is pressed and nobody presses one in the
         editor, so a section that cannot be seen cannot be placed, moved or
         ordered. Opened there with no gender, which is the full list — and
         `searched` with it, or the editor would show the catalogue sitting
         inside a closed fold rather than the list she is laying out. */
      if(window.Shopify && window.Shopify.designMode){
        S.searched = true;
        studioOpen(true);
      }
    }

    go();
  }

  function initAll(scope){
    var r = (scope && scope.querySelectorAll) ? scope : document;
    var n = r.querySelectorAll('[data-mcfg]');
    for(var i = 0; i < n.length; i++) init(n[i]);
  }
  if(document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
